<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row v-if="acceso">
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Auditoría</span>
            <v-spacer></v-spacer>

            <v-btn
              class="mr-2"
              small
              dark
              color="green"
              @click="exportExcel(auditoriasExportables, nombreArchivoAuditorias)"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              v-if="esTabEvaluacionPersonal"
              color="orange"
              dark
              class="mr-2"
              @click="openDialogActivo"
              small
              tile
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>

            <v-btn
              v-if="!esTabEvaluacionPersonal"
              color="deep-purple"
              dark
              class="mr-2"
              @click="openDialogProgramarControlInterno"
              small
              tile
            >
              <v-icon left small>mdi-calendar-plus</v-icon>
              Programar
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <v-card-text>
            <div class="auditoria-tabs-wrap mb-3">
              <v-tabs
                v-model="auditoriaTab"
                class="auditoria-tabs"
                background-color="transparent"
                height="40"
                slider-color="primary"
              >

                <v-tab class="auditoria-tab auditoria-tab--control" active-class="auditoria-tab--active">
                  Control Interno
                </v-tab>
              </v-tabs>
            </div>

            <v-row justify="space-between">
              <v-col v-if="esTabEvaluacionPersonal" cols="12" md="4" lg="3">
                <label>Tipo de Auditoría</label>
                <v-select
                  :items="tiposAuditoria"
                  v-model="filtros.tipoAuditoria"
                  label="Selecciona tipo"
                  item-text="nombre"
                  item-value="nombre"
                  filled
                  dense
                  clearable
                  single-line
                ></v-select>
              </v-col>

              <v-col v-if="esTabEvaluacionPersonal" cols="12" md="4" lg="3">
                <label>Fecha inicio</label>
                <v-text-field
                  label="Fecha de inicio"
                  filled
                  dense
                  v-model="filtros.fechaini"
                  single-line
                  type="date"
                  :max="fechaMaxima"
                ></v-text-field>
              </v-col>

              <v-col v-if="esTabEvaluacionPersonal" cols="12" md="4" lg="3">
                <label>Fecha final</label>
                <v-text-field
                  label="Fecha final"
                  filled
                  dense
                  v-model="filtros.fechafin"
                  single-line
                  type="date"
                  :max="fechaMaxima"
                ></v-text-field>
              </v-col>

              <v-col v-if="!esTabEvaluacionPersonal" cols="12" md="4" lg="3">
                <label>Ciclo</label>
                <v-autocomplete
                  :items="ciclos"
                  v-model="filtros.id_ciclo"
                  label="Selecciona ciclo"
                  item-text="ciclo"
                  item-value="id_ciclo"
                  filled
                  dense
                  clearable
                  single-line
                  no-data-text="No hay datos"
                  @change="onCambioCicloControlInterno"
                ></v-autocomplete>
              </v-col>

              <v-col v-if="!esTabEvaluacionPersonal" cols="12" md="4" lg="3">
                <label>Escuela</label>
                <v-select
                  :items="opcionesEscuelaControlInterno"
                  v-model="filtros.escuela"
                  label="Escuela"
                  filled
                  dense
                  single-line
                  @change="onCambioEscuelaControlInterno"
                ></v-select>
              </v-col>

              <v-col cols="12" md="4" lg="3">
                <label>Selecciona el Plantel</label>
                <v-autocomplete
                  :items="plantelesFiltroControlInterno"
                  v-model="filtros.plantel"
                  label="Plantel"
                  item-text="plantel"
                  item-value="idplantel"
                  filled
                  dense
                  single-line
                  clearable
                  no-data-text="No hay datos"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="4" lg="3">
                <label>Estatus</label>
                <v-select
                  :items="estatusFiltroActivo"
                  v-model="filtros.estatus"
                  label="Estatus"
                  filled
                  dense
                  clearable
                  single-line
                  no-data-text="No hay datos"
                ></v-select>
              </v-col>

              <v-col cols="12" md="4" lg="3">
                <v-text-field
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="filtros.search"
                  label="Buscar"
                ></v-text-field>
              </v-col>
            </v-row>

            <div class="auditoria-dashboard mt-4">
              <template v-if="esTabEvaluacionPersonal">
                <div class="auditoria-dashboard-header">
                  <span class="auditoria-section-title">Reporte Evaluación Personal</span>
                  <template v-if="tarjetasReporteDepartamento.length">
                    <v-chip x-small class="auditoria-chip" color="blue lighten-5" text-color="blue darken-2">
                      Promedio: {{ formatPorcentaje(totalesReporteTarjetas.promedioResultado) }}
                    </v-chip>
                  </template>
                </div>

                <v-row v-if="tarjetasReporteDepartamento.length" dense class="reporte-dashboard-row">
                  <v-col
                    v-for="row in tarjetasReporteDepartamento"
                    :key="row.id_departamento || row.departamento"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                  >
                    <v-card flat class="reporte-dept-card pa-3">
                      <div class="text-body-2 font-weight-bold text-truncate">
                        {{ row.departamento }}
                      </div>
                      <div class="text-caption text--secondary mt-1">Estatus</div>
                      <div class="auditoria-metrics mt-2">
                        <div class="reporte-metric">
                          <span class="text-caption text--secondary">Inicial</span>
                          <span class="reporte-metric-val primary--text">{{ row.conteoInicial }}</span>
                        </div>
                        <div class="reporte-metric">
                          <span class="text-caption text--secondary">Seguimiento</span>
                          <span class="reporte-metric-val orange--text text--darken-2">
                            {{ row.conteoSeguimiento }}
                          </span>
                        </div>
                        <div class="reporte-metric">
                          <span class="text-caption text--secondary">Promedio</span>
                          <span class="reporte-metric-val teal--text text--darken-2">
                            {{ formatPorcentaje(row.promedioResultado) }}
                          </span>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <div
                  v-else
                  class="text-caption text--secondary py-1 d-flex align-center flex-wrap"
                  style="gap: 8px;"
                >
                  Sin datos de reporte.
                  <v-btn color="primary" @click="initialize" x-small text>Actualizar</v-btn>
                </div>
              </template>

              <template v-else>
                <template v-if="filtros.id_ciclo">
                  <div class="auditoria-dashboard-header">
                    <span class="auditoria-section-title">Calificación global por escuela</span>
                    <span class="text-caption text--secondary">Promedio de auditorías cerradas del ciclo</span>
                  </div>
                  <v-row dense class="reporte-dashboard-row mb-2">
                    <v-col
                      v-for="row in promediosEscuelaControlInterno"
                      :key="row.clave"
                      cols="12"
                      sm="4"
                    >
                      <v-card flat class="reporte-dept-card pa-3">
                        <div class="d-flex align-center justify-space-between">
                          <span class="text-body-2 font-weight-bold">{{ row.nombre }}</span>
                          <span
                            class="text-h6 font-weight-bold"
                            :class="row.calificacion == null ? 'grey--text' : 'primary--text'"
                          >
                            {{ row.calificacion == null ? '-' : row.calificacion.toFixed(1) }}
                          </span>
                        </div>
                        <div class="text-caption text--secondary mt-1">
                          {{ row.auditadas }} de {{ row.sucursales }} sucursales auditadas
                          <template v-if="row.puntaje != null"> · {{ formatPorcentaje(row.puntaje) }}</template>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>

                <div class="auditoria-dashboard-header">
                  <span class="auditoria-section-title">Ranking del ciclo</span>
                  <template v-if="rankingTop3ControlInterno.length">
                    <v-chip x-small class="auditoria-chip" color="amber lighten-4" text-color="amber darken-4">
                      Top {{ rankingTop3ControlInterno.length }}
                    </v-chip>
                  </template>
                </div>

                <v-row v-if="rankingTop3ControlInterno.length" dense class="reporte-dashboard-row">
                  <v-col
                    v-for="(row, index) in rankingTop3ControlInterno"
                    :key="row.id_plantel || row.nombrePlantel"
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-card flat class="reporte-dept-card pa-3">
                      <div class="d-flex align-center justify-space-between">
                        <div class="text-body-2 font-weight-bold text-truncate">
                          #{{ index + 1 }} · {{ row.nombrePlantel }}
                        </div>
                        <v-chip
                          x-small
                          dark
                          :color="index === 0 ? 'amber darken-2' : index === 1 ? 'blue-grey' : 'brown'"
                        >
                          {{ formatPorcentaje(row.puntaje) }}
                        </v-chip>
                      </div>
                      <div class="text-caption text--secondary mt-1">
                        Puntaje por criterios cumplidos
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <div
                  v-else
                  class="text-caption text--secondary py-1 d-flex align-center flex-wrap"
                  style="gap: 8px;"
                >
                  <span v-if="!filtros.id_ciclo">Selecciona un ciclo para ver el ranking.</span>
                  <span v-else>Aún no hay sucursales auditadas (cerradas) en este ciclo.</span>
                </div>
              </template>
            </div>

            <div class="auditoria-table-header">
              <span class="auditoria-section-title">{{ tituloTablaActiva }}</span>
              <span class="text-caption text--secondary">
                {{ auditoriasExportables.length }} registros
              </span>
            </div>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headersControlInternoCiclo"
                  :items="sucursalesControlInternoCiclo"
                  item-key="id_plantel"
                  class="auditoria-table elevation-0"
                  :mobile-breakpoint="100"
                  :loading="cargandoControlInternoCiclo"
                  loading-text="Cargando sucursales"
                  dense
                >
                  <template v-slot:header.puntaje="{ header }">
                    {{ header.text }}
                    <v-menu offset-y open-on-hover max-width="420" :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon small color="primary" class="ml-1" v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <v-card class="pa-3 text-body-2">
                        <div class="font-weight-bold mb-1">¿Cómo se calcula?</div>
                        <div>
                          <b>Puntaje</b> = casillas en "Cumple" ÷ casillas evaluables × 100.
                          <b>Calificación</b> = puntaje redondeado ÷ 10. Todas las casillas valen igual.
                        </div>
                        <v-simple-table dense class="mt-2">
                          <tbody>
                            <tr v-for="fila in ponderacionControlInterno" :key="fila.seccion">
                              <td>{{ fila.seccion }}</td>
                              <td class="text-right font-weight-bold text-no-wrap">{{ fila.casillas }}</td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                        <div class="text-caption mt-2">
                          Casilla sin marcar = No cumple. "Ausente", Staff Extra y personal marcado como "No aplica" no cuentan.
                          Retroalimentación, Cierre y Tickets no suman al puntaje.
                        </div>
                      </v-card>
                    </v-menu>
                  </template>

                  <template v-slot:item.puntaje="{ item }">
                    <template v-if="item.tienePuntaje">
                      {{ formatPorcentaje(item.puntaje) }}
                      <div v-if="!item.auditado" class="text-caption grey--text">Parcial (en curso)</div>
                    </template>
                    <span v-else>-</span>
                  </template>

                  <template v-slot:item.calificacion="{ item }">
                    <span v-if="item.tienePuntaje" :class="{ 'font-weight-bold': item.auditado, 'grey--text': !item.auditado }">
                      {{ item.calificacion.toFixed(1) }}
                    </span>
                    <span v-else>-</span>
                  </template>

                  <template v-slot:item.fechaAuditoria="{ item }">
                    {{ item.fechaAuditoria || '-' }}
                  </template>

                  <template v-slot:item.nombreAuditor="{ item }">
                    {{ item.nombreAuditor || '-' }}
                  </template>

                  <template v-slot:item.estatusAuditado="{ item }">
                    <v-chip
                      small
                      dark
                      :color="item.auditado ? 'green' : 'blue-grey'"
                    >{{ item.estatusAuditado }}</v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      v-if="item.auditado || item.auditoria"
                      color="primary"
                      x-small
                      @click="editControlInternoItem(item.auditoria)"
                      class="mr-2"
                      :title="item.auditado ? 'Ver auditoría' : 'Continuar auditoría'"
                    >
                      <v-icon small>mdi-magnify</v-icon>
                    </v-btn>

                    <v-btn
                      v-else
                      color="orange"
                      dark
                      x-small
                      @click="agregarControlInternoDesdeSucursal(item)"
                      class="mr-2"
                    >
                      <v-icon small left>mdi-plus</v-icon>
                      Agregar
                    </v-btn>

                    <v-btn
                      v-if="!item.auditado"
                      color="deep-purple"
                      dark
                      x-small
                      class="mr-2"
                      title="Editar fecha de auditoría y auditor"
                      @click="openDialogEditarProgramacionControlInterno(item)"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn
                      v-if="item.auditoria && canDelete(item.auditoria)"
                      color="error"
                      x-small
                      outlined
                      title="Eliminar auditoría"
                      @click="deleteControlInternoItem(item.auditoria, item.nombrePlantel)"
                      class="ml-6"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:no-data>
                    <div class="py-2">
                      <span v-if="!filtros.id_ciclo" class="text-body-2 text--secondary">
                        Selecciona un ciclo para listar las sucursales.
                      </span>
                      <span v-else class="text-body-2 text--secondary">No hay sucursales</span>
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="1100px" persistent scrollable>
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1" v-if="editedItem.id">
            <strong>ID: {{ editedItem.id }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <h3 class="mb-2">I. Información general</h3>
              <v-divider class="mb-4"></v-divider>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Departamento/Área:</label>
              <v-autocomplete
                filled
                dense
                clearable
                v-model="editedItem.departamento"
                :items="departamentos"
                label="Selecciona departamento o área"
                item-text="nombre"
                item-value="id"
                no-data-text="No hay datos"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Fecha de Auditoría:</label>
              <v-text-field
                type="date"
                filled
                dense
                :max="fechaMaxima"
                v-model="editedItem.fecha"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Proceso Auditado:</label>
              <v-select
                v-model="editedItem.tipoAuditoria"
                :items="tiposAuditoria"
                item-text="nombre"
                item-value="nombre"
                filled
                dense
                clearable
                label="Tipo de Auditoría"
                no-data-text="No hay datos"
              ></v-select>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Auditor:</label>
              <v-autocomplete
                filled
                dense
                clearable
                v-model="editedItem.auditor"
                :items="usuariosSelects"
                label="Selecciona auditor"
                item-text="usuario_registro"
                item-value="idusuario"
                no-data-text="No hay datos"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Jefe de departamento:</label>
              <v-autocomplete
                filled
                dense
                clearable
                v-model="editedItem.jefeDepartamento"
                :items="usuariosSoloCatalogoErp"
                label="Seleccionar jefe de departamento"
                :item-text="etiquetaUsuarioSelect"
                item-value="idusuario"
                no-data-text="No hay datos"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Estatus:</label>
              <v-radio-group v-model="editedItem.estatusModalidad" row class="mt-0" hide-details>
                <v-radio label="Inicial" value="Inicial"></v-radio>
                <v-radio label="Seguimiento" value="Seguimiento"></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" class="mt-2">
              <h3 class="mb-3">II. Lista de verificación universal (PHVA)</h3>
              <v-simple-table dense class="phva-table elevation-1">
                <thead>
                  <tr>
                    <th class="text-left">Criterio de evaluación</th>
                    <th style="width: 200px">Calificación</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="fila in criteriosPhvaFilasTabla" :key="fila._key">
                    <template v-if="fila.kind === 'header'">
                      <td colspan="2" class="grey lighten-4 font-weight-bold py-2">{{ fila.titulo }}</td>
                    </template>
                    <template v-else-if="fila.kind === 'row'">
                      <td>
                        <div class="font-weight-bold">{{ fila.c.idVisual || fila.c.id }}</div>
                        <div class="mt-1">{{ etiquetaPreguntaPhva(fila.c) }}</div>
                      </td>
                      <td>
                        <v-select
                          v-model="fila.c.calificacion"
                          :items="calificacionesPhvaSelect"
                          item-text="text"
                          item-value="value"
                          label="Calificación"
                          dense
                          filled
                          hide-details
                          clearable
                        ></v-select>
                      </td>
                    </template>
                    <template v-else-if="fila.kind === 'evidencia-general'">
                      <td colspan="2" class="bg-light-grey pa-3">
                        <div class="font-weight-bold mb-2">Evidencia / Hallazgo General</div>
                        <v-textarea
                          v-model="evidenciasGeneralesPhva[fila.seccion]"
                          dense
                          filled
                          rows="3"
                          hide-details
                          placeholder="Evidencia/Hallazgo general para esta sección"
                        ></v-textarea>
                        <div class="mt-3">
                          <v-file-input
                            accept="image/*"
                            dense
                            filled
                            hide-details
                            prepend-icon="mdi-camera"
                            label="Subir foto"
                            @change="onFotoEvidenciaGeneralChange(fila.seccion, $event)"
                          ></v-file-input>
                          <div v-if="obtenerFotoEvidenciaGeneral(fila.seccion)" class="mt-2">
                            <v-img
                              :src="obtenerFotoEvidenciaGeneral(fila.seccion)"
                              max-height="150"
                              contain
                              class="grey lighten-4"
                            ></v-img>
                            <v-btn x-small text color="error" class="mt-1" @click="quitarFotoEvidenciaGeneral(fila.seccion)">
                              Quitar foto
                            </v-btn>
                          </div>
                        </div>
                      </td>
                    </template>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>

            <v-col cols="12" class="mt-4">
              <h3 class="mb-2">III. Resumen de hallazgos (Caja de texto/comentario)</h3>
              <v-divider class="mb-3"></v-divider>

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.hallazgo1"
                    filled
                    dense
                    hide-details
                    label="1."
                    placeholder="Escribe el hallazgo principal"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.hallazgo2"
                    filled
                    dense
                    hide-details
                    label="2."
                    placeholder="Escribe el segundo hallazgo"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.hallazgo3"
                    filled
                    dense
                    hide-details
                    label="3."
                    placeholder="Escribe el tercer hallazgo"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" class="mt-4">
              <h3 class="mb-2">
                IV. Plan de acción y cierre (Esto lo tiene que poder llenar el auditor o jefe de control interno y el responsable del departamento)
              </h3>
              <v-divider class="mb-3"></v-divider>

              <v-row>
                <v-col cols="12" md="6">
                  <label class="text-body-2">Acción correctiva:</label>
                  <v-textarea
                    v-model="editedItem.accionCorrectiva"
                    filled
                    dense
                    rows="3"
                    auto-grow
                    hide-details
                    placeholder="Describe la acción correctiva"
                  ></v-textarea>
                </v-col>

                <v-col cols="12" md="6">
                  <label class="text-body-2">Responsable:</label>
                  <v-autocomplete
                    filled
                    dense
                    clearable
                    v-model="editedItem.responsable"
                    :items="usuariosSoloCatalogoErp"
                    label="Seleccionar responsable"
                    :item-text="etiquetaUsuarioSelect"
                    item-value="iderp"
                    no-data-text="No hay datos"
                  ></v-autocomplete>

                  <label class="text-body-2">Fecha de compromiso:</label>
                  <v-text-field
                    type="date"
                    filled
                    dense
                    v-model="editedItem.fechaCompromiso"
                    :min="editedItem.fecha || null"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn color="black" tile dark small @click="close">
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" tile dark small @click="save">
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogControlInterno" max-width="1180px" persistent scrollable>
      <v-card class="control-interno-modal-card">
        <v-overlay :value="guardandoControlInterno" absolute :z-index="10" opacity="0.6">
          <div class="text-center">
            <v-progress-circular indeterminate size="56" width="5" color="white"></v-progress-circular>
            <div class="mt-3 font-weight-medium">Guardando auditoría...</div>
          </div>
        </v-overlay>
        <v-card-title class="control-interno-modal-header">
          <div class="control-interno-modal-title-wrap">
            <div class="control-interno-modal-icon">
              <v-icon color="primary">mdi-shield-check</v-icon>
            </div>
            <div>
              <span class="control-interno-modal-title">{{ controlInternoFormTitle }}</span>
              <div class="control-interno-modal-subtitle">
                Auditoría operativa del plantel y seguimiento de control interno
              </div>
            </div>
          </div>
          <v-spacer></v-spacer>
          <span class="control-interno-modal-id" v-if="editedControlInternoItem.id">
            <strong>ID: {{ editedControlInternoItem.id }}</strong>
          </span>
        </v-card-title>

        <v-card-text class="control-interno-modal-body">
          <div class="control-interno-modal-dashboard">
            <div class="control-interno-modal-stat">
              <span class="stat-label">Plantel</span>
              <span class="stat-value">
                {{ nombrePlantel(editedControlInternoItem.idplantel, 'Pendiente') || 'Pendiente' }}
              </span>
            </div>
            <div class="control-interno-modal-stat">
              <span class="stat-label">Fecha</span>
              <span class="stat-value">{{ editedControlInternoItem.fechaAuditoria || 'Sin fecha' }}</span>
            </div>
            <div class="control-interno-modal-stat">
              <span class="stat-label">Avance checklist</span>
              <span class="stat-value">
                {{ resumenControlInternoModal.completados }}/{{ resumenControlInternoModal.total }}
              </span>
            </div>
            <div class="control-interno-modal-stat stat-accent">
              <span class="stat-label">Secciones</span>
              <span class="stat-value">7</span>
            </div>
          </div>

          <v-row>
            <v-col cols="12">
              <h3 class="mb-2">I. Información de Control Interno</h3>
              <v-divider class="mb-4"></v-divider>
            </v-col>

            <v-col cols="12">
              <label class="text-body-2">Objetivo general:</label>
              <v-textarea
                :value="objetivoControlInterno"
                filled
                dense
                rows="3"
                auto-grow
                readonly
                hide-details
              ></v-textarea>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Departamento:</label>
              <v-text-field
                :value="nombreDepartamentoOperaciones"
                filled
                dense
                readonly
              ></v-text-field>
            </v-col>

            <v-col id="ci-campo-plantel" cols="12" md="6">
              <label class="text-body-2">Plantel:</label>
              <v-autocomplete
                v-model="editedControlInternoItem.idplantel"
                :items="planteles"
                filled
                dense
                clearable
                label="Selecciona plantel"
                :error-messages="erroresControlInterno.plantel"
                @change="limpiarErrorControlInterno('plantel'); cargarSalonesControlInterno(false); cargarTicketsControlInterno(); cargarPersonalCorporativoControlInterno()"
                item-text="plantel"
                item-value="idplantel"
                no-data-text="No hay datos"
              ></v-autocomplete>
            </v-col>

            <v-col id="ci-campo-responsable" cols="12" md="6">
              <label class="text-body-2">Responsable del plantel:</label>
              <v-autocomplete
                v-model="editedControlInternoItem.responsablePlantel"
                :items="usuariosSoloCatalogoErp"
                filled
                dense
                clearable
                label="Selecciona responsable"
                :error-messages="erroresControlInterno.responsable"
                @change="limpiarErrorControlInterno('responsable')"
                :item-text="etiquetaUsuarioSelect"
                item-value="iderp"
                no-data-text="No hay datos"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Fecha de auditoría:</label>
              <v-text-field
                :value="editedControlInternoItem.fechaAuditoria"
                type="date"
                filled
                dense
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Auditor:</label>
              <v-text-field
                :value="nombreAuditorControlInterno"
                filled
                dense
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <label class="text-body-2">Hora inicio:</label>
              <v-text-field
                v-model="editedControlInternoItem.horaInicio"
                type="time"
                filled
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <label class="text-body-2">Hora término:</label>
              <v-text-field
                v-model="editedControlInternoItem.horaTermino"
                type="time"
                filled
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Estatus:</label>
              <v-select
                v-model="editedControlInternoItem.estatus"
                :items="estatusControlInternoOpciones"
                filled
                dense
              ></v-select>
            </v-col>

            <v-col cols="12" class="mt-2">
              <h3 class="mb-2">II. Lista de verificación</h3>
              <v-divider class="mb-3"></v-divider>

              <div class="control-interno-seccion-title">1. INSTALACIONES</div>
              <div class="control-interno-seccion-desc">
                <div><strong>Qué se evalúa:</strong> {{ descripcionSeccionControlInterno(1).que }}</div>
                <div><strong>Cómo:</strong> {{ descripcionSeccionControlInterno(1).como }}</div>
              </div>
              <input
                ref="inputEvidenciaCIFoto"
                type="file"
                accept="image/*"
                capture="environment"
                class="control-interno-file-oculto"
                @change="onArchivosEvidenciaControlInterno"
              />
              <input
                ref="inputEvidenciaCIVideo"
                type="file"
                accept="video/*"
                capture="environment"
                class="control-interno-file-oculto"
                @change="onArchivosEvidenciaControlInterno"
              />
              <input
                ref="inputEvidenciaCIArchivo"
                type="file"
                accept="image/*,video/*"
                multiple
                class="control-interno-file-oculto"
                @change="onArchivosEvidenciaControlInterno"
              />
              <v-simple-table dense class="control-interno-check-table">
                <thead>
                  <tr>
                    <th class="text-left">Criterio</th>
                    <th class="text-center">Cumple</th>
                    <th class="text-center">No cumple</th>
                    <th class="text-center">Evidencias</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="criterio in editedControlInternoItem.criterios">
                    <tr :key="'crit-' + criterio.id">
                      <td>{{ criterio.criterio }}</td>
                      <td class="text-center">
                        <v-checkbox
                          :input-value="criterio.resultado === 'Cumple'"
                          class="control-interno-check"
                          hide-details
                          dense
                          @change="marcarCriterioControlInterno(criterio, 'Cumple')"
                        ></v-checkbox>
                      </td>
                      <td class="text-center">
                        <v-checkbox
                          :input-value="criterio.resultado === 'No cumple'"
                          class="control-interno-check"
                          hide-details
                          dense
                          @change="marcarCriterioControlInterno(criterio, 'No cumple')"
                        ></v-checkbox>
                      </td>
                      <td class="text-center text-no-wrap">
                        <v-progress-circular
                          v-if="subiendoEvidenciaControlInterno[criterio.id]"
                          indeterminate
                          size="20"
                          width="2"
                          color="primary"
                        ></v-progress-circular>
                        <template v-else>
                          <v-btn icon small color="primary" title="Tomar foto" @click="abrirSelectorEvidenciaControlInterno(criterio, 'foto')">
                            <v-icon small>mdi-camera</v-icon>
                          </v-btn>
                          <v-btn icon small color="deep-purple" title="Grabar video" @click="abrirSelectorEvidenciaControlInterno(criterio, 'video')">
                            <v-icon small>mdi-video</v-icon>
                          </v-btn>
                          <v-btn icon small color="teal" title="Subir desde archivos o galería" @click="abrirSelectorEvidenciaControlInterno(criterio, 'archivo')">
                            <v-icon small>mdi-paperclip</v-icon>
                          </v-btn>
                        </template>
                      </td>
                    </tr>
                    <tr
                      v-if="criterio.evidencias && criterio.evidencias.length"
                      :key="'evid-' + criterio.id"
                      class="control-interno-evidencias-row"
                    >
                      <td colspan="4">
                        <div class="control-interno-evidencias">
                          <div
                            v-for="(evidencia, index) in criterio.evidencias"
                            :key="evidencia.archivo"
                            class="control-interno-evidencia"
                          >
                            <a :href="urlEvidenciaControlInterno(evidencia)" target="_blank" rel="noopener">
                              <img
                                v-if="evidencia.tipo !== 'video'"
                                :src="urlEvidenciaControlInterno(evidencia)"
                                :alt="evidencia.nombre_original || 'Evidencia'"
                              />
                              <video
                                v-else
                                :src="urlEvidenciaControlInterno(evidencia)"
                                preload="metadata"
                                muted
                                playsinline
                              ></video>
                              <v-icon v-if="evidencia.tipo === 'video'" class="control-interno-evidencia-play" color="white">
                                mdi-play-circle
                              </v-icon>
                            </a>
                            <v-btn
                              icon
                              x-small
                              color="error"
                              class="control-interno-evidencia-quitar"
                              title="Quitar evidencia"
                              @click="quitarEvidenciaControlInterno(criterio, index)"
                            >
                              <v-icon x-small>mdi-close</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </v-simple-table>

              <template v-if="esCorporativoControlInterno">
              <div class="control-interno-seccion-title mt-5">
                2. AUDITORÍA DE OFICINAS (Total de oficinas: {{ (editedControlInternoItem.oficinas || []).length }})
              </div>
              <div class="control-interno-seccion-desc">
                <div><strong>Qué se evalúa:</strong> {{ descripcionSeccionControlInterno(2).que }}</div>
                <div><strong>Cómo:</strong> {{ descripcionSeccionControlInterno(2).como }}</div>
              </div>
              <div
                v-if="!(editedControlInternoItem.oficinas || []).length"
                class="text-body-2 text--secondary py-2"
              >
                Aún no hay oficinas. Agrega cada oficina del corporativo que vas a revisar.
              </div>
              <div
                v-for="(oficina, indexOficina) in editedControlInternoItem.oficinas"
                :id="'ci-campo-oficina-' + indexOficina"
                :key="oficina.id"
                class="control-interno-oficina mb-3 pa-3"
              >
                <div class="d-flex align-center flex-wrap" style="gap: 8px;">
                  <span class="font-weight-bold">Oficina {{ indexOficina + 1 }}</span>
                  <v-autocomplete
                    v-model="oficina.departamento"
                    :items="departamentosOficinaControlInterno"
                    label="Departamento"
                    dense
                    filled
                    clearable
                    class="control-interno-oficina-depto"
                    :hide-details="!erroresControlInterno['oficina-' + indexOficina]"
                    :error-messages="erroresControlInterno['oficina-' + indexOficina]"
                    no-data-text="No hay datos"
                    @change="limpiarErrorControlInterno('oficina-' + indexOficina)"
                  ></v-autocomplete>
                  <v-spacer></v-spacer>
                  <v-progress-circular
                    v-if="subiendoEvidenciaControlInterno[oficina.id]"
                    indeterminate
                    size="20"
                    width="2"
                    color="primary"
                  ></v-progress-circular>
                  <template v-else>
                    <v-btn icon small color="primary" title="Tomar foto" @click="abrirSelectorEvidenciaControlInterno(oficina, 'foto')">
                      <v-icon small>mdi-camera</v-icon>
                    </v-btn>
                    <v-btn icon small color="deep-purple" title="Grabar video" @click="abrirSelectorEvidenciaControlInterno(oficina, 'video')">
                      <v-icon small>mdi-video</v-icon>
                    </v-btn>
                    <v-btn icon small color="teal" title="Subir desde archivos o galería" @click="abrirSelectorEvidenciaControlInterno(oficina, 'archivo')">
                      <v-icon small>mdi-paperclip</v-icon>
                    </v-btn>
                  </template>
                  <v-btn icon small color="error" title="Quitar oficina" @click="quitarOficinaControlInterno(indexOficina)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </div>
                <v-simple-table dense class="control-interno-check-table mt-2">
                  <thead>
                    <tr>
                      <th class="text-left">Criterio</th>
                      <th class="text-center">Cumple</th>
                      <th class="text-center">No cumple</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="criterio in oficina.criterios" :key="oficina.id + '-' + criterio.id">
                      <td>{{ criterio.criterio }}</td>
                      <td class="text-center">
                        <v-checkbox
                          :input-value="criterio.resultado === 'Cumple'"
                          class="control-interno-check"
                          hide-details
                          dense
                          @change="marcarCriterioControlInterno(criterio, 'Cumple')"
                        ></v-checkbox>
                      </td>
                      <td class="text-center">
                        <v-checkbox
                          :input-value="criterio.resultado === 'No cumple'"
                          class="control-interno-check"
                          hide-details
                          dense
                          @change="marcarCriterioControlInterno(criterio, 'No cumple')"
                        ></v-checkbox>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <div v-if="oficina.evidencias && oficina.evidencias.length" class="control-interno-evidencias mt-2">
                  <div
                    v-for="(evidencia, indexEvidencia) in oficina.evidencias"
                    :key="evidencia.archivo"
                    class="control-interno-evidencia"
                  >
                    <a :href="urlEvidenciaControlInterno(evidencia)" target="_blank" rel="noopener">
                      <img
                        v-if="evidencia.tipo !== 'video'"
                        :src="urlEvidenciaControlInterno(evidencia)"
                        :alt="evidencia.nombre_original || 'Evidencia'"
                      />
                      <video
                        v-else
                        :src="urlEvidenciaControlInterno(evidencia)"
                        preload="metadata"
                        muted
                        playsinline
                      ></video>
                      <v-icon v-if="evidencia.tipo === 'video'" class="control-interno-evidencia-play" color="white">
                        mdi-play-circle
                      </v-icon>
                    </a>
                    <v-btn
                      icon
                      x-small
                      color="error"
                      class="control-interno-evidencia-quitar"
                      title="Quitar evidencia"
                      @click="quitarEvidenciaControlInterno(oficina, indexEvidencia)"
                    >
                      <v-icon x-small>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
              <v-btn small tile color="primary" class="mb-2" @click="agregarOficinaControlInterno">
                <v-icon left small>mdi-plus</v-icon>
                Agregar oficina
              </v-btn>
              <label class="text-body-2 font-weight-bold mt-2 d-block">Observaciones:</label>
              <v-textarea
                v-model="editedControlInternoItem.observacionesSalones"
                dense
                filled
                rows="2"
                auto-grow
                hide-details
              ></v-textarea>
              </template>

              <template v-else>
              <div class="control-interno-seccion-title mt-5">
                2. AUDITORÍA DE SALONES (Total de salones: {{ editedControlInternoItem.salones.length }})
              </div>
              <div class="control-interno-seccion-desc">
                <div><strong>Qué se evalúa:</strong> {{ descripcionSeccionControlInterno(2).que }}</div>
                <div><strong>Cómo:</strong> {{ descripcionSeccionControlInterno(2).como }}</div>
              </div>
              <v-progress-linear v-if="cargandoSalonesControlInterno" indeterminate color="primary" class="mb-2"></v-progress-linear>
              <div
                v-else-if="!editedControlInternoItem.salones.length"
                class="text-body-2 text--secondary py-2"
              >
                {{
                  editedControlInternoItem.idplantel
                    ? 'Esta sucursal no tiene salones activos registrados.'
                    : 'Selecciona el plantel para cargar sus salones.'
                }}
              </div>
              <v-simple-table v-if="editedControlInternoItem.salones.length" dense class="control-interno-check-table">
                <thead>
                  <tr>
                    <th class="text-center">Salón</th>
                    <th class="text-center">Bancos</th>
                    <th class="text-center">Proyector</th>
                    <th class="text-center">Iluminación</th>
                    <th class="text-center">Clima (A/C)</th>
                    <th class="text-center">Pintura</th>
                    <th class="text-center">Evidencias</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(salon, indexSalon) in editedControlInternoItem.salones">
                  <tr
                    :id="'ci-campo-salon-' + indexSalon"
                    :key="salon.id_salon != null ? 'id-' + salon.id_salon : 'n-' + salon.salon"
                    :class="{ 'control-interno-fila-error': salonSinEvidenciaConErrorControlInterno(salon, indexSalon) }"
                  >
                    <td class="text-center font-weight-bold">{{ salon.nombre || salon.salon }}</td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="salon.bancos"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="toggleBooleanControlInterno(salon, 'bancos')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="salon.proyector"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="toggleBooleanControlInterno(salon, 'proyector')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="salon.iluminacion"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="toggleBooleanControlInterno(salon, 'iluminacion')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="salon.clima"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="toggleBooleanControlInterno(salon, 'clima')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="salon.pintura"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="toggleBooleanControlInterno(salon, 'pintura')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center text-no-wrap">
                      <v-progress-circular
                        v-if="subiendoEvidenciaControlInterno[salon.id]"
                        indeterminate
                        size="20"
                        width="2"
                        color="primary"
                      ></v-progress-circular>
                      <template v-else>
                        <v-btn icon small color="primary" title="Tomar foto" @click="abrirSelectorEvidenciaSalonControlInterno(salon, indexSalon, 'foto')">
                          <v-icon small>mdi-camera</v-icon>
                        </v-btn>
                        <v-btn icon small color="deep-purple" title="Grabar video" @click="abrirSelectorEvidenciaSalonControlInterno(salon, indexSalon, 'video')">
                          <v-icon small>mdi-video</v-icon>
                        </v-btn>
                        <v-btn icon small color="teal" title="Subir desde archivos o galería" @click="abrirSelectorEvidenciaSalonControlInterno(salon, indexSalon, 'archivo')">
                          <v-icon small>mdi-paperclip</v-icon>
                        </v-btn>
                      </template>
                    </td>
                  </tr>
                  <tr
                    v-if="(salon.evidencias && salon.evidencias.length) || salonSinEvidenciaConErrorControlInterno(salon, indexSalon)"
                    :key="'evid-salon-' + salon.salon"
                    class="control-interno-evidencias-row"
                  >
                    <td colspan="7">
                      <div v-if="salonSinEvidenciaConErrorControlInterno(salon, indexSalon)" class="error--text text-caption mb-1">
                        Agrega al menos una foto o video de este salón para cerrar la auditoría.
                      </div>
                      <div class="control-interno-evidencias">
                        <div
                          v-for="(evidencia, indexEvidencia) in salon.evidencias"
                          :key="evidencia.archivo"
                          class="control-interno-evidencia"
                        >
                          <a :href="urlEvidenciaControlInterno(evidencia)" target="_blank" rel="noopener">
                            <img
                              v-if="evidencia.tipo !== 'video'"
                              :src="urlEvidenciaControlInterno(evidencia)"
                              :alt="evidencia.nombre_original || 'Evidencia'"
                            />
                            <video
                              v-else
                              :src="urlEvidenciaControlInterno(evidencia)"
                              preload="metadata"
                              muted
                              playsinline
                            ></video>
                            <v-icon v-if="evidencia.tipo === 'video'" class="control-interno-evidencia-play" color="white">
                              mdi-play-circle
                            </v-icon>
                          </a>
                          <v-btn
                            icon
                            x-small
                            color="error"
                            class="control-interno-evidencia-quitar"
                            title="Quitar evidencia"
                            @click="quitarEvidenciaControlInterno(salon, indexEvidencia)"
                          >
                            <v-icon x-small>mdi-close</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </td>
                  </tr>
                  </template>
                </tbody>
              </v-simple-table>
              <label class="text-body-2 font-weight-bold mt-2 d-block">Observaciones:</label>
              <v-textarea
                v-model="editedControlInternoItem.observacionesSalones"
                dense
                filled
                rows="2"
                auto-grow
                hide-details
              ></v-textarea>
              </template>

              <template v-if="!esCorporativoControlInterno">
              <div class="control-interno-seccion-title mt-5">3. CORTE</div>
              <div class="control-interno-seccion-desc">
                <div><strong>Qué se evalúa:</strong> {{ descripcionSeccionControlInterno(3).que }}</div>
                <div><strong>Cómo:</strong> {{ descripcionSeccionControlInterno(3).como }}</div>
              </div>
              <v-row dense>
                <v-col cols="12" md="6">
                  <label class="text-body-2 font-weight-bold">Encargada:</label>
                  <v-autocomplete
                    v-model="editedControlInternoItem.corte.encargada"
                    :items="usuariosSelects"
                    :item-text="etiquetaUsuarioSelect"
                    item-value="idusuario"
                    dense
                    filled
                    clearable
                    hide-details
                    no-data-text="No hay datos"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <label class="text-body-2 font-weight-bold">Recepción en turno:</label>
                  <v-autocomplete
                    v-model="editedControlInternoItem.corte.recepcionTurno"
                    :items="usuariosSelects"
                    :item-text="etiquetaUsuarioSelect"
                    item-value="idusuario"
                    dense
                    filled
                    clearable
                    hide-details
                    no-data-text="No hay datos"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-simple-table dense class="control-interno-check-table mt-3">
                <thead>
                  <tr>
                    <th class="text-left">Criterio</th>
                    <th class="text-center">Cumple</th>
                    <th class="text-center">No cumple</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="criterio in editedControlInternoItem.corte.criterios" :key="criterio.id">
                    <td>{{ criterio.criterio }}</td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'Cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'Cumple')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'No cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'No cumple')"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <label class="text-body-2 font-weight-bold mt-2 d-block">Observaciones:</label>
              <v-textarea
                v-model="editedControlInternoItem.corte.observaciones"
                dense
                filled
                rows="2"
                auto-grow
                hide-details
              ></v-textarea>
              </template>

              <div class="control-interno-seccion-title mt-5">{{ numeroSeccionControlInterno(4) }}. CÓDIGO DE VESTIMENTA</div>
              <div class="control-interno-seccion-desc">
                <div><strong>Qué se evalúa:</strong> {{ descripcionSeccionControlInterno(4).que }}</div>
                <div><strong>Cómo:</strong> {{ descripcionSeccionControlInterno(4).como }}</div>
              </div>
              <template v-if="esCorporativoControlInterno">
                <v-progress-linear
                  v-if="cargandoPersonalCorporativoControlInterno"
                  indeterminate
                  color="primary"
                  class="mb-2"
                ></v-progress-linear>
                <div
                  v-else-if="!personalCorporativoControlInterno.length"
                  class="text-body-2 text--secondary py-2"
                >
                  No hay trabajadores activos asignados a este corporativo en el ERP.
                </div>
                <v-expansion-panels v-else multiple flat class="control-interno-panels mb-2">
                  <v-expansion-panel
                    v-for="persona in personalCorporativoControlInterno"
                    :key="'corp-vest-' + (persona.iderp != null ? persona.iderp : persona.nombre)"
                  >
                    <v-expansion-panel-header class="py-1">
                      <div class="d-flex align-center flex-wrap" style="gap: 8px;">
                        <span class="font-weight-bold">{{ persona.nombre }}</span>
                        <span v-if="persona.puesto" class="text-caption text--secondary">{{ persona.puesto }}</span>
                        <v-chip x-small dark :color="resumenVestimentaPersonaControlInterno(persona).color">
                          {{ resumenVestimentaPersonaControlInterno(persona).texto }}
                        </v-chip>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-simple-table dense class="control-interno-check-table">
                        <thead>
                          <tr>
                            <th class="text-left">Criterio</th>
                            <th v-for="opcion in opcionesVestimentaControlInterno" :key="opcion.label" class="text-center">
                              {{ opcion.label }}
                            </th>
                            <th class="text-center">Cuántos</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="criterio in criteriosVestimentaControlInterno" :key="criterio.campo">
                            <td>{{ criterio.label }}</td>
                            <td v-for="opcion in opcionesVestimentaControlInterno" :key="opcion.label" class="text-center">
                              <v-checkbox
                                :input-value="persona[criterio.campo] === opcion.valor"
                                class="control-interno-check"
                                hide-details
                                dense
                                @change="marcarBooleanoCumpleControlInterno(persona, criterio.campo, opcion.valor)"
                              ></v-checkbox>
                            </td>
                            <td class="text-center">
                              <v-text-field
                                v-if="criterio.campoCantidad"
                                v-model.number="persona[criterio.campoCantidad]"
                                type="number"
                                min="0"
                                outlined
                                dense
                                hide-details
                                class="control-interno-cantidad"
                              ></v-text-field>
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </template>
              <template v-else>
              <div
                v-for="fila in filasVestimentaPdfControlInterno"
                :key="'vest-' + fila.personal"
                class="mb-3"
              >
                <v-row dense align="center" class="mb-1">
                  <v-col cols="12" sm="4" class="font-weight-bold d-flex align-center flex-wrap" style="gap: 8px;">
                    {{ fila.personal }}
                    <v-btn-toggle
                      v-if="esPersonalOpcionalControlInterno(fila)"
                      v-model="fila.aplica"
                      mandatory
                      dense
                    >
                      <v-btn :value="true" x-small class="text-capitalize" :color="fila.aplica ? 'green' : ''" :dark="fila.aplica">
                        Aplica
                      </v-btn>
                      <v-btn :value="false" x-small class="text-capitalize" :color="!fila.aplica ? 'grey darken-1' : ''" :dark="!fila.aplica">
                        No aplica
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                  <v-col v-if="fila.aplica === false" cols="12" sm="8" class="text-body-2 text--secondary">
                    La sucursal no cuenta con {{ fila.personal }}; no se evalúa ni cuenta para el puntaje.
                  </v-col>
                  <v-col v-else cols="12" sm="8">
                    <v-autocomplete
                      v-model="fila.idUsuarioEvaluado"
                      :items="usuariosSelects"
                      :item-text="etiquetaUsuarioSelect"
                      item-value="idusuario"
                      label="Persona evaluada"
                      dense
                      filled
                      clearable
                      hide-details
                      no-data-text="No hay datos"
                      @change="cambiarPersonaVestimentaControlInterno(fila)"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-simple-table v-if="fila.aplica !== false" dense class="control-interno-check-table">
                  <thead>
                    <tr>
                      <th class="text-left">Criterio</th>
                      <th v-for="opcion in opcionesVestimentaControlInterno" :key="opcion.label" class="text-center">
                        {{ opcion.label }}
                      </th>
                      <th class="text-center">Cuántos</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="criterio in criteriosVestimentaControlInterno" :key="criterio.campo">
                      <td>{{ criterio.label }}</td>
                      <td v-for="opcion in opcionesVestimentaControlInterno" :key="opcion.label" class="text-center">
                        <v-checkbox
                          :input-value="fila[criterio.campo] === opcion.valor"
                          class="control-interno-check"
                          hide-details
                          dense
                          @change="marcarBooleanoCumpleControlInterno(fila, criterio.campo, opcion.valor)"
                        ></v-checkbox>
                      </td>
                      <td class="text-center">
                        <v-text-field
                          v-if="criterio.campoCantidad"
                          v-model.number="fila[criterio.campoCantidad]"
                          type="number"
                          min="0"
                          outlined
                          dense
                          hide-details
                          class="control-interno-cantidad"
                        ></v-text-field>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>

              <div class="d-flex align-center mt-4 mb-2">
                <span class="font-weight-bold">Teachers ({{ teachersVestimentaControlInterno.length }})</span>
                <v-spacer></v-spacer>
                <v-btn small tile color="primary" dark @click="agregarTeacherVestimentaControlInterno">
                  <v-icon small left>mdi-plus</v-icon>
                  Agregar teacher
                </v-btn>
              </div>
              <div
                v-for="(teacher, indexTeacher) in teachersVestimentaControlInterno"
                :id="'ci-campo-teacher-' + indexTeacher"
                :key="'teacher-' + indexTeacher"
                class="mb-3"
              >
                <v-row dense align="center" class="mb-1">
                  <v-col cols="12" sm="4" class="font-weight-bold">Teacher {{ indexTeacher + 1 }}</v-col>
                  <v-col cols="10" sm="7">
                    <v-autocomplete
                      v-model="teacher.idUsuarioEvaluado"
                      :items="usuariosSelects"
                      :item-text="etiquetaUsuarioSelect"
                      item-value="idusuario"
                      label="Selecciona el teacher"
                      dense
                      filled
                      clearable
                      :hide-details="!erroresControlInterno['teacher-' + indexTeacher]"
                      :error-messages="erroresControlInterno['teacher-' + indexTeacher]"
                      @change="limpiarErrorControlInterno('teacher-' + indexTeacher); cambiarPersonaVestimentaControlInterno(teacher)"
                      no-data-text="No hay datos"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="2" sm="1" class="text-center">
                    <v-btn icon small color="error" title="Quitar teacher" @click="quitarTeacherVestimentaControlInterno(indexTeacher)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-simple-table dense class="control-interno-check-table">
                  <thead>
                    <tr>
                      <th class="text-left">Criterio</th>
                      <th v-for="opcion in opcionesVestimentaControlInterno" :key="opcion.label" class="text-center">
                        {{ opcion.label }}
                      </th>
                      <th class="text-center">Cuántos</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="criterio in criteriosTeacherControlInterno" :key="criterio.campo">
                      <td>{{ criterio.label }}</td>
                      <td v-for="opcion in opcionesVestimentaControlInterno" :key="opcion.label" class="text-center">
                        <v-checkbox
                          :input-value="teacher[criterio.campo] === opcion.valor"
                          class="control-interno-check"
                          hide-details
                          dense
                          @change="marcarBooleanoCumpleControlInterno(teacher, criterio.campo, opcion.valor)"
                        ></v-checkbox>
                      </td>
                      <td class="text-center">
                        <v-text-field
                          v-if="criterio.campoCantidad"
                          v-model.number="teacher[criterio.campoCantidad]"
                          type="number"
                          min="0"
                          outlined
                          dense
                          hide-details
                          class="control-interno-cantidad"
                        ></v-text-field>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>
              </template>
              <label class="text-body-2 font-weight-bold mt-2 d-block">Observaciones:</label>
              <v-textarea
                v-model="editedControlInternoItem.vestimenta.observaciones"
                dense
                filled
                rows="2"
                auto-grow
                hide-details
              ></v-textarea>

              <template v-if="!esCorporativoControlInterno">
              <div class="control-interno-seccion-title mt-5">5. PUNTUALIDAD Y DISCIPLINA DEL EQUIPO</div>
              <div class="control-interno-seccion-desc">
                <div><strong>Qué se evalúa:</strong> {{ descripcionSeccionControlInterno(5).que }}</div>
                <div><strong>Cómo:</strong> {{ descripcionSeccionControlInterno(5).como }}</div>
              </div>
              <div
                v-for="fila in filasPuntualidadPdfControlInterno"
                :key="'punt-' + fila.personal"
                class="mb-3"
              >
                <div class="font-weight-bold mb-1">{{ fila.personal }}</div>
                <v-simple-table dense class="control-interno-check-table">
                  <thead>
                    <tr>
                      <th class="text-left">Criterio</th>
                      <th class="text-center">Cumple</th>
                      <th class="text-center">No cumple</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Cumplimiento de horarios</td>
                      <td class="text-center">
                        <v-checkbox
                          :input-value="fila.cumpleHorario === true"
                          class="control-interno-check"
                          hide-details
                          dense
                          @change="marcarBooleanoCumpleControlInterno(fila, 'cumpleHorario', true)"
                        ></v-checkbox>
                      </td>
                      <td class="text-center">
                        <v-checkbox
                          :input-value="fila.cumpleHorario === false"
                          class="control-interno-check"
                          hide-details
                          dense
                          @change="marcarBooleanoCumpleControlInterno(fila, 'cumpleHorario', false)"
                        ></v-checkbox>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{
                          fila.personal === 'Encargada'
                            ? 'Supervisión activa del equipo'
                            : 'Permanencia en área de trabajo'
                        }}
                      </td>
                      <td class="text-center">
                        <v-checkbox
                          :input-value="fila.permaneceArea === true"
                          class="control-interno-check"
                          hide-details
                          dense
                          @change="marcarBooleanoCumpleControlInterno(fila, 'permaneceArea', true)"
                        ></v-checkbox>
                      </td>
                      <td class="text-center">
                        <v-checkbox
                          :input-value="fila.permaneceArea === false"
                          class="control-interno-check"
                          hide-details
                          dense
                          @change="marcarBooleanoCumpleControlInterno(fila, 'permaneceArea', false)"
                        ></v-checkbox>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>
              <label class="text-body-2 font-weight-bold mt-2 d-block">Observaciones:</label>
              <v-textarea
                v-model="editedControlInternoItem.vestimenta.observacionesPuntualidad"
                dense
                filled
                rows="2"
                auto-grow
                hide-details
              ></v-textarea>

              <div class="control-interno-seccion-title mt-5">6. REINSCRIPCIONES (RI) Y ATENCIÓN AL ALUMNO</div>
              <div class="control-interno-seccion-desc">
                <div><strong>Qué se evalúa:</strong> {{ descripcionSeccionControlInterno(6).que }}</div>
                <div><strong>Cómo:</strong> {{ descripcionSeccionControlInterno(6).como }}</div>
              </div>
              <v-row dense align="center" class="mb-1">
                <v-col cols="12" sm="4" class="font-weight-bold">Encargada</v-col>
                <v-col cols="12" sm="8">
                  <v-autocomplete
                    v-model="editedControlInternoItem.riAtencionAlumno.encargada"
                    :items="usuariosSelects"
                    :item-text="etiquetaUsuarioSelect"
                    item-value="idusuario"
                    label="Persona evaluada"
                    dense
                    filled
                    clearable
                    hide-details
                    no-data-text="No hay datos"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-simple-table dense class="control-interno-check-table">
                <thead>
                  <tr>
                    <th class="text-left">Criterio</th>
                    <th class="text-center">Cumple</th>
                    <th class="text-center">No cumple</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="criterio in editedControlInternoItem.riAtencionAlumno.encargadaCriterios" :key="criterio.id">
                    <td>{{ criterio.criterio }}</td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'Cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'Cumple')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'No cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'No cumple')"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>

              <v-row dense align="center" class="mt-4 mb-1">
                <v-col cols="12" sm="4" class="font-weight-bold">Recepción</v-col>
                <v-col cols="12" sm="8">
                  <v-autocomplete
                    v-model="editedControlInternoItem.riAtencionAlumno.recepcion"
                    :items="usuariosSelects"
                    :item-text="etiquetaUsuarioSelect"
                    item-value="idusuario"
                    label="Persona evaluada"
                    dense
                    filled
                    clearable
                    hide-details
                    no-data-text="No hay datos"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-simple-table dense class="control-interno-check-table">
                <thead>
                  <tr>
                    <th class="text-left">Criterio</th>
                    <th class="text-center">Cumple</th>
                    <th class="text-center">No cumple</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="criterio in editedControlInternoItem.riAtencionAlumno.recepcionCriterios" :key="criterio.id">
                    <td>{{ criterio.criterio }}</td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'Cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'Cumple')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'No cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'No cumple')"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <label class="text-body-2 font-weight-bold mt-2 d-block">Observaciones:</label>
              <v-textarea
                v-model="editedControlInternoItem.riAtencionAlumno.recepcionObservaciones"
                dense
                filled
                rows="2"
                auto-grow
                hide-details
              ></v-textarea>

              </template>

              <div class="control-interno-seccion-title mt-5">{{ numeroSeccionControlInterno(7) }}. METODOLOGÍA 5S</div>
              <div class="control-interno-seccion-desc">
                <div><strong>Qué se evalúa:</strong> {{ descripcionSeccionControlInterno(7).que }}</div>
                <div><strong>Cómo:</strong> {{ descripcionSeccionControlInterno(7).como }}</div>
              </div>
              <template v-if="esCorporativoControlInterno">
                <div
                  v-if="!(editedControlInternoItem.oficinas || []).length"
                  class="text-body-2 text--secondary py-2"
                >
                  Agrega las oficinas en la sección 2 para evaluarlas con 5S.
                </div>
                <div
                  v-for="(oficina, indexOficina) in editedControlInternoItem.oficinas"
                  :key="'5s-' + oficina.id"
                  class="mb-3"
                >
                  <div class="font-weight-bold mb-1">{{ nombreOficinaControlInterno(oficina, indexOficina) }}</div>
                  <v-simple-table dense class="control-interno-check-table control-interno-table-wide">
                    <thead>
                      <tr>
                        <th class="text-left">Criterio</th>
                        <th class="text-center">Cumple</th>
                        <th class="text-center">No cumple</th>
                        <th class="text-left">Observaciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="criterio in oficina.criterios5s" :key="oficina.id + '-5s-' + criterio.id">
                        <td>{{ etiquetaCriterio5sControlInterno(criterio) }}</td>
                        <td class="text-center">
                          <v-checkbox
                            :input-value="criterio.resultado === 'Cumple'"
                            class="control-interno-check"
                            hide-details
                            dense
                            @change="marcarCriterioControlInterno(criterio, 'Cumple')"
                          ></v-checkbox>
                        </td>
                        <td class="text-center">
                          <v-checkbox
                            :input-value="criterio.resultado === 'No cumple'"
                            class="control-interno-check"
                            hide-details
                            dense
                            @change="marcarCriterioControlInterno(criterio, 'No cumple')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <v-textarea
                            v-model="criterio.evidenciaAccion"
                            dense
                            rows="2"
                            auto-grow
                            hide-details
                            solo
                            flat
                          ></v-textarea>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </div>
              </template>
              <v-simple-table v-else dense class="control-interno-check-table control-interno-table-wide">
                <thead>
                  <tr>
                    <th class="text-left">Criterio</th>
                    <th class="text-center">Cumple</th>
                    <th class="text-center">No cumple</th>
                    <th class="text-left">Observaciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="criterio in editedControlInternoItem.metodologia5s.criterios" :key="criterio.id">
                    <td>{{ etiquetaCriterio5sControlInterno(criterio) }}</td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'Cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'Cumple')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'No cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'No cumple')"
                      ></v-checkbox>
                    </td>
                    <td>
                      <v-textarea
                        v-model="criterio.evidenciaAccion"
                        dense
                        rows="2"
                        auto-grow
                        hide-details
                        solo
                        flat
                      ></v-textarea>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>

              <p class="mb-2 mt-4">
                Agradezco mucho el apoyo y las facilidades brindadas durante la revisión.
                Se realizó la validación de los distintos procesos y áreas del plantel conforme a lo establecido.
                Cualquier seguimiento adicional se estará revisando de manera interna.
              </p>
              <p class="mb-3">Quedo atenta a cualquier duda.</p>

              <div class="control-interno-firmas mt-2 mb-4">
                <div class="font-weight-bold mb-2">FIRMAS</div>
                <p class="text-caption text--secondary mb-3">
                  Firma en pantalla, igual que en Documentación RH / Código de vestimenta.
                </p>
                <v-row dense>
                  <v-col cols="12" md="4">
                    <label class="text-body-2 font-weight-bold">Auditor:</label>
                    <div class="mt-1">
                      <v-btn
                        small
                        tile
                        color="primary"
                        class="mr-2"
                        @click="abrirFirmaControlInterno('auditorFirma')"
                      >
                        <v-icon left small>mdi-draw</v-icon>
                        Firmar
                      </v-btn>
                      <v-btn
                        v-if="esFirmaImagenControlInterno(editedControlInternoItem.cierreAuditoria.auditorFirma)"
                        small
                        tile
                        text
                        color="error"
                        @click="clearFirmaControlInterno('auditorFirma')"
                      >
                        Quitar
                      </v-btn>
                    </div>
                    <div
                      v-if="esFirmaImagenControlInterno(editedControlInternoItem.cierreAuditoria.auditorFirma)"
                      class="control-interno-firma-preview mt-2 pa-2"
                    >
                      <img
                        :src="editedControlInternoItem.cierreAuditoria.auditorFirma"
                        alt="Firma del auditor"
                        class="control-interno-firma-img"
                      />
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <label class="text-body-2 font-weight-bold">Responsable del plantel:</label>
                    <div class="mt-1">
                      <v-btn
                        small
                        tile
                        color="primary"
                        class="mr-2"
                        @click="abrirFirmaControlInterno('responsablePlantelFirma')"
                      >
                        <v-icon left small>mdi-draw</v-icon>
                        Firmar
                      </v-btn>
                      <v-btn
                        v-if="esFirmaImagenControlInterno(editedControlInternoItem.cierreAuditoria.responsablePlantelFirma)"
                        small
                        tile
                        text
                        color="error"
                        @click="clearFirmaControlInterno('responsablePlantelFirma')"
                      >
                        Quitar
                      </v-btn>
                    </div>
                    <div
                      v-if="esFirmaImagenControlInterno(editedControlInternoItem.cierreAuditoria.responsablePlantelFirma)"
                      class="control-interno-firma-preview mt-2 pa-2"
                    >
                      <img
                        :src="editedControlInternoItem.cierreAuditoria.responsablePlantelFirma"
                        alt="Firma del responsable"
                        class="control-interno-firma-img"
                      />
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <label class="text-body-2 font-weight-bold">Fecha:</label>
                    <v-text-field
                      v-model="editedControlInternoItem.cierreAuditoria.fechaFirma"
                      type="date"
                      dense
                      filled
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>

              <div class="control-interno-seccion-title mt-5">{{ numeroSeccionControlInterno(8) }}. RETROALIMENTACIÓN DEL PERSONAL</div>
              <div class="control-interno-seccion-desc">
                <div><strong>Qué se evalúa:</strong> {{ descripcionSeccionControlInterno(8).que }}</div>
                <div><strong>Cómo:</strong> {{ descripcionSeccionControlInterno(8).como }}</div>
              </div>
              <template v-if="esCorporativoControlInterno">
                <div
                  v-if="!editedControlInternoItem.retroalimentacion.personas.length"
                  class="text-body-2 text--secondary py-2"
                >
                  No hay personal del corporativo para entrevistar.
                </div>
                <v-expansion-panels v-else multiple flat class="control-interno-panels mb-4">
                  <v-expansion-panel
                    v-for="(persona, idxPersona) in editedControlInternoItem.retroalimentacion.personas"
                    :key="'corp-retro-' + idxPersona"
                  >
                    <v-expansion-panel-header class="py-1">
                      <div class="d-flex align-center flex-wrap" style="gap: 8px;">
                        <span class="font-weight-bold">{{ persona.nombre || 'Persona ' + (idxPersona + 1) }}</span>
                        <span v-if="persona.puesto" class="text-caption text--secondary">{{ persona.puesto }}</span>
                        <v-chip
                          x-small
                          :dark="respuestasRetroPersonaControlInterno(persona) > 0"
                          :color="respuestasRetroPersonaControlInterno(persona) > 0 ? 'primary' : 'grey lighten-2'"
                        >
                          {{ respuestasRetroPersonaControlInterno(persona) }} / {{ preguntasRetroControlInterno.length }} respondidas
                        </v-chip>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-textarea
                        v-for="(pregunta, idxPregunta) in preguntasRetroControlInterno"
                        :key="'corp-p-' + idxPersona + '-' + idxPregunta"
                        v-model="persona['p' + (idxPregunta + 1)]"
                        :label="pregunta"
                        dense
                        filled
                        rows="2"
                        auto-grow
                        hide-details
                        class="mt-2"
                      ></v-textarea>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </template>
              <template v-else>
              <div
                v-for="(persona, idxPersona) in editedControlInternoItem.retroalimentacion.personas"
                :id="'ci-campo-retro-' + idxPersona"
                :key="'retro-' + idxPersona"
                class="mb-4 pa-3"
                style="border: 1px solid #e0e0e0; border-radius: 4px;"
              >
                <v-row dense>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      :value="persona.idUsuario"
                      :items="usuariosSelects"
                      :item-text="etiquetaUsuarioSelect"
                      item-value="idusuario"
                      label="Persona"
                      dense
                      filled
                      clearable
                      :hide-details="!erroresControlInterno['retro-' + idxPersona] && (persona.idUsuario != null || !persona.nombre)"
                      :hint="persona.idUsuario == null && persona.nombre ? 'Registrado anteriormente: ' + persona.nombre : ''"
                      :error-messages="erroresControlInterno['retro-' + idxPersona]"
                      persistent-hint
                      no-data-text="No hay datos"
                      @change="limpiarErrorControlInterno('retro-' + idxPersona); seleccionarPersonaRetroControlInterno(persona, $event)"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      :value="persona.puesto"
                      label="Puesto"
                      dense
                      filled
                      readonly
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col
                    v-for="(pregunta, idxPregunta) in preguntasRetroControlInterno"
                    :key="'p-' + idxPersona + '-' + idxPregunta"
                    cols="12"
                  >
                    <v-textarea
                      v-model="persona['p' + (idxPregunta + 1)]"
                      :label="pregunta"
                      dense
                      filled
                      rows="2"
                      auto-grow
                      hide-details
                      class="mt-2"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </div>
              <v-btn small tile color="primary" class="mb-4" @click="agregarPersonaRetroControlInterno">
                <v-icon left small>mdi-plus</v-icon>
                Agregar persona
              </v-btn>
              </template>

              <div class="font-weight-bold mt-2 mb-2">Observaciones:</div>
              <div class="control-interno-nivel mb-4">
                <div
                  v-for="grupo in escalaClimaControlInternoGrupos"
                  :key="grupo.campo"
                  class="control-interno-nivel-row"
                >
                  <strong>{{ grupo.label }}:</strong>
                  <v-checkbox
                    v-for="opcion in grupo.opciones"
                    :key="opcion"
                    :label="opcion"
                    :input-value="editedControlInternoItem.retroalimentacion[grupo.campo] === opcion"
                    class="control-interno-check control-interno-nivel-check"
                    hide-details
                    dense
                    @change="aplicarOpcionControlInterno(editedControlInternoItem.retroalimentacion, grupo.campo, opcion, $event)"
                  ></v-checkbox>
                </div>
              </div>

              <div class="control-interno-seccion-title mt-5">{{ numeroSeccionControlInterno(9) }}. CIERRE DE AUDITORÍA</div>
              <div class="control-interno-seccion-desc">
                <div><strong>Qué se evalúa:</strong> {{ descripcionSeccionControlInterno(9).que }}</div>
                <div><strong>Cómo:</strong> {{ descripcionSeccionControlInterno(9).como }}</div>
              </div>

              <div class="font-weight-bold mb-1">Hallazgos por departamento:</div>
              <div class="text-caption grey--text text--darken-1 mb-2">
                Agrega en cada departamento los comentarios que apliquen, con foto o video.
              </div>
              <div
                v-for="grupo in hallazgosDepartamentoControlInterno"
                :key="grupo.departamento"
                class="control-interno-hallazgo-depto"
              >
                <div class="d-flex align-center">
                  <span class="font-weight-medium">{{ grupo.departamento }}</span>
                  <v-spacer></v-spacer>
                  <v-btn
                    x-small
                    tile
                    color="primary"
                    @click="agregarComentarioHallazgoDepartamentoControlInterno(grupo)"
                  >
                    <v-icon x-small left>mdi-plus</v-icon>
                    Agregar comentario
                  </v-btn>
                </div>
                <template v-if="grupo.comentarios && grupo.comentarios.length">
                  <div
                    v-for="(comentario, index) in grupo.comentarios"
                    :key="comentario.id"
                    class="control-interno-hallazgo-comentario"
                  >
                    <div class="d-flex align-start">
                      <v-textarea
                        v-model="comentario.observacion"
                        label="Comentario"
                        rows="2"
                        auto-grow
                        filled
                        dense
                        hide-details
                        class="mr-2"
                      ></v-textarea>
                      <div class="text-no-wrap pt-2">
                        <v-progress-circular
                          v-if="subiendoEvidenciaControlInterno[comentario.id]"
                          indeterminate
                          size="20"
                          width="2"
                          color="primary"
                        ></v-progress-circular>
                        <template v-else>
                          <v-btn icon small color="primary" title="Tomar foto" @click="abrirSelectorEvidenciaControlInterno(comentario, 'foto')">
                            <v-icon small>mdi-camera</v-icon>
                          </v-btn>
                          <v-btn icon small color="deep-purple" title="Grabar video" @click="abrirSelectorEvidenciaControlInterno(comentario, 'video')">
                            <v-icon small>mdi-video</v-icon>
                          </v-btn>
                          <v-btn icon small color="teal" title="Subir desde archivos o galería" @click="abrirSelectorEvidenciaControlInterno(comentario, 'archivo')">
                            <v-icon small>mdi-paperclip</v-icon>
                          </v-btn>
                        </template>
                        <v-btn
                          icon
                          small
                          color="error"
                          title="Quitar comentario"
                          @click="quitarComentarioHallazgoDepartamentoControlInterno(grupo, index)"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <div v-if="comentario.evidencias && comentario.evidencias.length" class="control-interno-evidencias mt-2">
                      <div
                        v-for="(evidencia, indexEvidencia) in comentario.evidencias"
                        :key="evidencia.archivo"
                        class="control-interno-evidencia"
                      >
                        <a :href="urlEvidenciaControlInterno(evidencia)" target="_blank" rel="noopener">
                          <img
                            v-if="evidencia.tipo !== 'video'"
                            :src="urlEvidenciaControlInterno(evidencia)"
                            :alt="evidencia.nombre_original || 'Evidencia'"
                          />
                          <video
                            v-else
                            :src="urlEvidenciaControlInterno(evidencia)"
                            preload="metadata"
                            muted
                            playsinline
                          ></video>
                          <v-icon v-if="evidencia.tipo === 'video'" class="control-interno-evidencia-play" color="white">
                            mdi-play-circle
                          </v-icon>
                        </a>
                        <v-btn
                          icon
                          x-small
                          color="error"
                          class="control-interno-evidencia-quitar"
                          title="Quitar evidencia"
                          @click="quitarEvidenciaControlInterno(comentario, indexEvidencia)"
                        >
                          <v-icon x-small>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <div class="control-interno-seccion-title mt-5">
                {{ numeroSeccionControlInterno(10) }}. TICKETS RELACIONADOS (MANTENIMIENTO)
              </div>
              <div class="control-interno-seccion-desc">
                <div><strong>Qué se evalúa:</strong> {{ descripcionSeccionControlInterno(10).que }}</div>
                <div><strong>Cómo:</strong> {{ descripcionSeccionControlInterno(10).como }}</div>
              </div>
              <div class="d-flex align-center mb-2">
                <span class="text-caption grey--text text--darken-1">
                  Tickets de la sucursal dirigidos a Mantenimiento en estatus Asignado, Pendiente o Rechazado.
                </span>
                <v-spacer></v-spacer>
                <v-btn
                  x-small
                  tile
                  color="primary"
                  :loading="cargandoTicketsControlInterno"
                  :disabled="!editedControlInternoItem.idplantel"
                  @click="cargarTicketsControlInterno"
                >
                  <v-icon x-small left>mdi-refresh</v-icon>
                  Actualizar
                </v-btn>
              </div>
              <v-data-table
                :headers="headersTicketsControlInterno"
                :items="ticketsControlInterno"
                :loading="cargandoTicketsControlInterno"
                item-key="idticket"
                dense
                class="elevation-0 control-interno-tickets-table"
                :items-per-page="10"
                loading-text="Cargando tickets..."
                no-data-text="La sucursal no tiene tickets abiertos de Mantenimiento"
              >
                <template v-slot:item.fecha_apertura="{ item }">
                  {{ formatearFechaInput(item.fecha_apertura) }}
                </template>
                <template v-slot:item.motivo="{ item }">
                  <div class="control-interno-ticket-motivo">
                    <div v-if="item.tema || item.subtema" class="font-weight-medium">
                      {{ [item.tema, item.subtema].filter(Boolean).join(' / ') }}
                    </div>
                    {{ item.motivo }}
                  </div>
                </template>
                <template v-slot:item.nombre_responsable="{ item }">
                  {{ item.nombre_responsable || '-' }}
                  <div v-if="item.nombre_auxiliar" class="text-caption grey--text">
                    Auxiliar: {{ item.nombre_auxiliar }}
                  </div>
                </template>
                <template v-slot:item.estatus="{ item }">
                  <v-chip x-small dark :color="estatusTicketControlInterno(item.estatus).color">
                    {{ estatusTicketControlInterno(item.estatus).texto }}
                  </v-chip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="control-interno-modal-actions">
          <v-btn color="black" tile dark small class="control-interno-action-btn" @click="closeControlInterno">
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            tile
            dark
            small
            class="control-interno-action-btn"
            :disabled="cargar || guardandoControlInterno"
            :loading="guardandoControlInterno"
            @click="saveControlInterno"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogFirmaControlInterno"
      max-width="800px"
      transition="dialog-transition"
      persistent
    >
      <v-card outlined>
        <v-card-title class="text-subtitle-1">
          Firmar: {{ tituloFirmaControlInterno }}
          <v-spacer></v-spacer>
          <v-btn icon small @click="cerrarDialogFirmaControlInterno">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <div class="px-2">
          <canvas
            id="signature-pad-control-interno"
            class="signature-pad control-interno-signature-pad"
            width="780"
            height="250"
          ></canvas>
        </div>
        <v-card-actions>
          <v-btn color="primary" small class="mr-2" @click="guardarFirmaControlInterno">
            Guardar firma
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="primary" small @click="limpiarFirmaControlInterno">
            Limpiar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogProgramarControlInterno" max-width="640px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">
            {{ programarControlInternoEsEdicion ? 'Editar auditoría de sucursal' : 'Programar auditoría de sucursal' }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-autocomplete
                v-model="programarControlInternoItem.id_plantel"
                :items="planteles"
                item-text="plantel"
                item-value="idplantel"
                label="Plantel / Sucursal"
                filled
                dense
                clearable
                :disabled="programarControlInternoEsEdicion"
                no-data-text="No hay datos"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="programarControlInternoItem.id_auditor"
                :items="usuariosSelects"
                :item-text="etiquetaUsuarioSelect"
                item-value="idusuario"
                label="Quién va a auditar"
                filled
                dense
                clearable
                no-data-text="No hay datos"
              ></v-autocomplete>
            </v-col>
            <v-col v-if="!programarControlInternoEsEdicion" cols="12">
              <v-autocomplete
                v-model="programarControlInternoItem.id_responsable_plantel"
                :items="usuariosSelects"
                :item-text="etiquetaUsuarioSelect"
                item-value="idusuario"
                label="Responsable del plantel (opcional)"
                filled
                dense
                clearable
                no-data-text="No hay datos"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" :md="programarControlInternoEsEdicion ? 12 : 6">
              <v-text-field
                v-model="programarControlInternoItem.fecha_programada"
                type="date"
                label="Fecha de auditoría"
                filled
                dense
              ></v-text-field>
            </v-col>
            <v-col v-if="!programarControlInternoEsEdicion" cols="6" md="3">
              <v-text-field
                v-model="programarControlInternoItem.hora_inicio"
                type="time"
                label="Hora inicio"
                filled
                dense
              ></v-text-field>
            </v-col>
            <v-col v-if="!programarControlInternoEsEdicion" cols="6" md="3">
              <v-text-field
                v-model="programarControlInternoItem.hora_termino"
                type="time"
                label="Hora término"
                filled
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="black" dark small tile @click="closeDialogProgramarControlInterno">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="deep-purple"
            dark
            small
            tile
            :disabled="cargar || guardandoProgramarControlInterno"
            :loading="guardandoProgramarControlInterno"
            @click="saveProgramarControlInterno"
          >
            {{ programarControlInternoEsEdicion ? 'Guardar' : 'Programar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import SignaturePad from 'signature_pad'
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'
import funcionesExcel from '@/mixins/funcionesExcel'

const TIPOS_AUDITORIA = [
  { id: 1, nombre: 'Inicial' },
  { id: 2, nombre: 'Seguimiento' }
]

const ESTATUS_VALIDOS = ['Inicial', 'Seguimiento']
const CALIFICACIONES_VALIDAS = ['1 - No cumple', '2 - Parcial', '3 - Cumple totalmente', 'N/A']
const EVIDENCIA_FOTO_MARKER = '[FOTO_BASE64]'

const CRITERIOS_BASE = [
  {
    id: 1,
    idVisual: '1.1',
    seccion: '1.0 PLANIFICACIÓN (Documentación)',
    nombre: '¿Existe un diagrama de flujo o manual actualizado del proceso?',
    descripcion: ''
  },
  {
    id: 2,
    idVisual: '1.2',
    seccion: '1.0 PLANIFICACIÓN (Documentación)',
    nombre: '¿El personal conoce sus responsabilidades dentro del flujo?',
    descripcion: ''
  },
  {
    id: 3,
    idVisual: '2.1',
    seccion: '2.0 EJECUCIÓN (Trazabilidad)',
    nombre: '¿Se cuenta con evidencia (firmas, documentos, tickets) de cada paso?',
    descripcion: ''
  },
  {
    id: 4,
    idVisual: '2.2',
    seccion: '2.0 EJECUCIÓN (Trazabilidad)',
    nombre: '¿Los tiempos de ejecución coinciden con los estándares establecidos?',
    descripcion: ''
  },
  {
    id: 5,
    idVisual: '2.3',
    seccion: '2.0 EJECUCIÓN (Trazabilidad)',
    nombre: '¿El entorno de trabajo cumple con el estándar de orden (5S)?',
    descripcion: ''
  },
  {
    id: 6,
    idVisual: '3.1',
    seccion: '3.0 VERIFICACIÓN (Puntos de Control)',
    nombre: '¿Se realizan las validaciones/autorizaciones previas al cierre?',
    descripcion: ''
  },
  {
    id: 7,
    idVisual: '3.2',
    seccion: '3.0 VERIFICACIÓN (Puntos de Control)',
    nombre: '¿Se miden indicadores de desempeño (KPIs) en este proceso?',
    descripcion: ''
  },
  {
    id: 8,
    idVisual: '4.1',
    seccion: '4.0 ACTUACIÓN (Mejora)',
    nombre: '¿Se han corregido errores detectados en auditorías previas?',
    descripcion: ''
  },
  {
    id: 9,
    idVisual: '4.2',
    seccion: '4.0 ACTUACIÓN (Mejora)',
    nombre: '¿Existen propuestas documentadas para optimizar el proceso?',
    descripcion: ''
  }
]

const OBJETIVO_CONTROL_INTERNO =
  'Verificar que la sucursal opere según los estándares de INBI/Fast English en tres frentes: los salones donde se imparte la clase, las personas que atienden y enseñan, y la sucursal como unidad de negocio. Con esto se asegura una experiencia consistente para el alumno, se detectan desviaciones a tiempo y se generan acciones correctivas medibles.'

const DEPARTAMENTO_CONTROL_INTERNO = 'Operaciones'

const MAX_MB_EVIDENCIA_CONTROL_INTERNO = 200

const CRITERIOS_CONTROL_INTERNO_BASE = [
  {
    id: 1,
    seccion: '1. INSTALACIONES',
    criterio: 'Fachada (limpieza, buena imagen)'
  },
  {
    id: 2,
    seccion: '1. INSTALACIONES',
    criterio: 'Baños (limpieza, insumos, funcionamiento)'
  },
  {
    id: 4,
    seccion: '1. INSTALACIONES',
    criterio: 'Recepción (equipo funcionando correctamente, espacio limpio y ordenado)'
  },
  {
    id: 5,
    seccion: '1. INSTALACIONES',
    criterio: 'Estado general de mantenimiento (desgaste, daños visibles)'
  }
]

const CAMPOS_SALON_CONTROL_INTERNO = ['bancos', 'proyector', 'iluminacion', 'clima', 'pintura']

function crearSalonControlInterno(datos, index) {
  const origen = datos || {}
  const salon = origen.salon != null && !Number.isNaN(Number(origen.salon)) ? Number(origen.salon) : index + 1
  const fila = {
    // `id` solo identifica la fila para el estado de subida de evidencias
    id: 'salon-' + salon,
    salon,
    id_salon: origen.id_salon != null ? origen.id_salon : null,
    nombre: origen.nombre || '',
    evidencias: Array.isArray(origen.evidencias)
      ? origen.evidencias.filter((evidencia) => evidencia && evidencia.archivo).map((evidencia) => ({ ...evidencia }))
      : []
  }
  CAMPOS_SALON_CONTROL_INTERNO.forEach((campo) => {
    fila[campo] = !!origen[campo]
  })
  return fila
}

const CORTE_CONTROL_INTERNO_BASE = [
  '(Encargada) Supervisión de cortes',
  '(Encargada) Validación de ingresos y egresos',
  '(Encargada) Control de incidencias',
  '(Recepción) Corte realizado y enviado correctamente',
  '(Recepción) Coincidencia de ingresos y egresos',
  '(Recepción) Control de recibos y pagos'
].map((criterio, index) => ({ id: index + 1, criterio, resultado: null }))

// No todas las sucursales los tienen: si no aplica, la fila no se guarda ni cuenta para el puntaje
const PERSONAL_OPCIONAL_CONTROL_INTERNO = ['Recepción #3']

const VESTIMENTA_CONTROL_INTERNO_BASE = [
  'Encargada',
  'Recepción',
  'Recepción #2',
  'Recepción #3',
  'Vendedora',
  'Limpieza',
  'Staff Extra'
].map((personal) => ({
  personal,
  aplica: PERSONAL_OPCIONAL_CONTROL_INTERNO.indexOf(personal) === -1,
  idUsuarioEvaluado: null,
  uniformeCorrecto: null,
  presentacionProfesional: null,
  antecedentesDisciplinarios: null,
  antecedentesCantidad: null,
  cumpleHorario: null,
  permaneceArea: null
}))

// Campo `escuela` de la tabla plantel
const NOMBRES_ESCUELA_CONTROL_INTERNO = { 1: 'INBI', 2: 'FAST' }

const OPCIONES_ESCUELA_CONTROL_INTERNO = [
  { text: 'Todas', value: null },
  { text: 'INBI', value: 1 },
  { text: 'FAST', value: 2 }
]

// Debe coincidir con calcularResultadoControlInterno en api-rh (models/auditorias.model.js)
const PONDERACION_CONTROL_INTERNO = [
  { seccion: '1. Instalaciones', casillas: '4' },
  { seccion: '2. Salones', casillas: '5 por salón' },
  { seccion: '3. Corte', casillas: '6' },
  { seccion: '4 y 5. Encargada y Recepción (vestimenta + puntualidad)', casillas: '5 por persona' },
  { seccion: '4. Recepción #2 y #3, Vendedora y Limpieza', casillas: '3 por persona' },
  { seccion: '4. Teachers', casillas: '7 por teacher' },
  { seccion: '6. RI y atención al alumno', casillas: '3 + 5' },
  { seccion: '7. Metodología 5S', casillas: '5' },
  { seccion: 'Corporativos: Instalaciones', casillas: '4' },
  { seccion: 'Corporativos: Oficinas', casillas: '6 por oficina' },
  { seccion: 'Corporativos: Vestimenta', casillas: '3 por persona' },
  { seccion: 'Corporativos: 5S', casillas: '5 por oficina' }
]

const DESCRIPCIONES_SECCIONES_CONTROL_INTERNO = {
  1: {
    que: 'Imagen y condiciones físicas de la sucursal: fachada, baños, recepción y estado general de mantenimiento.',
    como: 'Recorre cada área y marca Cumple o No cumple. Adjunta foto o video de lo observado, sobre todo cuando no cumple.'
  },
  2: {
    que: 'Condición de cada salón activo de la sucursal: bancos, proyector, iluminación, clima (A/C) y pintura.',
    como: 'Revisa salón por salón y marca cada elemento que esté en buen estado y funcionando. Cada salón requiere al menos una foto o video para cerrar la auditoría.'
  },
  3: {
    que: 'Control del corte de caja por parte de la Encargada y de Recepción.',
    como: 'Selecciona a la encargada y a la recepción del turno y valida contra el corte del día que ingresos, egresos, recibos e incidencias coincidan y estén documentados.'
  },
  4: {
    que: 'Uso correcto del uniforme y presentación profesional del personal: encargada, recepción, vendedora, limpieza y teachers.',
    como: 'Selecciona a la persona evaluada y marca Cumple, No cumple o Ausente (Ausente no cuenta para el puntaje). Si la sucursal no tiene Recepción #3, márcala como No aplica. "Cuántos" se llena solo con las actas administrativas e incidencias registradas de la persona (se puede corregir). Con "Agregar teacher" evalúa también si está sentado, la impartición de la clase, si la imparte únicamente en inglés y si llega puntual.'
  },
  5: {
    que: 'Cumplimiento de horario y permanencia en su área de la Encargada y de Recepción.',
    como: 'Compara la hora de llegada contra su horario y observa si permanecen en su área durante la visita.'
  },
  6: {
    que: 'Seguimiento a reinscripciones y calidad de atención al alumno por parte de la Encargada y de Recepción.',
    como: 'Selecciona a la persona evaluada, revisa mensajes, tickets, seguimiento académico y comentarios en panel, y observa la atención a alumnos durante la visita.'
  },
  7: {
    que: 'Orden y limpieza de las áreas de trabajo con la metodología 5S: clasificación, orden, limpieza, estandarización y disciplina.',
    como: 'Revisa cada pilar en recepción, oficinas y almacén; marca Cumple o No cumple y anota la evidencia o acción correctiva.'
  },
  8: {
    que: 'Clima laboral y percepción del personal. No suma al puntaje.',
    como: 'Entrevista en privado a cada persona con las preguntas guía, registra sus respuestas y al final califica clima, comunicación, organización de turnos, liderazgo y operación.'
  },
  9: {
    que: 'Hallazgos de la visita que requieren atención de otros departamentos. No suma al puntaje.',
    como: 'Agrega comentarios en el departamento responsable con foto o video de soporte y recaba las firmas del auditor y del responsable del plantel.'
  },
  10: {
    que: 'Tickets abiertos de Mantenimiento de la sucursal (Asignado, Pendiente o Rechazado). No suma al puntaje.',
    como: 'Solo consulta: compáralos con lo observado en Instalaciones y Salones para identificar pendientes ya reportados.'
  }
}

// Corporativos: reemplazan la descripción de la sección original con el mismo número
const DESCRIPCIONES_SECCIONES_CORPORATIVO_CONTROL_INTERNO = {
  2: {
    que: 'Condición de cada oficina del corporativo: limpieza, orden, mobiliario, equipo de cómputo, iluminación y clima (A/C).',
    como: 'Agrega cada oficina eligiendo su departamento y marca Cumple o No cumple en cada criterio. La foto o video es opcional.'
  },
  4: {
    que: 'Uso correcto del uniforme y presentación profesional del personal del corporativo.',
    como: 'La lista sale de los trabajadores activos asignados a este corporativo en el ERP. Despliega a cada persona y marca Cumple, No cumple o Ausente (Ausente no cuenta para el puntaje).'
  },
  7: {
    que: 'Orden y limpieza de cada oficina con la metodología 5S: clasificación, orden, limpieza, estandarización y disciplina.',
    como: 'Por cada oficina agregada en la sección de Oficinas, marca Cumple o No cumple en los 5 pilares y anota la evidencia o acción correctiva.'
  },
  8: {
    que: 'Clima laboral y percepción del personal del corporativo. No suma al puntaje.',
    como: 'Despliega a cada persona, entrevístala en privado con las preguntas guía y registra sus respuestas. Al final califica clima, comunicación, organización, liderazgo y operación.'
  }
}

// Número que se muestra en el corporativo para cada sección original (Corte, Puntualidad y RI no aplican)
const NUMERO_SECCION_CORPORATIVO_CONTROL_INTERNO = { 1: 1, 2: 2, 4: 3, 7: 4, 8: 5, 9: 6, 10: 7 }

const PERSONAL_PUNTUALIDAD_CONTROL_INTERNO = ['Encargada', 'Recepción']

const OPCIONES_VESTIMENTA_CONTROL_INTERNO = [
  { valor: true, label: 'Cumple' },
  { valor: false, label: 'No cumple' },
  { valor: 'Ausente', label: 'Ausente' }
]

const CRITERIOS_VESTIMENTA_CONTROL_INTERNO = [
  { campo: 'uniformeCorrecto', label: 'Uso correcto de uniforme' },
  { campo: 'presentacionProfesional', label: 'Presentación profesional' },
  {
    campo: 'antecedentesDisciplinarios',
    label: 'Antecedentes disciplinarios/incidencias',
    campoCantidad: 'antecedentesCantidad'
  }
]

const CRITERIOS_TEACHER_CONTROL_INTERNO = [
  ...CRITERIOS_VESTIMENTA_CONTROL_INTERNO,
  { campo: 'sentado', label: 'Sentado' },
  { campo: 'imparticionClases', label: 'Impartición de clases' },
  { campo: 'soloIngles', label: 'Imparte clases únicamente en inglés' },
  { campo: 'puntualClases', label: 'Llega puntual a sus clases' }
]

function crearTeacherVestimentaControlInterno(datos) {
  const origen = datos || {}
  const teacher = { idUsuarioEvaluado: origen.idUsuarioEvaluado != null ? origen.idUsuarioEvaluado : null }
  CRITERIOS_TEACHER_CONTROL_INTERNO.forEach((criterio) => {
    teacher[criterio.campo] = origen[criterio.campo] != null ? origen[criterio.campo] : null
    if (criterio.campoCantidad) {
      teacher[criterio.campoCantidad] = origen[criterio.campoCantidad] != null ? origen[criterio.campoCantidad] : null
    }
  })
  return teacher
}

const ETIQUETAS_5S_CONTROL_INTERNO = {
  1: 'Clasificación (Seiri)',
  2: 'Orden (Seiton)',
  3: 'Limpieza (Seiso)',
  4: 'Estandarización (Seiketsu)',
  5: 'Disciplina (Shitsuke)'
}

const RI_ENCARGADA_CONTROL_INTERNO_BASE = [
  'Seguimiento a actividades de recepción (mensajes, tickets, seguimiento académico)',
  'Supervisión de atención en tiempo y forma',
  'Supervisión de calidad en atención al cliente'
].map((criterio, index) => ({ id: index + 1, criterio, resultado: null }))

const RI_RECEPCION_CONTROL_INTERNO_BASE = [
  'Atención de mensajes en tiempo y forma',
  'Atención correcta de tickets',
  'Seguimiento a alumnos (académico y reprobados)',
  'Registro y atención de comentarios en panel',
  'Atención al cliente cordial y efectiva'
].map((criterio, index) => ({ id: index + 1, criterio, resultado: null }))

const METODOLOGIA_5S_CONTROL_INTERNO_BASE = [
  {
    id: 1,
    pilar: '1. Seiri (Clasificación)',
    criterioRevision: 'No hay objetos o documentos innecesarios en las áreas de trabajo.'
  },
  {
    id: 2,
    pilar: '2. Seiton (Orden)',
    criterioRevision: 'Todo equipo, insumo y archivo tiene un lugar asignado e identificado.'
  },
  {
    id: 3,
    pilar: '3. Seiso (Limpieza)',
    criterioRevision: 'Áreas operativas libres de polvo, basura o derrames.'
  },
  {
    id: 4,
    pilar: '4. Seiketsu (Estandarización)',
    criterioRevision: 'Existen ayudas visuales o señalamientos claros; se siguen los procesos.'
  },
  {
    id: 5,
    pilar: '5. Shitsuke (Disciplina)',
    criterioRevision: 'El equipo respeta y mantiene las 4S anteriores proactivamente.'
  }
].map((item) => ({ ...item, resultado: null, evidenciaAccion: '' }))

const NIVEL_GENERAL_CONTROL_INTERNO_OPCIONES = {
  nivelGeneral: ['Óptimo', 'Funcional', 'Crítico'],
  climaGeneral: ['Positivo', 'Neutro', 'Negativo'],
  comunicacion: ['Buena', 'Regular', 'Deficiente'],
  organizacionTurnos: ['Clara', 'Parcial', 'Deficiente'],
  liderazgo: ['Adecuado', 'Área de mejora', 'Deficiente'],
  operacion: ['Sólida', 'Con fallas', 'Crítica']
}

function crearDefaultItem() {
  return {
    id: null,
    departamento: null,
    idplantel: null,
    tipoAuditoria: null,
    auditor: null,
    jefeDepartamento: null,
    fecha: null,
    estatus: 'Inicial',
    estatusModalidad: 'Inicial',
    procesoAuditado: '',
    hallazgos: '',
    hallazgo1: '',
    hallazgo2: '',
    hallazgo3: '',
    accionCorrectiva: '',
    responsable: null,
    fechaCompromiso: null,
    evidenciaCierre: ''
  }
}

const ESTATUS_CONTROL_INTERNO = ['Programada', 'En curso', 'Cerrada']
const ESTATUS_AUDITORIA_SUCURSAL = ['Auditado', 'No auditado']

const PREGUNTAS_RETRO_CONTROL_INTERNO = [
  '¿Cómo te sientes trabajando en el plantel actualmente?',
  '¿Qué tal te llevas con el equipo y cómo se organizan entre turnos?',
  '¿Sientes apoyo cuando lo necesitas?',
  '¿Te sientes cómodo/a con tus procesos (RI, atención, corte)?',
  '¿Hay algo que se te complique en tu día a día?',
  '¿Sientes que te da tiempo de realizar tus actividades?',
  '¿Te has sentido incómodo/a o has vivido alguna situación de trato inadecuado con alguien del equipo o liderazgo?',
  'Si pudieras cambiar algo, ¿qué sería?'
]

function crearDefaultPersonaRetroControlInterno() {
  return {
    idUsuario: null,
    nombre: '',
    puesto: '',
    p1: '',
    p2: '',
    p3: '',
    p4: '',
    p5: '',
    p6: '',
    p7: '',
    p8: ''
  }
}

function crearDefaultRetroalimentacionControlInterno() {
  return {
    personas: [crearDefaultPersonaRetroControlInterno(), crearDefaultPersonaRetroControlInterno()],
    climaGeneral: null,
    comunicacion: null,
    organizacionTurnos: null,
    liderazgo: null,
    operacion: null
  }
}

function crearDefaultControlInternoItem() {
  return {
    id: null,
    objetivo: '',
    departamento: null,
    dirigidoA: null,
    idplantel: null,
    id_ciclo: null,
    responsablePlantel: null,
    idAuditor: null,
    fechaAuditoria: null,
    fechaProgramada: null,
    horaInicio: null,
    horaTermino: null,
    estatus: 'En curso',
    criterios: clonarCriteriosControlInterno(),
    salones: [],
    oficinas: [],
    observacionesSalones: '',
    corte: crearDefaultCorteControlInterno(),
    vestimenta: crearDefaultVestimentaControlInterno(),
    riAtencionAlumno: crearDefaultRiAtencionAlumnoControlInterno(),
    metodologia5s: crearDefaultMetodologia5sControlInterno(),
    retroalimentacion: crearDefaultRetroalimentacionControlInterno(),
    cierreAuditoria: crearDefaultCierreAuditoriaControlInterno()
  }
}

function clonarCriteriosControlInterno() {
  return CRITERIOS_CONTROL_INTERNO_BASE.map((item) => ({
    ...item,
    resultado: null,
    evidencias: []
  }))
}

function clonarCriteriosResultado(lista) {
  return lista.map((item) => ({ ...item }))
}

function crearDefaultCorteControlInterno() {
  return {
    encargada: '',
    recepcionTurno: '',
    criterios: clonarCriteriosResultado(CORTE_CONTROL_INTERNO_BASE),
    observaciones: ''
  }
}

function crearDefaultVestimentaControlInterno() {
  return {
    filas: VESTIMENTA_CONTROL_INTERNO_BASE.map((item) => ({ ...item })),
    teachers: [],
    corporativo: [],
    observaciones: '',
    observacionesPuntualidad: ''
  }
}

function crearDefaultRiAtencionAlumnoControlInterno() {
  return {
    encargada: '',
    recepcion: '',
    encargadaCriterios: clonarCriteriosResultado(RI_ENCARGADA_CONTROL_INTERNO_BASE),
    encargadaObservaciones: '',
    recepcionCriterios: clonarCriteriosResultado(RI_RECEPCION_CONTROL_INTERNO_BASE),
    recepcionObservaciones: ''
  }
}

function crearDefaultMetodologia5sControlInterno() {
  return {
    criterios: clonarCriteriosResultado(METODOLOGIA_5S_CONTROL_INTERNO_BASE)
  }
}

// idplantel de los corporativos (mismo id en erp_db y KPI): se auditan por oficinas y personal
const IDS_CORPORATIVO_CONTROL_INTERNO = [13, 10016]

const CRITERIOS_OFICINA_CONTROL_INTERNO = [
  'Limpieza',
  'Orden',
  'Mobiliario',
  'Equipo de cómputo',
  'Iluminación',
  'Clima (A/C)'
].map((criterio, index) => ({ id: index + 1, criterio, resultado: null }))

// La tabla de vestimenta exige `personal` único por auditoría: "Corporativo:<iderp>:<nombre>"
const PREFIJO_PERSONAL_CORPORATIVO_CONTROL_INTERNO = 'Corporativo:'

function esPlantelCorporativoControlInterno(idPlantel) {
  return IDS_CORPORATIVO_CONTROL_INTERNO.indexOf(Number(idPlantel)) !== -1
}

let contadorOficinaControlInterno = 0

function crearOficinaControlInterno(datos) {
  const origen = datos || {}
  const porId = (lista) => {
    const mapa = {}
    ;(Array.isArray(lista) ? lista : []).forEach((item) => {
      if (item && item.id != null) mapa[String(item.id)] = item
    })
    return mapa
  }
  const criterios = porId(origen.criterios)
  const criterios5s = porId(origen.criterios5s)
  contadorOficinaControlInterno += 1
  return {
    // `id` solo identifica la oficina para el estado de subida de evidencias
    id: 'oficina-' + contadorOficinaControlInterno,
    departamento: origen.departamento || '',
    criterios: CRITERIOS_OFICINA_CONTROL_INTERNO.map((base) => ({
      ...base,
      resultado: criterios[base.id] ? criterios[base.id].resultado || null : null
    })),
    criterios5s: METODOLOGIA_5S_CONTROL_INTERNO_BASE.map((base) => ({
      ...base,
      resultado: criterios5s[base.id] ? criterios5s[base.id].resultado || null : null,
      evidenciaAccion: criterios5s[base.id] ? criterios5s[base.id].evidenciaAccion || '' : ''
    })),
    evidencias: Array.isArray(origen.evidencias)
      ? origen.evidencias.filter((evidencia) => evidencia && evidencia.archivo).map((evidencia) => ({ ...evidencia }))
      : []
  }
}

function crearPersonaCorporativoControlInterno(datos) {
  const origen = datos || {}
  return {
    iderp: origen.iderp != null && origen.iderp !== '' ? Number(origen.iderp) : null,
    idUsuario: origen.idUsuario != null ? origen.idUsuario : origen.idusuario != null ? origen.idusuario : null,
    nombre: origen.nombre || origen.nombre_completo || '',
    puesto: origen.puesto || '',
    departamento: origen.departamento || '',
    uniformeCorrecto: origen.uniformeCorrecto != null ? origen.uniformeCorrecto : null,
    presentacionProfesional: origen.presentacionProfesional != null ? origen.presentacionProfesional : null,
    antecedentesDisciplinarios: origen.antecedentesDisciplinarios != null ? origen.antecedentesDisciplinarios : null,
    antecedentesCantidad: origen.antecedentesCantidad != null ? origen.antecedentesCantidad : null
  }
}

function personaCorporativoDesdeFilaVestimenta(fila) {
  const partes = String(fila.personal || '')
    .slice(PREFIJO_PERSONAL_CORPORATIVO_CONTROL_INTERNO.length)
    .split(':')
  return crearPersonaCorporativoControlInterno({
    iderp: partes[0],
    nombre: partes.slice(1).join(':'),
    idUsuario: fila.idUsuarioEvaluado,
    uniformeCorrecto: fila.uniformeCorrecto,
    presentacionProfesional: fila.presentacionProfesional,
    antecedentesDisciplinarios: fila.antecedentesDisciplinarios,
    antecedentesCantidad: fila.antecedentesCantidad
  })
}

function crearFilasObservacionesControlInterno(cantidad) {
  return Array.from({ length: cantidad }, () => ({
    observacion: '',
    departamento: ''
  }))
}

let contadorHallazgoDepartamentoControlInterno = 0

function crearComentarioHallazgoDepartamentoControlInterno(datos) {
  const item = datos || {}
  contadorHallazgoDepartamentoControlInterno += 1
  return {
    id: 'hallazgo-' + contadorHallazgoDepartamentoControlInterno,
    observacion: item.observacion || '',
    evidencias: Array.isArray(item.evidencias)
      ? item.evidencias
          .filter((evidencia) => evidencia && evidencia.archivo)
          .map((evidencia) => ({
            archivo: evidencia.archivo,
            tipo: evidencia.tipo === 'video' ? 'video' : 'imagen',
            nombre_original: evidencia.nombre_original || ''
          }))
      : []
  }
}

function crearDefaultCierreAuditoriaControlInterno() {
  return {
    principalesHallazgos: crearFilasObservacionesControlInterno(2),
    hallazgosDepartamento: [],
    areasOportunidad: crearFilasObservacionesControlInterno(2),
    fortalezasDetectadas: crearFilasObservacionesControlInterno(2),
    nivelGeneral: null,
    auditorFirma: '',
    responsablePlantelFirma: '',
    fechaFirma: null
  }
}

function clonarCriteriosBase() {
  return CRITERIOS_BASE.map((item) => ({
    id: item.id,
    idVisual: item.idVisual,
    id_criterio_catalogo: item.id,
    seccion: item.seccion,
    nombre: item.nombre,
    descripcion: item.descripcion,
    calificacion: null,
    evidencia: '',
    evidencia_hallazgo: ''
  }))
}

/** Texto de pregunta PHVA alineado a CRITERIOS_BASE (evita nombres viejos del catálogo API). */
function textoPreguntaCanonicaCriterio(criterio) {
  if (!criterio) return ''
  const vis = String(criterio.idVisual || '').trim()
  if (vis) {
    const porVisual = CRITERIOS_BASE.find((row) => row.idVisual === vis)
    if (porVisual && porVisual.nombre) return porVisual.nombre
  }
  const id = criterio.id != null ? Number(criterio.id) : null
  const idCat =
    criterio.id_criterio_catalogo != null ? Number(criterio.id_criterio_catalogo) : null
  const porId =
    (id != null && !Number.isNaN(id) && CRITERIOS_BASE.find((row) => row.id === id)) ||
    (idCat != null && !Number.isNaN(idCat) && CRITERIOS_BASE.find((row) => row.id === idCat))
  if (porId && porId.nombre) return porId.nombre
  return ''
}

export default {
  name: 'Auditoria',

  mixins: [validarErrores, funcionesExcel],

  components: {
    Alerta,
    carga
  },

  data() {
    return {
      parametros: {
        dialogError: false,
        mensaje: '',
        color: ''
      },
      respuestaAlerta: false,
      cargar: false,
      cargandoAuditorias: false,
      auditoriaTab: 0,
      dialog: false,
      dialogControlInterno: false,
      editedIndex: -1,
      editedControlInternoIndex: -1,
      acceso: true,
      fechaMaxima: new Date().toISOString().slice(0, 10),
      tiposAuditoria: TIPOS_AUDITORIA,
      auditorias: [],
      controlInternoAuditorias: [],
      reporteAuditorias: [],
      departamentos: [],
      planteles: [],
      usuariosCatalogo: [],
      /** true si respondió GET /catalogs/usuarios/auditoria (el backend puede mandar solo idusuario sin campo iderp). */
      usuariosCatalogoEsEndpointAuditoria: false,
      usuariosAll: [],
      usuariosAllErp: [],
      idsUsuariosInactivos: {},
      idsUsuariosPermitidosEnSelects: {},
      fotosEvidenciaPhva: {},
      evidenciasGeneralesPhva: {},
      fotosEvidenciaGeneralesPhva: {},
      criteriosPlantilla: [],
      criterios: clonarCriteriosBase(),
      ciclos: [],
      cargandoControlInternoCiclo: false,
      filtros: {
        tipoAuditoria: null,
        fechaini: null,
        fechafin: null,
        id_ciclo: null,
        escuela: null,
        colaborador: null,
        departamento: null,
        plantel: null,
        estatus: null,
        search: ''
      },
      editedItem: crearDefaultItem(),
      defaultItem: crearDefaultItem(),
      editedControlInternoItem: crearDefaultControlInternoItem(),
      defaultControlInternoItem: crearDefaultControlInternoItem(),
      headers: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'Evalúa', value: 'auditor' },
        { text: 'Evaluado', value: 'departamento' },
        { text: 'Plantel', value: 'nombrePlantel' },
        { text: 'Promedio', value: 'resultadoPorcentaje', align: 'end' },
        { text: 'Concepto', value: 'tipoAuditoria', sortable: false },
        { text: 'Estatus', value: 'estatus', sortable: false },
        { text: 'Acciones', value: 'actions', sortable: false, align: 'center' }
      ],
      headersControlInterno: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'Objetivo', value: 'objetivo' },
        { text: 'Plantel', value: 'nombrePlantel' },
        { text: 'Auditor', value: 'nombreAuditor' },
        { text: 'Fecha programada', value: 'fechaProgramada' },
        { text: 'Fecha de auditoría', value: 'fechaAuditoria' },
        { text: 'Estatus', value: 'estatus', sortable: false },
        { text: 'Acciones', value: 'actions', sortable: false, align: 'center' }
      ],
      headersControlInternoCiclo: [
        { text: 'Sucursal', value: 'nombrePlantel' },
        { text: 'Escuela', value: 'nombreEscuela' },
        { text: 'Fecha de auditoría', value: 'fechaAuditoria' },
        { text: 'Auditor', value: 'nombreAuditor' },
        { text: 'Puntaje', value: 'puntaje', align: 'end' },
        { text: 'Calificación', value: 'calificacion', align: 'end' },
        { text: 'Estatus', value: 'estatusAuditado', sortable: false },
        { text: 'Acciones', value: 'actions', sortable: false, align: 'center' }
      ],
      dialogProgramarControlInterno: false,
      dialogFirmaControlInterno: false,
      campoFirmaControlInterno: null,
      signaturePadControlInterno: null,
      guardandoControlInterno: false,
      guardandoProgramarControlInterno: false,
      subiendoEvidenciaControlInterno: {},
      cargandoSalonesControlInterno: false,
      solicitudSalonesControlInterno: 0,
      erroresControlInterno: {},
      ticketsControlInterno: [],
      cargandoTicketsControlInterno: false,
      solicitudTicketsControlInterno: 0,
      cargandoPersonalCorporativoControlInterno: false,
      solicitudPersonalCorporativoControlInterno: 0,
      headersTicketsControlInterno: [
        { text: 'Ticket', value: 'idticket', width: 80 },
        { text: 'Apertura', value: 'fecha_apertura', width: 110 },
        { text: 'Motivo', value: 'motivo', sortable: false },
        { text: 'Responsable', value: 'nombre_responsable', width: 160 },
        { text: 'Días', value: 'dias_abierto', align: 'center', width: 70 },
        { text: 'Estatus', value: 'estatus', width: 110 }
      ],
      criterioEvidenciaControlInterno: null,
      programarControlInternoItem: {
        id: null,
        esEdicion: false,
        id_plantel: null,
        id_auditor: null,
        fecha_programada: null,
        hora_inicio: null,
        hora_termino: null,
        id_responsable_plantel: null
      }
    }
  },

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),

    formTitle() {
      return this.editedIndex === -1 ? 'Nueva Auditoría' : 'Editar Auditoría'
    },

    controlInternoFormTitle() {
      return this.editedControlInternoIndex === -1 ? 'Nueva Auditoría de Control Interno' : 'Editar Auditoría de Control Interno'
    },

    objetivoControlInterno() {
      return OBJETIVO_CONTROL_INTERNO
    },

    hallazgosDepartamentoControlInterno() {
      const cierre = this.editedControlInternoItem && this.editedControlInternoItem.cierreAuditoria
      return cierre && Array.isArray(cierre.hallazgosDepartamento) ? cierre.hallazgosDepartamento : []
    },

    programarControlInternoEsEdicion() {
      return !!(this.programarControlInternoItem && this.programarControlInternoItem.esEdicion)
    },

    departamentoOperaciones() {
      const objetivo = this.normalizarTexto(DEPARTAMENTO_CONTROL_INTERNO)
      const lista = this.departamentos || []
      return (
        lista.find((item) => this.normalizarTexto(item && item.nombre) === objetivo) ||
        lista.find((item) => this.normalizarTexto(item && item.nombre).indexOf(objetivo) !== -1) ||
        null
      )
    },

    nombreDepartamentoOperaciones() {
      return this.departamentoOperaciones ? this.departamentoOperaciones.nombre : DEPARTAMENTO_CONTROL_INTERNO
    },

    nombreAuditorControlInterno() {
      const idAuditor = this.editedControlInternoItem.idAuditor
      const sesion = this.getdatosUsuarioERPERP || {}
      const idSesion = this.obtenerIdSesion()
      if (idAuditor == null || idAuditor === '' || String(idAuditor) === String(idSesion)) {
        return sesion.nombre_completo || sesion.nombre || this.obtenerNombreUsuario(idSesion, '')
      }
      return this.obtenerNombreUsuario(idAuditor, this.editedControlInternoItem.nombreAuditor || '')
    },

    tituloFirmaControlInterno() {
      if (this.campoFirmaControlInterno === 'responsablePlantelFirma') {
        return 'Responsable del plantel'
      }
      return 'Auditor'
    },

    resumenControlInternoModal() {
      let total = 0
      let completados = 0
      const contarResultado = (lista) => {
        ;(Array.isArray(lista) ? lista : []).forEach((item) => {
          total += 1
          if (item && item.resultado) completados += 1
        })
      }
      const contarBooleanos = (lista, campos) => {
        ;(Array.isArray(lista) ? lista : []).forEach((item) => {
          campos.forEach((campo) => {
            total += 1
            if (item && item[campo]) completados += 1
          })
        })
      }

      const item = this.editedControlInternoItem || {}
      contarResultado(item.criterios)
      contarBooleanos(item.salones, ['bancos', 'proyector', 'iluminacion', 'clima', 'pintura'])
      contarResultado(item.corte && item.corte.criterios)
      const contarVestimenta = (fila, campos) => {
        campos.forEach((campo) => {
          if (fila[campo] === 'Ausente') return
          total += 1
          if (fila[campo] === true) completados += 1
        })
      }
      ;(Array.isArray(item.vestimenta && item.vestimenta.filas) ? item.vestimenta.filas : []).forEach((fila) => {
        if (!fila || fila.personal === 'Staff Extra' || fila.aplica === false) return
        const campos = CRITERIOS_VESTIMENTA_CONTROL_INTERNO.map((criterio) => criterio.campo)
        if (PERSONAL_PUNTUALIDAD_CONTROL_INTERNO.indexOf(fila.personal) !== -1) {
          campos.push('cumpleHorario', 'permaneceArea')
        }
        contarVestimenta(fila, campos)
      })
      ;(Array.isArray(item.vestimenta && item.vestimenta.teachers) ? item.vestimenta.teachers : []).forEach((teacher) => {
        if (teacher) contarVestimenta(teacher, CRITERIOS_TEACHER_CONTROL_INTERNO.map((criterio) => criterio.campo))
      })
      contarResultado(item.riAtencionAlumno && item.riAtencionAlumno.encargadaCriterios)
      contarResultado(item.riAtencionAlumno && item.riAtencionAlumno.recepcionCriterios)
      contarResultado(item.metodologia5s && item.metodologia5s.criterios)

      return { total, completados }
    },

    nivelGeneralControlInternoGrupos() {
      return []
    },

    escalaClimaControlInternoGrupos() {
      return [
        {
          campo: 'climaGeneral',
          label: 'Clima general',
          opciones: NIVEL_GENERAL_CONTROL_INTERNO_OPCIONES.climaGeneral
        },
        {
          campo: 'comunicacion',
          label: 'Comunicación',
          opciones: NIVEL_GENERAL_CONTROL_INTERNO_OPCIONES.comunicacion
        },
        {
          campo: 'organizacionTurnos',
          label: 'Organización de turnos',
          opciones: NIVEL_GENERAL_CONTROL_INTERNO_OPCIONES.organizacionTurnos
        },
        {
          campo: 'liderazgo',
          label: 'Liderazgo',
          opciones: NIVEL_GENERAL_CONTROL_INTERNO_OPCIONES.liderazgo
        },
        {
          campo: 'operacion',
          label: 'Operación (RI/corte/atención)',
          opciones: NIVEL_GENERAL_CONTROL_INTERNO_OPCIONES.operacion
        }
      ]
    },

    opcionesNivelGeneralControlInterno() {
      return NIVEL_GENERAL_CONTROL_INTERNO_OPCIONES.nivelGeneral
    },

    preguntasRetroControlInterno() {
      return PREGUNTAS_RETRO_CONTROL_INTERNO
    },

    estatusControlInternoOpciones() {
      return ESTATUS_CONTROL_INTERNO
    },

    estatusFiltroActivo() {
      return this.esTabEvaluacionPersonal ? ESTATUS_VALIDOS : ESTATUS_AUDITORIA_SUCURSAL
    },

    filasVestimentaPdfControlInterno() {
      const filas =
        this.editedControlInternoItem &&
        this.editedControlInternoItem.vestimenta &&
        this.editedControlInternoItem.vestimenta.filas
          ? this.editedControlInternoItem.vestimenta.filas
          : []
      return filas.filter((fila) => fila && fila.personal !== 'Staff Extra')
    },

    filasPuntualidadPdfControlInterno() {
      return this.filasVestimentaPdfControlInterno.filter(
        (fila) => PERSONAL_PUNTUALIDAD_CONTROL_INTERNO.indexOf(fila.personal) !== -1
      )
    },

    esCorporativoControlInterno() {
      return !!this.editedControlInternoItem && esPlantelCorporativoControlInterno(this.editedControlInternoItem.idplantel)
    },

    departamentosOficinaControlInterno() {
      return (this.departamentos || [])
        .map((depto) => (depto && depto.nombre ? depto.nombre : ''))
        .filter((nombre) => {
          const texto = this.normalizarTexto(nombre)
          return texto && texto !== 'control interno' && texto.indexOf('eliminar') === -1
        })
    },

    personalCorporativoControlInterno() {
      const vestimenta = this.editedControlInternoItem && this.editedControlInternoItem.vestimenta
      return vestimenta && Array.isArray(vestimenta.corporativo) ? vestimenta.corporativo : []
    },

    criteriosOficinaControlInterno() {
      return CRITERIOS_OFICINA_CONTROL_INTERNO
    },

    teachersVestimentaControlInterno() {
      const vestimenta = this.editedControlInternoItem && this.editedControlInternoItem.vestimenta
      return vestimenta && Array.isArray(vestimenta.teachers) ? vestimenta.teachers : []
    },

    opcionesVestimentaControlInterno() {
      return OPCIONES_VESTIMENTA_CONTROL_INTERNO
    },

    criteriosVestimentaControlInterno() {
      return CRITERIOS_VESTIMENTA_CONTROL_INTERNO
    },

    criteriosTeacherControlInterno() {
      return CRITERIOS_TEACHER_CONTROL_INTERNO
    },

    esTabEvaluacionPersonal() {
      return false
    },

    tituloTablaActiva() {
      return this.esTabEvaluacionPersonal ? 'Evaluación Personal' : 'Sucursales por ciclo'
    },

    auditoriasExportables() {
      return this.esTabEvaluacionPersonal ? this.auditoriasFiltradas : this.sucursalesControlInternoCiclo
    },

    nombreArchivoAuditorias() {
      return this.esTabEvaluacionPersonal ? 'auditorias_evaluacion_personal' : 'auditorias_control_interno'
    },

    tiposAuditoriaNombres() {
      return this.tiposAuditoria.map((item) => item.nombre)
    },

    tipoAuditoriaBackendMap() {
      return {
        Inicial: 'Inicial',
        Seguimiento: 'Seguimiento',
        'Auditoría 5S': 'Inicial',
        'Auditoría de Procesos': 'Seguimiento'
      }
    },

    estatusValidos() {
      return ESTATUS_VALIDOS
    },

    calificacionesValidas() {
      return CALIFICACIONES_VALIDAS
    },

    calificacionesPhvaSelect() {
      return [
        { text: '1 — No cumple', value: '1 - No cumple' },
        { text: '2 — Parcial', value: '2 - Parcial' },
        { text: '3 — Cumple totalmente', value: '3 - Cumple totalmente' },
        { text: 'N/A — No aplica', value: 'N/A' }
      ]
    },

    criteriosPhvaPorSeccion() {
      const orden = []
      const porTitulo = new Map()
      ;(this.criterios || []).forEach((c) => {
        const titulo = (c && c.seccion) || 'GENERAL'
        if (!porTitulo.has(titulo)) {
          porTitulo.set(titulo, [])
          orden.push(titulo)
        }
        porTitulo.get(titulo).push(c)
      })
      return orden.map((titulo) => ({ titulo, items: porTitulo.get(titulo) || [] }))
    },

    criteriosPhvaFilasTabla() {
      const filas = []
      this.criteriosPhvaPorSeccion.forEach((grupo, gIdx) => {
        filas.push({ kind: 'header', titulo: grupo.titulo, _key: `phva-h-${gIdx}` })
        ;(grupo.items || []).forEach((c, cIdx) => {
          filas.push({
            kind: 'row',
            c,
            _key: `phva-r-${gIdx}-${c.id != null ? c.id : cIdx}`
          })
        })
        // Agregar fila de evidencia general al final de cada sección
        filas.push({
          kind: 'evidencia-general',
          seccion: grupo.titulo,
          _key: `phva-eg-${gIdx}`
        })
      })
      return filas
    },

    conteosDepartamentoDesdeListadoAuditorias() {
      const mapa = new Map()

      const upsert = (llave, nombre) => {
        if (!mapa.has(llave)) {
          mapa.set(llave, {
            id_departamento: null,
            departamento: nombre || '',
            conteoInicial: 0,
            conteoSeguimiento: 0,
            resultados: []
          })
        }
        return mapa.get(llave)
      }

      const lista = this.auditoriasFiltradas || []

      lista.forEach((item) => {
        const idDept = item.id_departamento != null ? item.id_departamento : null
        const nombreDept = item.departamento || item.nombre_departamento || ''
        const llave = idDept != null && idDept !== '' ? `id:${String(idDept)}` : `nom:${this.normalizarTexto(nombreDept)}`

        const row = upsert(llave, nombreDept)
        if (row.id_departamento == null && idDept != null && idDept !== '') {
          row.id_departamento = idDept
        }
        if (!row.departamento && nombreDept) {
          row.departamento = nombreDept
        }

        const estatus = String(item.estatus || '').trim()
        const tipoVisible = this.tipoAuditoriaVisible(item.tipoAuditoria)

        let bucket = null
        if (estatus === 'Inicial' || estatus === 'Seguimiento') {
          bucket = estatus
        } else if (tipoVisible === 'Inicial' || tipoVisible === 'Seguimiento') {
          bucket = tipoVisible
        }

        if (bucket === 'Inicial') row.conteoInicial += 1
        if (bucket === 'Seguimiento') row.conteoSeguimiento += 1

        const r = item.resultadoPorcentaje
        if (r != null && r !== '' && !Number.isNaN(Number(r))) {
          row.resultados.push(Number(r))
        }
      })

      return mapa
    },

    tarjetasReporteDepartamento() {
      const mapa = this.conteosDepartamentoDesdeListadoAuditorias

      const baseRows = Array.isArray(this.reporteAuditorias) ? this.reporteAuditorias : []

      const construirTarjeta = (meta, agg) => {
        const conteoInicial = agg ? agg.conteoInicial : 0
        const conteoSeguimiento = agg ? agg.conteoSeguimiento : 0
        const res = agg && agg.resultados && agg.resultados.length ? agg.resultados : []
        const promedioResultado = res.length ? res.reduce((a, b) => a + b, 0) / res.length : 0

        return {
          id_departamento:
            meta.id_departamento != null
              ? meta.id_departamento
              : meta.id != null
                ? meta.id
                : null,
          departamento: meta.departamento || '',
          conteoInicial,
          conteoSeguimiento,
          promedioResultado
        }
      }

      if (baseRows.length) {
        return baseRows
          .map((item) => {
            const idDept = item.id_departamento != null ? item.id_departamento : item.id != null ? item.id : null
            const nombreDept = item.nombre_departamento || item.departamento || ''
            const llave = idDept != null && idDept !== '' ? `id:${String(idDept)}` : `nom:${this.normalizarTexto(nombreDept)}`
            const agg = mapa.get(llave) || null

            return construirTarjeta(
              {
                id_departamento: idDept,
                departamento: nombreDept
              },
              agg
            )
          })
          .sort((a, b) =>
            String(a.departamento || '').localeCompare(String(b.departamento || ''), 'es', { sensitivity: 'base' })
          )
      }

      return Array.from(mapa.values())
        .map((agg) =>
          construirTarjeta(
            {
              id_departamento: agg.id_departamento,
              departamento: agg.departamento
            },
            agg
          )
        )
        .filter((t) => t.departamento || t.id_departamento != null)
        .sort((a, b) =>
          String(a.departamento || '').localeCompare(String(b.departamento || ''), 'es', { sensitivity: 'base' })
        )
    },

    totalesReporteTarjetas() {
      const filas = this.tarjetasReporteDepartamento
      if (!filas.length) {
        return {
          conteoInicial: 0,
          conteoSeguimiento: 0,
          promedioResultado: 0
        }
      }

      const sumas = filas.reduce(
        (acc, item) => {
          acc.conteoInicial += Number(item.conteoInicial || 0)
          acc.conteoSeguimiento += Number(item.conteoSeguimiento || 0)
          acc.promedio += Number(item.promedioResultado || 0)
          return acc
        },
        { conteoInicial: 0, conteoSeguimiento: 0, promedio: 0 }
      )

      return {
        conteoInicial: sumas.conteoInicial,
        conteoSeguimiento: sumas.conteoSeguimiento,
        promedioResultado: filas.length ? sumas.promedio / filas.length : 0
      }
    },

    tarjetasReporteControlInterno() {
      const mapa = new Map()
      ;(this.controlInternoFiltradas || []).forEach((item) => {
        const idDept = item.id_departamento != null ? item.id_departamento : item.departamentoId
        const nombreDept = item.departamento || item.nombre_departamento || 'Sin departamento'
        const llave = idDept != null && idDept !== '' ? `id:${String(idDept)}` : `nom:${this.normalizarTexto(nombreDept)}`

        if (!mapa.has(llave)) {
          mapa.set(llave, {
            id_departamento: idDept != null ? idDept : null,
            departamento: nombreDept,
            totalAuditorias: 0,
            planteles: new Set(),
            responsables: new Set()
          })
        }

        const row = mapa.get(llave)
        row.totalAuditorias += 1
        if (item.id_plantel != null && item.id_plantel !== '') {
          row.planteles.add(String(item.id_plantel))
        }
        if (item.id_responsable_plantel != null && item.id_responsable_plantel !== '') {
          row.responsables.add(String(item.id_responsable_plantel))
        }
      })

      return Array.from(mapa.values())
        .map((item) => ({
          id_departamento: item.id_departamento,
          departamento: item.departamento,
          totalAuditorias: item.totalAuditorias,
          totalPlanteles: item.planteles.size,
          totalResponsables: item.responsables.size
        }))
        .sort((a, b) =>
          String(a.departamento || '').localeCompare(String(b.departamento || ''), 'es', { sensitivity: 'base' })
        )
    },

    totalesReporteControlInterno() {
      const planteles = new Set()
      const responsables = new Set()
      ;(this.controlInternoFiltradas || []).forEach((item) => {
        if (item.id_plantel != null && item.id_plantel !== '') {
          planteles.add(String(item.id_plantel))
        }
        if (item.id_responsable_plantel != null && item.id_responsable_plantel !== '') {
          responsables.add(String(item.id_responsable_plantel))
        }
      })

      return {
        totalAuditorias: (this.controlInternoFiltradas || []).length,
        totalPlanteles: planteles.size,
        totalResponsables: responsables.size
      }
    },

    usuariosSelects() {
      const referencias = []
      this.auditorias.forEach((item) => this.agregarReferenciasUsuarioDesdeAuditoria(referencias, item))

      const fusionados = this.fusionarListaUsuariosParaSelects(
        [...this.usuariosCatalogo, ...this.usuariosAllErp, ...this.usuariosAll],
        referencias
      )

      const lista = this.disambiguarEtiquetasUsuariosDuplicados(this.dedupeUsuariosPorId(fusionados))
      return this.filtrarUsuariosActivosParaSelect(lista)
    },

    usuariosSoloCatalogoErp() {
      const iderpExplicitoEnFila = (u) => {
        if (!u) return null
        const raw = u.iderp != null && u.iderp !== '' ? u.iderp : u.IDERP != null && u.IDERP !== '' ? u.IDERP : null
        if (raw == null || raw === '') return null
        const n = Number(raw)
        return !Number.isNaN(n) && n > 0 ? n : null
      }

      const idusuarioCatalogoNumerico = (u) => {
        if (!u || u.idusuario == null || u.idusuario === '') return null
        const n = Number(u.idusuario)
        return !Number.isNaN(n) && n > 0 ? n : null
      }

      const elegibleResponsable = (u) => {
        if (iderpExplicitoEnFila(u) != null) return true
        if (this.usuariosCatalogoEsEndpointAuditoria && idusuarioCatalogoNumerico(u) != null) return true
        return false
      }

      // iderp explícito, o catálogo /auditoria con idusuario = FK ERP (sin duplicar filas mezcladas desde usuarios.all).
      const soloCatalogoFk = (this.usuariosCatalogo || []).filter(elegibleResponsable)

      const base = soloCatalogoFk.map((u) => this.normalizarUsuario(u))
      const dedup = this.dedupeUsuariosPorId(base)

      const filasNombre = [...(this.usuariosAllErp || []), ...(this.usuariosAll || []), ...(this.auditorias || [])]

      // Solo IDs del catálogo ERP; pero mejora la etiqueta con nombres encontrados en otras listas.
      const conEtiquetas = this.combinarEtiquetasUsuarios(dedup, filasNombre)
      const disamb = this.disambiguarEtiquetasUsuariosDuplicados(conEtiquetas)
      return this.filtrarUsuariosActivosParaSelect(disamb).sort((a, b) =>
        String(this.etiquetaUsuarioSelect(a) || '').localeCompare(String(this.etiquetaUsuarioSelect(b) || ''), 'es', {
          sensitivity: 'base'
        })
      )
    },

    colaboradores() {
      return this.usuariosSelects
    },

    mapaNombreUsuarioPorId() {
      const mapa = this.construirMapaNombrePorCualquierId([
        ...this.usuariosCatalogo,
        ...this.usuariosAll,
        ...this.usuariosAllErp,
        ...this.usuariosSelects,
        ...this.auditorias
      ])
      const salida = {}
      mapa.forEach((valor, llave) => {
        salida[llave] = valor
      })
      return salida
    },

    mapaNombrePlantelPorId() {
      return this.planteles.reduce((acc, item) => {
        if (item.idplantel != null && item.idplantel !== '') {
          acc[String(item.idplantel)] = item.plantel || item.nombre || ''
        }
        return acc
      }, {})
    },

    auditoriasEnriquecidas() {
      return this.auditorias.map((item) => {
        const idRegistro =
          item.usuario_registro ||
          item.id_usuario_creacion ||
          item.id_usuario_actualizacion ||
          item.id_auditor

        const nombreRegistro =
          this.obtenerNombreUsuario(
            idRegistro,
            item.nombre_usuario_registro ||
              item.nombre_usuario_creacion ||
              item.usuario_registro_nombre ||
              item.nombre_auditor
          ) || ''

        const auditor = this.obtenerNombreUsuario(item.id_auditor, item.nombre_auditor || item.auditor)
        const jefe = this.obtenerNombreUsuario(
          item.id_jefe_departamento,
          item.nombre_jefe || item.nombre_jefe_departamento
        )
        const responsable = this.obtenerNombreUsuario(item.id_responsable, item.nombre_responsable)
        const plantel = this.nombrePlantel(item.id_plantel || item.idplantel, item.nombre_plantel)
        const resultado =
          item.resultado_porcentaje != null && item.resultado_porcentaje !== ''
            ? Number(item.resultado_porcentaje)
            : this.calcularResultadoPorcentaje(item.criterios || [])

        return {
          ...item,
          id: item.id,
          departamento: item.nombre_departamento || item.departamento || '',
          tipoAuditoria: item.tipo_auditoria || item.tipoAuditoria || '',
          auditor,
          jefeDepartamento: jefe,
          responsable,
          nombrePlantel: plantel,
          fecha: this.formatearFechaInput(item.fecha_auditoria || item.fecha),
          resultadoPorcentaje: resultado,
          usuario_registro: idRegistro,
          usuario_registro_nombre: nombreRegistro,
          idusuario: idRegistro
        }
      })
    },

    auditoriasFiltradas() {
      let lista = this.auditoriasEnriquecidas
        .filter((item) => this.filaAuditoriaSoloUsuariosActivosSn(item))
        .slice()
      const filtros = this.filtros
      const textoBuscar = this.normalizarTexto(filtros.search)

      if (filtros.tipoAuditoria) {
        lista = lista.filter((item) => item.tipoAuditoria === filtros.tipoAuditoria)
      }

      if (filtros.estatus != null && filtros.estatus !== '') {
        lista = lista.filter((item) => item.estatus === filtros.estatus)
      }

      if (filtros.departamento != null && filtros.departamento !== '') {
        lista = lista.filter((item) => String(item.id_departamento || '') === String(filtros.departamento))
      }

      if (filtros.plantel != null && filtros.plantel !== '') {
        lista = lista.filter((item) => String(item.id_plantel || item.idplantel || '') === String(filtros.plantel))
      }

      if (filtros.colaborador != null && filtros.colaborador !== '') {
        const colaboradorId = String(filtros.colaborador)
        lista = lista.filter((item) => {
          const ids = [
            item.usuario_registro,
            item.idusuario,
            item.id_auditor,
            item.id_usuario_creacion,
            item.id_usuario_actualizacion
          ]
            .filter((valor) => valor != null && valor !== '')
            .map((valor) => String(valor))

          return ids.includes(colaboradorId)
        })
      }

      if (filtros.fechaini) {
        lista = lista.filter((item) => !item.fecha || item.fecha >= filtros.fechaini)
      }

      if (filtros.fechafin) {
        lista = lista.filter((item) => !item.fecha || item.fecha <= filtros.fechafin)
      }

      if (textoBuscar) {
        lista = lista.filter((item) => this.textoBusquedaAuditoria(item).includes(textoBuscar))
      }

      return lista
    },

    controlInternoEnriquecidas() {
      return this.controlInternoAuditorias.map((item) => {
        const idDept =
          item.id_departamento != null
            ? item.id_departamento
            : item.departamento != null
              ? item.departamento
              : null
        const idPlantel =
          item.id_plantel != null
            ? item.id_plantel
            : item.idplantel != null
              ? item.idplantel
              : null
        const idDirigido =
          item.id_dirigido_a != null
            ? item.id_dirigido_a
            : item.dirigidoA != null
              ? item.dirigidoA
              : null
        const idResponsable =
          item.id_responsable_plantel != null
            ? item.id_responsable_plantel
            : item.responsablePlantel != null
              ? item.responsablePlantel
              : null

        return {
          ...item,
          id: item.id,
          id_departamento: idDept,
          id_plantel: idPlantel,
          id_dirigido_a: idDirigido,
          id_responsable_plantel: idResponsable,
          objetivo: item.objetivo || '',
          departamento: this.nombreDepartamento(idDept, item.nombre_departamento || item.departamentoNombre),
          dirigidoA: this.obtenerNombreUsuario(idDirigido, item.nombre_dirigido_a || item.dirigido_a),
          nombrePlantel: this.nombrePlantel(idPlantel, item.nombre_plantel || item.plantel),
          responsablePlantel: this.obtenerNombreUsuario(
            idResponsable,
            item.nombre_responsable_plantel || item.responsable_plantel
          ),
          nombreAuditor: this.obtenerNombreUsuario(
            item.id_auditor || item.idAuditor,
            item.nombre_auditor
          ),
          id_ciclo:
            item.id_ciclo != null
              ? item.id_ciclo
              : item.idCiclo != null
                ? item.idCiclo
                : null,
          resultadoPorcentaje:
            item.resultado_porcentaje != null
              ? Number(item.resultado_porcentaje)
              : item.resultadoPorcentaje != null
                ? Number(item.resultadoPorcentaje)
                : 0,
          fechaAuditoria: this.formatearFechaInput(item.fecha_auditoria || item.fechaAuditoria),
          fechaProgramada: this.formatearFechaInput(item.fecha_programada || item.fechaProgramada),
          estatus: item.estatus || 'Cerrada'
        }
      })
    },

    cicloFiltroSeleccionado() {
      if (this.filtros.id_ciclo == null || this.filtros.id_ciclo === '') return null
      return (this.ciclos || []).find((item) => String(item.id_ciclo) === String(this.filtros.id_ciclo)) || null
    },

    controlInternoDelCiclo() {
      const idCiclo = this.filtros.id_ciclo
      let lista = this.controlInternoEnriquecidas.slice()
      if (idCiclo != null && idCiclo !== '') {
        const ciclo = this.cicloFiltroSeleccionado
        const inicio = ciclo ? this.formatearFechaInput(ciclo.fecha_inicio_ciclo) : null
        const fin = ciclo ? this.formatearFechaInput(ciclo.fecha_fin_ciclo) : null
        lista = lista.filter((item) => {
          if (item.id_ciclo != null && item.id_ciclo !== '') {
            return String(item.id_ciclo) === String(idCiclo)
          }
          // Fallback histórico: si aún no tiene id_ciclo, usar rango de fechas del ciclo.
          if (!inicio || !fin) return false
          const fecha = item.fechaAuditoria || item.fechaProgramada
          return !!(fecha && fecha >= inicio && fecha <= fin)
        })
      }
      const vistos = {}
      return lista.filter((item) => {
        if (!item || item.id == null || item.id === '') return true
        const llave = String(item.id)
        if (vistos[llave]) return false
        vistos[llave] = true
        return true
      })
    },

    controlInternoFiltradas() {
      let lista = this.controlInternoDelCiclo.slice()
      const filtros = this.filtros
      const textoBuscar = this.normalizarTexto(filtros.search)

      if (filtros.departamento != null && filtros.departamento !== '') {
        lista = lista.filter((item) => String(item.id_departamento || '') === String(filtros.departamento))
      }

      if (filtros.plantel != null && filtros.plantel !== '') {
        lista = lista.filter((item) => String(item.id_plantel || '') === String(filtros.plantel))
      }

      if (filtros.colaborador != null && filtros.colaborador !== '') {
        const colaboradorId = String(filtros.colaborador)
        lista = lista.filter((item) =>
          [item.id_dirigido_a, item.id_responsable_plantel, item.id_auditor]
            .filter((valor) => valor != null && valor !== '')
            .map((valor) => String(valor))
            .includes(colaboradorId)
        )
      }

      if (textoBuscar) {
        lista = lista.filter((item) => this.textoBusquedaControlInterno(item).includes(textoBuscar))
      }

      return lista
    },

    /** Todas las sucursales del ciclo con su auditoría, sin aplicar filtros de la pantalla. */
    sucursalesBaseControlInternoCiclo() {
      if (this.filtros.id_ciclo == null || this.filtros.id_ciclo === '') {
        return []
      }

      const porPlantel = {}

      this.controlInternoDelCiclo.forEach((item) => {
        const idPlantel = item.id_plantel != null ? String(item.id_plantel) : null
        if (!idPlantel) return
        const actual = porPlantel[idPlantel]
        if (!actual) {
          porPlantel[idPlantel] = item
          return
        }
        const actualCerrada = String(actual.estatus || '') === 'Cerrada'
        const itemCerrada = String(item.estatus || '') === 'Cerrada'
        if (itemCerrada && !actualCerrada) {
          porPlantel[idPlantel] = item
          return
        }
        if (itemCerrada === actualCerrada && Number(item.id || 0) > Number(actual.id || 0)) {
          porPlantel[idPlantel] = item
        }
      })

      return (this.planteles || []).map((plantel) => {
        const idPlantel = plantel.idplantel != null ? plantel.idplantel : plantel.id_plantel
        const auditoria = porPlantel[String(idPlantel)] || null
        const escuela = Number(plantel.escuela) || null
        const auditado = !!(auditoria && String(auditoria.estatus || '') === 'Cerrada')
        const puntaje =
          auditoria && auditoria.resultadoPorcentaje != null
            ? Number(auditoria.resultadoPorcentaje)
            : 0

        return {
          id_plantel: idPlantel,
          nombrePlantel: plantel.plantel || plantel.nombre || this.nombrePlantel(idPlantel),
          escuela,
          nombreEscuela: NOMBRES_ESCUELA_CONTROL_INTERNO[escuela] || '-',
          auditoria,
          auditado,
          estatusAuditado: auditado ? 'Auditado' : 'No auditado',
          tienePuntaje: !!(auditoria && String(auditoria.estatus || '') !== 'Programada'),
          puntaje,
          calificacion: Math.round(puntaje) / 10,
          fechaAuditoria: auditoria ? auditoria.fechaAuditoria || auditoria.fechaProgramada : null,
          nombreAuditor: auditoria ? auditoria.nombreAuditor : '',
          id_departamento: auditoria ? auditoria.id_departamento : null,
          id_dirigido_a: auditoria ? auditoria.id_dirigido_a : null,
          id_responsable_plantel: auditoria ? auditoria.id_responsable_plantel : null,
          id_auditor: auditoria ? auditoria.id_auditor || auditoria.idAuditor : null
        }
      })
    },

    sucursalesControlInternoCiclo() {
      const filtros = this.filtros
      const textoBuscar = this.normalizarTexto(filtros.search)
      let lista = this.sucursalesBaseControlInternoCiclo.slice()

      if (filtros.escuela != null && filtros.escuela !== '') {
        lista = lista.filter((item) => Number(item.escuela) === Number(filtros.escuela))
      }

      if (filtros.plantel != null && filtros.plantel !== '') {
        lista = lista.filter((item) => String(item.id_plantel) === String(filtros.plantel))
      }

      if (filtros.departamento != null && filtros.departamento !== '') {
        lista = lista.filter(
          (item) => item.auditoria && String(item.id_departamento || '') === String(filtros.departamento)
        )
      }

      if (filtros.colaborador != null && filtros.colaborador !== '') {
        const colaboradorId = String(filtros.colaborador)
        lista = lista.filter((item) => {
          if (!item.auditoria) return false
          return [item.id_dirigido_a, item.id_responsable_plantel, item.id_auditor]
            .filter((valor) => valor != null && valor !== '')
            .map((valor) => String(valor))
            .includes(colaboradorId)
        })
      }

      if (filtros.estatus === 'Auditado') {
        lista = lista.filter((item) => item.auditado)
      } else if (filtros.estatus === 'No auditado') {
        lista = lista.filter((item) => !item.auditado)
      }

      if (textoBuscar) {
        lista = lista.filter((item) =>
          this.normalizarTexto(
            [item.nombrePlantel, item.nombreEscuela, item.estatusAuditado, item.nombreAuditor, item.puntaje].join(' ')
          ).includes(textoBuscar)
        )
      }

      return lista.sort((a, b) => {
        const nombreA = String(a.nombrePlantel || '')
        const nombreB = String(b.nombrePlantel || '')
        return nombreA.localeCompare(nombreB, 'es')
      })
    },

    /** Calificación promedio (0–10) de las auditorías Cerradas del ciclo, por escuela y global. */
    promediosEscuelaControlInterno() {
      const cerradas = this.sucursalesBaseControlInternoCiclo.filter((item) => item.auditado)
      const resumen = (lista) => {
        const total = lista.length
        const suma = lista.reduce((acc, item) => acc + Number(item.puntaje || 0), 0)
        const promedio = total ? suma / total : null
        return {
          auditadas: total,
          puntaje: promedio,
          calificacion: promedio == null ? null : Math.round(promedio) / 10
        }
      }
      const filas = Object.keys(NOMBRES_ESCUELA_CONTROL_INTERNO).map((clave) => ({
        clave,
        nombre: NOMBRES_ESCUELA_CONTROL_INTERNO[clave],
        sucursales: this.sucursalesBaseControlInternoCiclo.filter((item) => String(item.escuela) === clave).length,
        ...resumen(cerradas.filter((item) => String(item.escuela) === clave))
      }))
      filas.push({
        clave: 'global',
        nombre: 'Global',
        sucursales: this.sucursalesBaseControlInternoCiclo.length,
        ...resumen(cerradas)
      })
      return filas
    },

    opcionesEscuelaControlInterno() {
      return OPCIONES_ESCUELA_CONTROL_INTERNO
    },

    ponderacionControlInterno() {
      return PONDERACION_CONTROL_INTERNO
    },

    plantelesFiltroControlInterno() {
      const escuela = this.filtros.escuela
      if (escuela == null || escuela === '') return this.planteles
      return (this.planteles || []).filter((plantel) => Number(plantel.escuela) === Number(escuela))
    },

    rankingTop3ControlInterno() {
      return this.sucursalesControlInternoCiclo
        .filter((item) => item.auditado)
        .slice()
        .sort((a, b) => Number(b.puntaje || 0) - Number(a.puntaje || 0))
        .slice(0, 3)
    }
  },

  methods: {
    criteriosVacios() {
      return clonarCriteriosBase()
    },

    etiquetaPreguntaPhva(criterio) {
      const canon = textoPreguntaCanonicaCriterio(criterio)
      if (canon) return canon
      return String(criterio && criterio.nombre ? criterio.nombre : '').trim()
    },

    tipoAuditoriaVisible(valor) {
      const texto = String(valor || '').trim()
      if (texto === 'Auditoría 5S') return 'Inicial'
      if (texto === 'Auditoría de Procesos') return 'Seguimiento'
      if (this.tiposAuditoriaNombres.includes(texto)) return texto
      return texto
    },

    tipoAuditoriaParaBackend(valor) {
      const texto = String(valor || '').trim()
      return this.tipoAuditoriaBackendMap[texto] || texto
    },

    claveCriterioPhva(criterio) {
      return String((criterio && (criterio.idVisual || criterio.id || criterio.id_criterio_catalogo)) || '')
    },

    esCriterioFotoComentario(criterio) {
      return this.claveCriterioPhva(criterio) === '1.2'
    },

    placeholderEvidenciaPhva(criterio) {
      return this.esCriterioFotoComentario(criterio) ? 'Foto/comentario' : 'Evidencia / Hallazgo'
    },

    obtenerFotoEvidencia(criterio) {
      const clave = this.claveCriterioPhva(criterio)
      return this.fotosEvidenciaPhva[clave] || ''
    },

    separarEvidenciaYFoto(valor) {
      const texto = String(valor || '')
      const idx = texto.indexOf(EVIDENCIA_FOTO_MARKER)
      if (idx === -1) {
        return { comentario: texto, fotoBase64: '' }
      }

      return {
        comentario: texto.slice(0, idx).trim(),
        fotoBase64: texto.slice(idx + EVIDENCIA_FOTO_MARKER.length).trim()
      }
    },

    construirEvidenciaConFoto(comentario, fotoBase64) {
      const texto = String(comentario || '').trim()
      if (!fotoBase64) return texto
      return `${texto}\n${EVIDENCIA_FOTO_MARKER}${fotoBase64}`.trim()
    },

    onFotoEvidenciaChange(criterio, file) {
      const clave = this.claveCriterioPhva(criterio)
      if (!clave) return

      const archivo = Array.isArray(file) ? file[0] : file
      if (!archivo) {
        this.$delete(this.fotosEvidenciaPhva, clave)
        return
      }

      const reader = new FileReader()
      reader.onload = () => {
        this.$set(this.fotosEvidenciaPhva, clave, String(reader.result || ''))
      }
      reader.readAsDataURL(archivo)
    },

    quitarFotoEvidencia(criterio) {
      const clave = this.claveCriterioPhva(criterio)
      if (!clave) return
      this.$delete(this.fotosEvidenciaPhva, clave)
    },

    onFotoEvidenciaGeneralChange(seccion, file) {
      if (!seccion) return
      const archivo = Array.isArray(file) ? file[0] : file
      if (!archivo) {
        this.$delete(this.fotosEvidenciaGeneralesPhva, seccion)
        return
      }
      const reader = new FileReader()
      reader.onload = () => {
        this.$set(this.fotosEvidenciaGeneralesPhva, seccion, reader.result)
      }
      reader.readAsDataURL(archivo)
    },

    obtenerFotoEvidenciaGeneral(seccion) {
      if (!seccion) return ''
      return this.fotosEvidenciaGeneralesPhva[seccion] || ''
    },

    quitarFotoEvidenciaGeneral(seccion) {
      if (!seccion) return
      this.$delete(this.fotosEvidenciaGeneralesPhva, seccion)
    },

    extraerArray(response) {
      const body = response && response.data !== undefined ? response.data : response

      if (Array.isArray(body)) return body
      if (body && Array.isArray(body.data)) return body.data
      return []
    },

    extraerObjeto(response) {
      const body = response && response.data !== undefined ? response.data : response
      if (body && body.data !== undefined && !Array.isArray(body.data)) return body.data
      return body
    },

    normalizarTexto(valor) {
      return String(valor || '')
        .trim()
        .toLowerCase()
    },

    formatearFechaInput(valor) {
      if (!valor) return null
      return String(valor).slice(0, 10)
    },

    normalizarValorSelectNumerico(valor) {
      if (valor == null || valor === '') return ''
      if (typeof valor === 'number') return valor
      const texto = String(valor).trim()
      if (/^\d+$/.test(texto)) {
        const numero = Number(texto)
        return Number.isNaN(numero) ? texto : numero
      }
      return texto
    },

    /** Valor de v-select / FK ERP: prioriza iderp del catálogo cuando existe. */
    idParaSelectUsuario(u) {
      if (!u) return null
      if (u.iderp != null && u.iderp !== '') return u.iderp
      if (u.idusuario != null && u.idusuario !== '') return u.idusuario
      if (u.id_usuario != null && u.id_usuario !== '') return u.id_usuario
      if (u.id != null && u.id !== '') return u.id
      return null
    },

    obtenerIdSesion() {
      if (!this.getdatosUsuarioERPERP) return null
      const u = this.getdatosUsuarioERPERP
      if (u.idusuario != null && u.idusuario !== '') return u.idusuario
      if (u.id_usuario != null && u.id_usuario !== '') return u.id_usuario
      if (u.iderp != null && u.iderp !== '') return u.iderp
      return null
    },

    /**
     * Solo el select Responsable usa item-value iderp; auditor/jefe/colaborador usan idusuario.
     * @param {boolean} usarIderpFk - true solo para id_responsable
     */
    resolverIdUsuarioFkParaPayload(valorSeleccionado, usarIderpFk = false) {
      if (valorSeleccionado == null || valorSeleccionado === '') return null

      if (typeof valorSeleccionado === 'object') {
        const obj = valorSeleccionado || {}
        if (usarIderpFk) {
          const idDirecto =
            obj.iderp != null && obj.iderp !== ''
              ? obj.iderp
              : obj.idusuario != null && obj.idusuario !== ''
                ? obj.idusuario
                : obj.id_usuario != null && obj.id_usuario !== ''
                  ? obj.id_usuario
                  : obj.id != null && obj.id !== ''
                    ? obj.id
                    : null
          return idDirecto != null && idDirecto !== '' ? idDirecto : null
        }
        const idDirecto =
          obj.idusuario != null && obj.idusuario !== ''
            ? obj.idusuario
            : obj.id_usuario != null && obj.id_usuario !== ''
              ? obj.id_usuario
              : obj.id != null && obj.id !== ''
                ? obj.id
                : obj.iderp != null && obj.iderp !== ''
                  ? obj.iderp
                  : null
        return idDirecto != null && idDirecto !== '' ? idDirecto : null
      }

      const k = String(valorSeleccionado).trim()
      if (!k) return null

      const candidatosLista = [...(this.usuariosSelects || [])]

      const matchEnLista = candidatosLista.find((u) => {
        if (!u) return false
        const ids = [u.iderp, u.idusuario, u.id_usuario, u.id].filter((v) => v != null && v !== '')
        return ids.some((v) => String(v) === k)
      })

      if (matchEnLista) {
        if (usarIderpFk) {
          const idSel = this.idParaSelectUsuario(matchEnLista)
          if (idSel != null && idSel !== '') return idSel
        } else {
          if (matchEnLista.idusuario != null && matchEnLista.idusuario !== '') return matchEnLista.idusuario
          if (matchEnLista.id_usuario != null && matchEnLista.id_usuario !== '') return matchEnLista.id_usuario
          if (matchEnLista.id != null && matchEnLista.id !== '') return matchEnLista.id
          return matchEnLista.iderp != null && matchEnLista.iderp !== '' ? matchEnLista.iderp : null
        }
      }

      const fuentes = [...this.usuariosCatalogo, ...this.usuariosAllErp, ...this.usuariosAll]
      for (let i = 0; i < fuentes.length; i++) {
        const row = fuentes[i]
        const n = this.normalizarUsuario(row)
        const ids = [n.iderp, n.idusuario, n.id_usuario, row.id].filter((v) => v != null && v !== '')
        if (!ids.some((v) => String(v) === k)) continue
        if (usarIderpFk) {
          const idOut = this.idParaSelectUsuario(n)
          if (idOut != null && idOut !== '') return idOut
        } else {
          if (n.idusuario != null && n.idusuario !== '') return n.idusuario
          if (n.id_usuario != null && n.id_usuario !== '') return n.id_usuario
          if (row.id != null && String(row.id) === k) return row.id
          return n.iderp != null && n.iderp !== '' ? n.iderp : null
        }
      }

      if (/^\d+$/.test(k)) {
        const n = Number(k)
        return Number.isNaN(n) ? null : n
      }

      return null
    },

    /** Mapea idusuario del auditor al iderp del select Responsable (solo si hay fila con iderp real en el catálogo). */
    idResponsableSelectDesdeIdUsuarioOAuditor(valor) {
      if (valor == null || valor === '') return null
      const k = String(valor)
      const candidatos = this.usuariosSoloCatalogoErp || []
      const match = candidatos.find((u) => {
        if (!u) return false
        return [u.idusuario, u.id_usuario, u.iderp].some((v) => v != null && String(v) === k)
      })
      if (!match) return null
      const idErp = this.idParaSelectUsuario(match)
      return idErp != null && idErp !== '' ? idErp : null
    },

    asegurarUsuarioEnCatalogoLocal(idUsuario, etiquetaFallback) {
      if (idUsuario == null || idUsuario === '') return
      const k = String(idUsuario)
      const num = Number.isNaN(Number(k)) ? idUsuario : Number(k)
      const existe = (this.usuariosCatalogo || []).some((u) => {
        const n = this.normalizarUsuario(u)
        return [n.iderp, n.idusuario, n.id_usuario].some((v) => v != null && String(v) === k)
      })
      if (existe) return

      const texto = String(etiquetaFallback || this.obtenerNombreUsuario(idUsuario, '') || '').trim()
      if (!texto || this.etiquetaUsuarioGenerica(texto)) return

      this.usuariosCatalogo.push(
        this.normalizarUsuario({
          iderp: num,
          idusuario: num,
          usuario_registro: texto
        })
      )
    },

    etiquetaUsuarioGenerica(texto) {
      if (texto == null || texto === '') return true
      const s = String(texto).trim()
      if (/^Usuario\s+\d+$/i.test(s)) return true
      if (/^\d+$/.test(s)) return true
      return false
    },

    textoNombreHumano(valor) {
      if (valor == null || valor === '') return ''
      if (typeof valor !== 'string') return ''
      const s = valor.trim()
      if (!s || /^\d+$/.test(s)) return ''
      return s
    },

    etiquetaUsuarioSelect(item) {
      const u = item || {}
      const candidatas = [
        this.textoNombreHumano(u.label),
        this.textoNombreHumano(u.nombre_mostrar),
        this.textoNombreHumano(u.nombre_display),
        this.textoNombreHumano(u.texto_select),
        this.textoNombreHumano(u.usuario_registro),
        this.textoNombreHumano(u.nombre_completo),
        this.textoNombreHumano(u.nombreCompleto),
        this.textoNombreHumano(u.nombre),
        [u.nombre, u.apellido].filter(Boolean).join(' ').trim(),
        [u.nombre_usuario, u.apellido_usuario].filter(Boolean).join(' ').trim(),
        this.nombreDesdeDatosCompletos(u),
        typeof u.usuario === 'string' ? this.textoNombreHumano(u.usuario) : '',
        this.textoNombreHumano(u.email)
      ]

      const nombre = candidatas
        .map((t) => String(t || '').trim())
        .find((t) => t && !/^\d+$/.test(t))
      if (nombre) return nombre

      return ''
    },

    nombreDesdeDatosCompletos(item) {
      const dc = item && item.datos_completos
      if (dc == null || typeof dc !== 'string') return null
      const primera = dc
        .split('/')
        .map((s) => s.trim())
        .find((s) => s.length)
      return this.esTextoNombreUsuarioValido(primera) ? primera : null
    },

    activoSnExplicitamenteInactivo(v) {
      if (v == null || v === '') return false
      const texto = String(v).trim().toLowerCase()
      if (['1', 'true', 'activo', 'activa', 'a', 'si', 'sí'].includes(texto)) return false
      if (['0', 'false', 'inactivo', 'inactiva', 'baja', 'deleted', 'eliminado'].includes(texto)) return true
      return false
    },

    valorEliminadoExplicitamente(v) {
      if (v == null || v === '') return false
      const texto = String(v).trim().toLowerCase()
      return ['1', 'true', 'si', 'sí', 'deleted', 'eliminado'].includes(texto)
    },

    obtenerActivoSnTrabajadorDesdeFila(row) {
      if (!row) return null
      const candidatos = [
        row.trabajador_activo_sn,
        row.activo_sn_trabajador,
        row.activo_trabajador_sn,
        row.t_activo_sn,
        row.trabajador_activo,
        row.activo_trabajador,
        row.cat_trabajador_activo_sn,
        row && row.trabajador && row.trabajador.activo_sn
      ]
      for (let i = 0; i < candidatos.length; i++) {
        const v = candidatos[i]
        if (v == null || v === '') continue
        if (Number(v) === 1 || v === true || v === '1') return true
        return false
      }
      return null
    },

    filaUsuarioActivoParaSelect(row) {
      if (row == null) return false
      const eliminados = [row.deleted, row.DELETED, row.eliminado, row.eliminado_sn, row.borrado_sn]
      if (eliminados.some((v) => this.valorEliminadoExplicitamente(v))) return false
      const activos = [row.activo_sn, row.ACTIVO_SN, row.activo, row.ACTIVO, row.estatus, row.status]
      if (activos.some((v) => this.activoSnExplicitamenteInactivo(v))) return false
      const t = this.obtenerActivoSnTrabajadorDesdeFila(row)
      if (t === false) return false
      return true
    },

    obtenerMapaIdsUsuariosInactivos(listas) {
      const map = {}
      ;(listas || []).forEach((arr) => {
        ;(Array.isArray(arr) ? arr : []).forEach((row) => {
          if (this.filaUsuarioActivoParaSelect(row)) return
          const ids = [row.id_usuario, row.idusuario, row.iderp, row.id].filter((v) => v != null && v !== '')
          ids.forEach((id) => {
            map[String(id)] = true
          })
        })
      })
      return map
    },

    esIdUsuarioInactivoEnCatalogos(id) {
      if (id == null || id === '') return false
      return !!this.idsUsuariosInactivos[String(id)]
    },

    recopilarIdsUsuariosPermitidosDesdeCatalogosCargados(listas) {
      const map = {}
      ;(listas || []).forEach((arr) => {
        ;(Array.isArray(arr) ? arr : []).forEach((row) => {
          const n = this.normalizarUsuario(row)
          ;[n.iderp, n.idusuario, n.id_usuario]
            .filter((v) => v != null && v !== '')
            .forEach((v) => {
              map[String(v)] = true
            })
        })
      })
      return map
    },

    filtrarUsuariosActivosParaSelect(lista) {
      const permitir = this.idsUsuariosPermitidosEnSelects
      const usarListaBlanca = permitir && Object.keys(permitir).length > 0

      return (Array.isArray(lista) ? lista : []).filter((u) => {
        if (!u) return false
        const idSel = this.idParaSelectUsuario(u)
        if (idSel == null || idSel === '') return false
        if (!String(this.etiquetaUsuarioSelect(u) || '').trim()) return false
        if (this.esIdUsuarioInactivoEnCatalogos(idSel)) return false
        if (usarListaBlanca && !permitir[String(idSel)]) return false
        return true
      })
    },

    idsUsuariosReferenciadosEnAuditoria(item) {
      const raw = [
        item && item.id_auditor,
        item && item.id_jefe_departamento,
        item && item.id_responsable,
        item && item.id_usuario_creacion,
        item && item.id_usuario_actualizacion
      ]
      const set = new Set()
      raw.forEach((v) => {
        if (v != null && v !== '') set.add(String(v))
      })
      return Array.from(set)
    },

    usuarioCumpleActivoSnParaVista(itemIdUsuario) {
      if (itemIdUsuario == null || itemIdUsuario === '') return true
      const id = String(itemIdUsuario)
      if (this.esIdUsuarioInactivoEnCatalogos(id)) return false
      const permitir = this.idsUsuariosPermitidosEnSelects
      const usarListaBlanca = permitir && Object.keys(permitir).length > 0
      if (usarListaBlanca && !permitir[id]) return false
      return true
    },

    filaAuditoriaSoloUsuariosActivosSn(item) {
      const ids = this.idsUsuariosReferenciadosEnAuditoria(item)
      if (!ids.length) return true
      return ids.every((id) => this.usuarioCumpleActivoSnParaVista(id))
    },

    esTextoNombreUsuarioValido(valor) {
      if (valor == null || valor === '') return false
      const s = String(valor).trim()
      if (!s) return false
      if (/^\d+$/.test(s)) return false
      return true
    },

    agregarReferenciasUsuarioDesdeAuditoria(referencias, item) {
      if (!item) return
      const idsCatalogo = new Set()
      ;(this.usuariosCatalogo || []).forEach((u) => {
        if (!u) return
        const n = this.normalizarUsuario(u)
        ;[n.iderp, n.idusuario, n.id_usuario]
          .filter((v) => v != null && v !== '')
          .forEach((v) => idsCatalogo.add(String(v)))
      })

      const agregarSiEnCatalogoErp = (idUsuario) => {
        if (idUsuario == null || idUsuario === '') return
        const k = String(idUsuario)
        if (!idsCatalogo.has(k)) return
        referencias.push({
          idusuario: idUsuario,
          iderp: idUsuario,
          usuario_registro: ''
        })
      }

      agregarSiEnCatalogoErp(item.id_auditor)
      agregarSiEnCatalogoErp(item.id_jefe_departamento)
      agregarSiEnCatalogoErp(item.id_responsable)

      const idRegistro =
        item.usuario_registro || item.id_usuario_creacion || item.id_usuario_actualizacion || item.id_auditor
      agregarSiEnCatalogoErp(idRegistro)
    },

    esEtiquetaMasLegible(candidata, actual) {
      const cand = String(candidata || '').trim()
      const act = String(actual || '').trim()

      if (!cand) return false
      if (!act) return true
      if (this.etiquetaUsuarioGenerica(act) && !this.etiquetaUsuarioGenerica(cand)) return true
      if (act.length < 5 && cand.length >= 5) return true
      return cand.length > act.length && !this.etiquetaUsuarioGenerica(cand)
    },

    normalizarUsuario(raw) {
      const item = raw || {}
      const nombreArmado = [item.nombre, item.apellido].filter(Boolean).join(' ').trim()
      const nombreUsuarioArmado = [item.nombre_usuario, item.apellido_usuario]
        .filter(Boolean)
        .join(' ')
        .trim()

      const candidatas = [
        item.label,
        item.nombre_mostrar,
        item.nombre_display,
        item.texto_select,
        item.nombre_completo,
        item.nombreCompleto,
        item.nombre,
        nombreArmado,
        nombreUsuarioArmado,
        typeof item.usuario === 'string' ? item.usuario : null,
        item.usuario_registro,
        item.nombre_usuario,
        this.nombreDesdeDatosCompletos(item),
        item.email
      ]

      let idusuario =
        item.idusuario != null && item.idusuario !== ''
          ? item.idusuario
          : item.id_usuario != null && item.id_usuario !== ''
            ? item.id_usuario
            : item.id != null && item.id !== ''
              ? item.id
              : null

      if (
        idusuario == null &&
        item.usuario_registro != null &&
        item.usuario_registro !== '' &&
        !Number.isNaN(Number(item.usuario_registro))
      ) {
        idusuario = item.usuario_registro
      }

      const iderpBruto = item.iderp != null && item.iderp !== '' ? item.iderp : item.IDERP != null && item.IDERP !== '' ? item.IDERP : null

      if ((idusuario == null || idusuario === '') && iderpBruto != null) {
        idusuario = iderpBruto
      }

      const etiqueta = candidatas.find((valor) => this.esTextoNombreUsuarioValido(valor))

      return {
        ...item,
        idusuario,
        id_usuario: item.id_usuario != null ? item.id_usuario : idusuario,
        iderp: iderpBruto != null ? iderpBruto : item.id_usuario != null ? item.id_usuario : idusuario,
        usuario_registro: String(etiqueta || '').trim(),
        nombre_completo: String(etiqueta || '').trim(),
        datos_completos: String(item.datos_completos || etiqueta || '').trim(),
        puesto: item.puesto || item.departamento_puesto || item.rol || ''
      }
    },

    construirMapaNombrePorCualquierId(filasReferenciaNombre) {
      const mapa = new Map()

      ;(Array.isArray(filasReferenciaNombre) ? filasReferenciaNombre : []).forEach((row) => {
        const normalizado = this.normalizarUsuario(row)
        const etiqueta = normalizado.usuario_registro
        const posiblesIds = [
          row && row.idusuario,
          row && row.id_usuario,
          row && row.iderp,
          row && row.id,
          row && row.usuario_registro,
          normalizado.idusuario,
          normalizado.id_usuario,
          normalizado.iderp
        ]

        posiblesIds.forEach((id) => {
          if (id == null || id === '' || Number.isNaN(Number(id)) && typeof id !== 'string') return
          const llave = String(id)
          const actual = mapa.get(llave)
          if (this.esEtiquetaMasLegible(etiqueta, actual)) {
            mapa.set(llave, etiqueta)
          } else if (!actual && etiqueta) {
            mapa.set(llave, etiqueta)
          }
        })
      })

      return mapa
    },

    combinarEtiquetasUsuarios(usuariosCatalogoNorm, filasReferenciaNombre) {
      const mapa = this.construirMapaNombrePorCualquierId(filasReferenciaNombre)
      return usuariosCatalogoNorm.map((u) => {
        const keyRaw = this.idParaSelectUsuario(u)
        if (keyRaw == null || keyRaw === '') return u
        const key = String(keyRaw)
        const mejor = mapa.get(key)
        if (mejor) return { ...u, usuario_registro: mejor, nombre_completo: mejor }
        return u
      })
    },

    dedupeUsuariosPorId(lista) {
      const map = new Map()
      ;(Array.isArray(lista) ? lista : []).forEach((u) => {
        if (u == null) return
        const idSel = this.idParaSelectUsuario(u)
        if (idSel == null || idSel === '') return
        const k = String(idSel)
        if (!map.has(k)) {
          map.set(k, u)
          return
        }

        const actual = map.get(k)
        if (this.esEtiquetaMasLegible(u.usuario_registro, actual.usuario_registro)) {
          map.set(k, { ...actual, ...u })
        }
      })
      return Array.from(map.values())
    },

    fusionarListaUsuariosParaSelects(usuariosRaw, filasNombre) {
      let lista = []
      const referencias = Array.isArray(filasNombre) ? filasNombre : []

      if (referencias.length) {
        lista = this.dedupeUsuariosPorId(referencias.map((u) => this.normalizarUsuario(u)))
      }

      const ids = new Set(
        lista.map((u) => this.idParaSelectUsuario(u)).filter((v) => v != null && v !== '').map((v) => String(v))
      )

      if (Array.isArray(usuariosRaw) && usuariosRaw.length) {
        usuariosRaw.forEach((raw) => {
          const n = this.normalizarUsuario(raw)
          const idSel = this.idParaSelectUsuario(n)
          if (idSel == null || idSel === '') return
          const k = String(idSel)

          if (ids.has(k)) {
            const idx = lista.findIndex((x) => String(this.idParaSelectUsuario(x)) === k)
            if (idx >= 0) {
              const cur = lista[idx]
              if (
                this.etiquetaUsuarioGenerica(cur.usuario_registro) &&
                !this.etiquetaUsuarioGenerica(n.usuario_registro) &&
                n.usuario_registro
              ) {
                lista[idx] = {
                  ...cur,
                  ...n,
                  usuario_registro: n.usuario_registro,
                  nombre_completo: n.usuario_registro
                }
              }
            }
            return
          }

          ids.add(k)
          lista.push(n)
        })
      }

      if (!lista.length && Array.isArray(usuariosRaw) && usuariosRaw.length) {
        lista = usuariosRaw.map((u) => this.normalizarUsuario(u))
        if (referencias.length) {
          lista = this.combinarEtiquetasUsuarios(lista, referencias)
        }
      }

      lista.sort((a, b) =>
        String(a.usuario_registro || '').localeCompare(String(b.usuario_registro || ''), 'es', {
          sensitivity: 'base'
        })
      )

      return lista
    },

    disambiguarEtiquetasUsuariosDuplicados(lista) {
      const grupos = {}
      ;(Array.isArray(lista) ? lista : []).forEach((item) => {
        const llave = this.normalizarTexto(item.usuario_registro)
        if (!llave) return
        if (!grupos[llave]) grupos[llave] = []
        grupos[llave].push(item)
      })

      return (Array.isArray(lista) ? lista : []).map((item) => {
        const llave = this.normalizarTexto(item.usuario_registro)
        const grupo = grupos[llave] || []
        if (grupo.length <= 1) return item

        const idDisamb = this.idParaSelectUsuario(item)
        const sufijo = ` (#${idDisamb != null ? idDisamb : item.idusuario})`
        return {
          ...item,
          usuario_registro: `${item.usuario_registro}${sufijo}`,
          nombre_completo: `${item.usuario_registro}${sufijo}`
        }
      })
    },

    normalizarDepartamento(row) {
      return {
        ...row,
        id:
          row && row.id != null
            ? row.id
            : row && row.id_departamento != null
              ? row.id_departamento
              : row && row.idDepartamento != null
                ? row.idDepartamento
                : null,
        nombre:
          (row && (row.nombre || row.nombre_departamento || row.departamento)) || ''
      }
    },

    normalizarPlantel(row) {
      return {
        ...row,
        idplantel:
          row && row.idplantel != null
            ? row.idplantel
            : row && row.id_plantel != null
              ? row.id_plantel
              : row && row.id != null
                ? row.id
                : null,
        plantel: (row && (row.plantel || row.nombre_plantel || row.nombre)) || ''
      }
    },

    normalizarCriterioPlantilla(row, index) {
      const criterio = row || {}
      const id =
        criterio.id_criterio_catalogo != null
          ? criterio.id_criterio_catalogo
          : criterio.id_criterio != null
            ? criterio.id_criterio
            : criterio.id != null
              ? criterio.id
              : index + 1

      return {
        ...criterio,
        id,
        id_criterio_catalogo: id,
        idVisual: criterio.idVisual != null ? criterio.idVisual : null,
        seccion:
          criterio.seccion ||
          criterio.categoria ||
          this.obtenerSeccionDesdeNombre(criterio.nombre_criterio || criterio.nombre),
        nombre: criterio.nombre_criterio || criterio.nombre || `Criterio ${id}`,
        descripcion: criterio.descripcion || criterio.detalle || '',
        calificacion: criterio.calificacion != null ? criterio.calificacion : null,
        evidencia: criterio.evidencia_hallazgo || criterio.evidencia || '',
        evidencia_hallazgo: criterio.evidencia_hallazgo || criterio.evidencia || ''
      }
    },

    normalizarAuditoriaListado(row) {
      const item = row || {}
      return {
        ...item,
        id: item.id,
        id_departamento:
          item.id_departamento != null
            ? item.id_departamento
            : item.departamento != null
              ? item.departamento
              : null,
        nombre_departamento:
          item.nombre_departamento || item.departamento || item.nombreDepartamento || '',
        tipo_auditoria: item.tipo_auditoria || item.tipoAuditoria || '',
        id_auditor:
          item.id_auditor != null
            ? item.id_auditor
            : typeof item.auditor === 'number' || (typeof item.auditor === 'string' && /^\d+$/.test(item.auditor))
              ? Number(item.auditor)
              : null,
        nombre_auditor:
          this.textoNombreHumano(item.nombre_auditor) || this.textoNombreHumano(item.auditor) || '',
        id_jefe_departamento:
          item.id_jefe_departamento != null ? item.id_jefe_departamento : item.jefeDepartamento || null,
        nombre_jefe: item.nombre_jefe || item.nombre_jefe_departamento || '',
        fecha_auditoria: this.formatearFechaInput(item.fecha_auditoria || item.fecha),
        estatus: item.estatus || 'Pendiente',
        hallazgos: item.hallazgos || '',
        accion_correctiva: item.accion_correctiva || item.accionCorrectiva || '',
        id_responsable:
          item.id_responsable != null ? item.id_responsable : item.responsable != null ? item.responsable : null,
        nombre_responsable: item.nombre_responsable || '',
        fecha_compromiso: this.formatearFechaInput(item.fecha_compromiso),
        evidencia_cierre: item.evidencia_cierre != null ? item.evidencia_cierre : '',
        id_plantel:
          item.id_plantel != null ? item.id_plantel : item.idplantel != null ? item.idplantel : null,
        nombre_plantel: item.nombre_plantel || item.plantel || '',
        resultado_porcentaje:
          item.resultado_porcentaje != null ? Number(item.resultado_porcentaje) : item.resultadoPorcentaje,
        criterios: Array.isArray(item.criterios) ? item.criterios : [],
        usuario_registro:
          item.usuario_registro != null ? item.usuario_registro : item.id_usuario_creacion || item.id_auditor || null,
        id_usuario_creacion: item.id_usuario_creacion != null ? item.id_usuario_creacion : null,
        id_usuario_actualizacion: item.id_usuario_actualizacion != null ? item.id_usuario_actualizacion : null,
        nombre_usuario_creacion:
          item.nombre_usuario_creacion || item.usuario_registro_nombre || item.nombre_auditor || ''
      }
    },

    parseHallazgosInformacionGeneral(texto) {
      const raw = texto || ''
      let modalidad = 'Inicial'
      let proceso = ''
      let resto = raw

      const lineas = raw.split(/\r?\n/)
      if (lineas.length && /^Modalidad:\s*(Inicial|Seguimiento)\s*$/i.test(lineas[0].trim())) {
        modalidad = lineas[0].replace(/^Modalidad:\s*/i, '').trim()
        resto = lineas.slice(1).join('\n').replace(/^\s+/, '')
      }

      const matchProc = resto.match(/^Proceso auditado:\s*(.*?)(?:\n\n([\s\S]*)|$)/is)
      if (matchProc) {
        proceso = (matchProc[1] || '').trim()
        resto = (matchProc[2] || '').trim()
      }

      return { modalidad, proceso, restoHallazgos: resto }
    },

    parseResumenHallazgos(texto) {
      const limpio = String(texto || '').trim()
      if (!limpio) {
        return { hallazgo1: '', hallazgo2: '', hallazgo3: '' }
      }

      const porNumero = [1, 2, 3].map((n) => {
        const re = new RegExp(`(?:^|\\n)\\s*${n}\\.\\s*(.*?)(?=(?:\\n\\s*[123]\\.\\s*)|$)`, 's')
        const m = limpio.match(re)
        return m ? String(m[1] || '').trim() : ''
      })

      if (porNumero.some((x) => x)) {
        return {
          hallazgo1: porNumero[0] || '',
          hallazgo2: porNumero[1] || '',
          hallazgo3: porNumero[2] || ''
        }
      }

      const lineas = limpio
        .split(/\r?\n/)
        .map((l) => l.trim())
        .filter(Boolean)

      return {
        hallazgo1: lineas[0] || '',
        hallazgo2: lineas[1] || '',
        hallazgo3: lineas[2] || ''
      }
    },

    construirResumenHallazgos() {
      return [
        `1. ${String(this.editedItem.hallazgo1 || '').trim()}`,
        `2. ${String(this.editedItem.hallazgo2 || '').trim()}`,
        `3. ${String(this.editedItem.hallazgo3 || '').trim()}`
      ].join('\n')
    },

    mapDetalleAFormulario(payload) {
      const item = this.extraerObjeto(payload) || {}
      const ph = this.parseHallazgosInformacionGeneral(item.hallazgos || '')
      const resumen = this.parseResumenHallazgos(ph.restoHallazgos)
      return {
        id: item.id != null ? item.id : null,
        departamento:
          item.id_departamento != null
            ? item.id_departamento
            : item.departamento != null
              ? item.departamento
              : null,
        idplantel:
          item.id_plantel != null ? item.id_plantel : item.idplantel != null ? item.idplantel : null,
        tipoAuditoria: this.tipoAuditoriaVisible(item.tipo_auditoria || item.tipoAuditoria || null),
        auditor: item.id_auditor != null ? item.id_auditor : item.auditor != null ? item.auditor : null,
        jefeDepartamento:
          item.id_jefe_departamento != null
            ? item.id_jefe_departamento
            : item.jefeDepartamento != null
              ? item.jefeDepartamento
              : null,
        fecha: this.formatearFechaInput(item.fecha_auditoria || item.fecha),
        estatus: item.estatus || 'Pendiente',
        estatusModalidad: ph.modalidad,
        procesoAuditado: ph.proceso,
        hallazgos: ph.restoHallazgos,
        hallazgo1: resumen.hallazgo1,
        hallazgo2: resumen.hallazgo2,
        hallazgo3: resumen.hallazgo3,
        accionCorrectiva: item.accion_correctiva || item.accionCorrectiva || '',
        responsable:
          item.id_responsable != null ? item.id_responsable : item.responsable != null ? item.responsable : null,
        fechaCompromiso: this.formatearFechaInput(item.fecha_compromiso || item.fechaCompromiso),
        evidenciaCierre: item.evidencia_cierre != null ? item.evidencia_cierre : ''
      }
    },

    obtenerSeccionDesdeNombre(nombre) {
      const texto = this.normalizarTexto(nombre)
      if (texto.includes('planeación') || texto.includes('planeacion')) return 'PLANEACIÓN'
      if (texto.includes('ejecución') || texto.includes('ejecucion')) return 'EJECUCIÓN'
      if (texto.includes('verificación') || texto.includes('verificacion')) return 'VERIFICACIÓN'
      if (texto.includes('actuación') || texto.includes('actuacion')) return 'ACTUACIÓN'
      return 'GENERAL'
    },

    obtenerSeccionCriterio(criterio) {
      return criterio.seccion || this.obtenerSeccionDesdeNombre(criterio.nombre)
    },

    aplicarCriteriosDesdeApi(criteriosApi) {
      const criteriosEntrada = Array.isArray(criteriosApi) ? criteriosApi : []
      const plantilla = this.criteriosVacios()

      const mapaApi = new Map()
      criteriosEntrada.forEach((item, index) => {
        const normalizado = this.normalizarCriterioPlantilla(item, index)
        const textoCanonico = this.normalizarTexto(textoPreguntaCanonicaCriterio(normalizado))
        const textoApi = this.normalizarTexto(normalizado.nombre)
        const keys = [
          normalizado.id,
          normalizado.idVisual,
          normalizado.id_criterio,
          normalizado.id_criterio_catalogo,
          item && item.id,
          item && item.idVisual,
          item && item.id_criterio,
          item && item.id_criterio_catalogo
        ].filter((valor) => valor != null && valor !== '')

        if (textoCanonico) keys.push(`txt:${textoCanonico}`)
        if (textoApi) keys.push(`txt:${textoApi}`)

        keys.forEach((key) => {
          mapaApi.set(String(key), normalizado)
        })
      })

      const fusionados = plantilla.map((base) => {
        const match =
          mapaApi.get(String(base.idVisual)) ||
          mapaApi.get(String(base.id)) ||
          mapaApi.get(String(base.id_criterio_catalogo)) ||
          mapaApi.get(String(base.id_criterio)) ||
          mapaApi.get(`txt:${this.normalizarTexto(base.nombre)}`) ||
          null

        if (!match) {
          return {
            ...base,
            calificacion: base.calificacion != null ? base.calificacion : null,
            evidencia: base.evidencia || '',
            evidencia_hallazgo: base.evidencia_hallazgo || ''
          }
        }

        return {
          ...base,
          id: base.id,
          id_criterio_catalogo: base.id_criterio_catalogo || match.id_criterio_catalogo || match.id,
          nombre:
            textoPreguntaCanonicaCriterio(base) ||
            match.nombre ||
            match.nombre_criterio ||
            base.nombre,
          descripcion: match.descripcion || base.descripcion,
          seccion: base.seccion,
          calificacion: match.calificacion != null ? match.calificacion : base.calificacion,
          evidencia: match.evidencia || match.evidencia_hallazgo || base.evidencia || '',
          evidencia_hallazgo:
            match.evidencia_hallazgo || match.evidencia || base.evidencia_hallazgo || ''
        }
      })

      const fotosMap = {}
      fusionados.forEach((item) => {
        if (!this.esCriterioFotoComentario(item)) return
        const separado = this.separarEvidenciaYFoto(item.evidencia || item.evidencia_hallazgo)
        item.evidencia = separado.comentario
        item.evidencia_hallazgo = separado.comentario
        if (separado.fotoBase64) {
          fotosMap[this.claveCriterioPhva(item)] = separado.fotoBase64
        }
      })

      this.fotosEvidenciaPhva = fotosMap

      this.criterios = fusionados
      return fusionados
    },

    resolverPuntosCalificacion(calificacion) {
      if (calificacion === '1 - No cumple') return 1
      if (calificacion === '2 - Parcial') return 2
      if (calificacion === '3 - Cumple totalmente') return 3
      return null
    },

    calcularResultadoPorcentaje(criterios) {
      const lista = Array.isArray(criterios) ? criterios : []
      let puntos = 0
      let maximo = 0

      lista.forEach((item) => {
        const calificacion =
          item.calificacion != null
            ? item.calificacion
            : item.calificacion_phva != null
              ? item.calificacion_phva
              : null

        const puntaje = this.resolverPuntosCalificacion(calificacion)
        if (puntaje == null) return
        puntos += puntaje
        maximo += 3
      })

      if (!maximo) return 0
      return Number(((puntos / maximo) * 100).toFixed(2))
    },

    formatPorcentaje(valor) {
      if (valor == null || valor === '' || Number.isNaN(Number(valor))) return '0.00%'
      return `${Number(valor).toFixed(2)}%`
    },

    getTipoColor(tipo) {
      return tipo === 'Auditoría 5S' ? 'orange' : 'blue'
    },

    nombrePlantel(id, fallback) {
      if (id != null && this.mapaNombrePlantelPorId[String(id)]) {
        return this.mapaNombrePlantelPorId[String(id)]
      }
      return fallback || ''
    },

    nombreDepartamento(id, fallback) {
      if (id != null && id !== '') {
        const match = (this.departamentos || []).find((item) => String(item.id) === String(id))
        if (match && match.nombre) return match.nombre
      }
      return fallback || ''
    },

    obtenerNombreUsuario(id, fallback) {
      if (id != null && this.mapaNombreUsuarioPorId[String(id)]) {
        return this.mapaNombreUsuarioPorId[String(id)]
      }
      return fallback || ''
    },

    textoBusquedaAuditoria(item) {
      return this.normalizarTexto(
        [
          item.id,
          item.departamento,
          item.nombrePlantel,
          item.tipoAuditoria,
          item.auditor,
          item.jefeDepartamento,
          item.responsable,
          item.estatus,
          item.usuario_registro_nombre,
          item.fecha,
          this.formatPorcentaje(item.resultadoPorcentaje)
        ].join(' ')
      )
    },

    textoBusquedaControlInterno(item) {
      return this.normalizarTexto(
        [
          item.id,
          item.objetivo,
          item.departamento,
          item.dirigidoA,
          item.nombrePlantel,
          item.responsablePlantel,
          item.fechaAuditoria
        ].join(' ')
      )
    },

    construirQueryAuditorias() {
      const query = {
        tipo_auditoria: this.filtros.tipoAuditoria || undefined,
        estatus: this.filtros.estatus || undefined,
        id_departamento:
          this.filtros.departamento != null && this.filtros.departamento !== ''
            ? this.filtros.departamento
            : undefined,
        id_plantel:
          this.filtros.plantel != null && this.filtros.plantel !== '' ? this.filtros.plantel : undefined,
        id_auditor:
          this.filtros.colaborador != null && this.filtros.colaborador !== ''
            ? this.filtros.colaborador
            : undefined,
        fecha_inicio: this.filtros.fechaini || undefined,
        fecha_fin: this.filtros.fechafin || undefined,
        page: 1,
        per_page: 500
      }

      Object.keys(query).forEach((key) => {
        if (query[key] === undefined || query[key] === null || query[key] === '') {
          delete query[key]
        }
      })

      return query
    },

    construirQueryControlInterno() {
      // Pedimos por ciclo si el API ya soporta id_ciclo; si no, el front filtra en cliente.
      const query = {
        id_ciclo:
          this.filtros.id_ciclo != null && this.filtros.id_ciclo !== ''
            ? this.filtros.id_ciclo
            : undefined,
        page: 1,
        per_page: 1000
      }

      Object.keys(query).forEach((key) => {
        if (query[key] === undefined || query[key] === null || query[key] === '') {
          delete query[key]
        }
      })

      return query
    },

    async cargarCatalogos() {
      let responseUsuariosCatalogo = { data: [] }
      this.usuariosCatalogoEsEndpointAuditoria = false
      try {
        responseUsuariosCatalogo = await this.$http.get('catalogs/usuarios/auditoria')
        this.usuariosCatalogoEsEndpointAuditoria = true
      } catch (error) {
        responseUsuariosCatalogo = await this.$http.get('catalogs/usuarios').catch(() => ({ data: [] }))
      }

      const [
        responseDepartamentos,
        responsePlanteles,
        responseCriterios,
        responseUsuariosAll,
        responseUsuariosAllErp
      ] = await Promise.all([
        this.$http.get('catalogs/departamentos').catch(() => ({ data: [] })),
        this.$http.get('catalogs/planteles').catch(() => ({ data: [] })),
        this.$http.get('catalogs/auditorias/criterios').catch(() => ({ data: [] })),
        this.$http.get('usuarios.all').catch(() => ({ data: [] })),
        this.$http.get('usuarios.all.erp').catch(() => ({ data: [] }))
      ])

      this.departamentos = this.extraerArray(responseDepartamentos)
        .map((item) => this.normalizarDepartamento(item))
        .sort((a, b) => String(a.nombre).localeCompare(String(b.nombre), 'es', { sensitivity: 'base' }))

      this.planteles = this.extraerArray(responsePlanteles)
        .map((item) => this.normalizarPlantel(item))
        .sort((a, b) => String(a.plantel).localeCompare(String(b.plantel), 'es', { sensitivity: 'base' }))

      const rawUsuariosCatalogo = this.extraerArray(responseUsuariosCatalogo)
      const rawUsuariosAll = this.extraerArray(responseUsuariosAll)
      const rawUsuariosAllErp = this.extraerArray(responseUsuariosAllErp)

      this.idsUsuariosInactivos = this.obtenerMapaIdsUsuariosInactivos([
        rawUsuariosCatalogo,
        rawUsuariosAll,
        rawUsuariosAllErp
      ])

      this.usuariosCatalogo = rawUsuariosCatalogo.filter((u) => this.filaUsuarioActivoParaSelect(u))
      this.usuariosAll = rawUsuariosAll.filter((u) => this.filaUsuarioActivoParaSelect(u))
      this.usuariosAllErp = rawUsuariosAllErp.filter((u) => this.filaUsuarioActivoParaSelect(u))

      this.idsUsuariosPermitidosEnSelects = this.recopilarIdsUsuariosPermitidosDesdeCatalogosCargados([
        this.usuariosCatalogo,
        this.usuariosAll,
        // Importante: `usuarios.all.erp` trae los `idusuario` del nuevo ERP (FK de auditorías).
        // Si no lo incluimos, se ocultan filas al validar "usuarios activos" en la tabla.
        this.usuariosAllErp
      ])

      const criteriosApi = this.extraerArray(responseCriterios)
      this.criteriosPlantilla = criteriosApi.length
        ? criteriosApi.map((item, index) => this.normalizarCriterioPlantilla(item, index))
        : this.criteriosVacios()
    },

    async ensureCriteriosPlantilla() {
      if (this.criteriosPlantilla.length) {
        return this.criteriosPlantilla
      }

      try {
        const response = await this.$http.get('catalogs/auditorias/criterios')
        const lista = this.extraerArray(response)
        this.criteriosPlantilla = lista.length
          ? lista.map((item, index) => this.normalizarCriterioPlantilla(item, index))
          : this.criteriosVacios()
      } catch (error) {
        this.criteriosPlantilla = this.criteriosVacios()
      }

      return this.criteriosPlantilla
    },

    dedupeAuditoriasListadoPorId(filas) {
      const visto = new Set()
      return (Array.isArray(filas) ? filas : []).filter((row) => {
        if (!row || row.id == null || row.id === '') return true
        const k = String(row.id)
        if (visto.has(k)) return false
        visto.add(k)
        return true
      })
    },

    async obtenerAuditorias() {
      this.cargandoAuditorias = true

      try {
        const response = await this.$http.get('auditorias', {
          params: this.construirQueryAuditorias()
        })

        const normalizadas = this.extraerArray(response).map((item) => this.normalizarAuditoriaListado(item))
        this.auditorias = this.dedupeAuditoriasListadoPorId(normalizadas)
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudieron cargar las auditorías.'
        this.validarErrorDirecto(mensaje)
        this.auditorias = []
      } finally {
        this.cargandoAuditorias = false
      }
    },

    async obtenerControlInternoAuditorias() {
      const aplicarLista = (response) => {
        const lista = this.extraerArray(response)
        const vistos = {}
        this.controlInternoAuditorias = lista.filter((item) => {
          if (!item || item.id == null || item.id === '') return true
          const llave = String(item.id)
          if (vistos[llave]) return false
          vistos[llave] = true
          return true
        })
        return this.controlInternoAuditorias.length
      }

      try {
        const response = await this.$http.get('auditorias/control-interno', {
          params: this.construirQueryControlInterno()
        })
        const total = aplicarLista(response)
        // Si el API ignoró id_ciclo o aún no lo soporta, recargar sin filtro y filtrar en cliente.
        if (
          total === 0 &&
          this.filtros.id_ciclo != null &&
          this.filtros.id_ciclo !== ''
        ) {
          const responseAll = await this.$http.get('auditorias/control-interno', {
            params: { page: 1, per_page: 1000 }
          })
          aplicarLista(responseAll)
        }
      } catch (error) {
        try {
          const response = await this.$http.get('auditorias/control-interno', {
            params: { page: 1, per_page: 1000 }
          })
          aplicarLista(response)
        } catch (error2) {
          const mensaje =
            (error2.response && error2.response.data && error2.response.data.message) ||
            (error.response && error.response.data && error.response.data.message) ||
            error2.message ||
            error.message ||
            'No se pudieron cargar las auditorías de control interno.'
          this.validarErrorDirecto(mensaje)
          this.controlInternoAuditorias = []
        }
      }
    },

    async obtenerReporteDepartamentos() {
      try {
        const response = await this.$http.get('auditorias/reporte/departamentos', {
          params: this.construirQueryAuditorias()
        })

        this.reporteAuditorias = this.extraerArray(response).map((item) => ({
          ...item,
          id_departamento:
            item.id_departamento != null
              ? item.id_departamento
              : item.id != null
                ? item.id
                : null,
          departamento: item.nombre_departamento || item.departamento || '',
          auditorias5s:
            item.auditorias_5s != null ? Number(item.auditorias_5s) : Number(item.auditorias5s || 0),
          auditoriasProcesos:
            item.auditorias_procesos != null
              ? Number(item.auditorias_procesos)
              : Number(item.auditoriasProcesos || 0),
          promedioResultado:
            item.promedio_resultado != null
              ? Number(item.promedio_resultado)
              : Number(item.promedioResultado || 0)
        }))
      } catch (error) {
        this.reporteAuditorias = []
      }
    },

    async initialize() {
      this.cargar = true
      try {
        await this.cargarCatalogos()
        await this.obtenerCiclos()
        await Promise.all([
          this.obtenerAuditorias(),
          this.obtenerReporteDepartamentos(),
          this.obtenerControlInternoAuditorias()
        ])
      } finally {
        this.cargar = false
      }
    },

    async obtenerCiclos() {
      try {
        const response = await this.$http.get('kpi.ciclos.all', {
          params: { pasados: 12, futuros: 2 }
        })
        this.ciclos = Array.isArray(response.data) ? response.data : this.extraerArray(response)
        if (
          (this.filtros.id_ciclo == null || this.filtros.id_ciclo === '') &&
          this.ciclos &&
          this.ciclos.length
        ) {
          const hoy = this.fechaMaxima
          const cicloActual = this.ciclos.find((item) => {
            const inicio = this.formatearFechaInput(item.fecha_inicio_ciclo)
            const fin = this.formatearFechaInput(item.fecha_fin_ciclo)
            return inicio && fin && hoy >= inicio && hoy <= fin
          })
          this.filtros.id_ciclo = cicloActual
            ? cicloActual.id_ciclo
            : this.ciclos[this.ciclos.length - 1].id_ciclo
        }
      } catch (error) {
        this.ciclos = []
      }
    },

    async onCambioCicloControlInterno() {
      if (this.esTabEvaluacionPersonal) return
      this.cargandoControlInternoCiclo = true
      try {
        await this.obtenerControlInternoAuditorias()
      } finally {
        this.cargandoControlInternoCiclo = false
      }
    },

    agregarControlInternoDesdeSucursal(sucursal) {
      if (!this.filtros.id_ciclo) {
        this.validarErrorDirecto('Selecciona un ciclo antes de agregar la auditoría.')
        return
      }
      this.openDialogControlInterno()
      this.editedControlInternoItem.idplantel = sucursal && sucursal.id_plantel != null
        ? sucursal.id_plantel
        : null
      this.editedControlInternoItem.id_ciclo = this.filtros.id_ciclo
      this.editedControlInternoItem.estatus = 'En curso'
      if (!this.editedControlInternoItem.fechaAuditoria) {
        this.editedControlInternoItem.fechaAuditoria = this.fechaMaxima
      }
      this.cargarSalonesControlInterno(false)
      this.cargarTicketsControlInterno()
      this.cargarPersonalCorporativoControlInterno()
    },

    aplicarDefaultsAuditoriaSiFaltan() {
      if (!this.editedItem.tipoAuditoria && this.tiposAuditoriaNombres && this.tiposAuditoriaNombres.length) {
        this.editedItem.tipoAuditoria = this.tiposAuditoria[0] ? this.tiposAuditoria[0].nombre : null
      }
      if (!this.editedItem.procesoAuditado && this.editedItem.tipoAuditoria) {
        this.editedItem.procesoAuditado = this.editedItem.tipoAuditoria
      }
      if (!this.editedItem.estatusModalidad || !ESTATUS_VALIDOS.includes(this.editedItem.estatusModalidad)) {
        this.editedItem.estatusModalidad = 'Inicial'
      }
      this.editedItem.estatus = this.editedItem.estatusModalidad
      if (
        (this.editedItem.idplantel == null || this.editedItem.idplantel === '') &&
        this.planteles &&
        this.planteles.length
      ) {
        this.editedItem.idplantel = this.planteles[0].idplantel
      }
      if (
        (this.editedItem.responsable == null || this.editedItem.responsable === '') &&
        this.editedItem.auditor != null &&
        this.editedItem.auditor !== ''
      ) {
        this.editedItem.responsable = this.idResponsableSelectDesdeIdUsuarioOAuditor(this.editedItem.auditor)
      }
      if (this.criterios && this.criterios.length) {
        this.criterios.forEach((c) => {
          if (c.calificacion == null || c.calificacion === '') {
            c.calificacion = 'N/A'
          }
        })
      }
    },

    validarFormularioAuditoria() {
      this.aplicarDefaultsAuditoriaSiFaltan()

      if (this.editedItem.departamento == null || this.editedItem.departamento === '') {
        this.validarErrorDirecto('Selecciona el departamento o área.')
        return false
      }

      if (this.editedItem.auditor == null || this.editedItem.auditor === '') {
        this.validarErrorDirecto('Selecciona el auditor.')
        return false
      }

      if (this.editedItem.jefeDepartamento == null || this.editedItem.jefeDepartamento === '') {
        this.validarErrorDirecto('Selecciona el jefe de departamento.')
        return false
      }

      if (!this.editedItem.fecha) {
        this.validarErrorDirecto('Selecciona la fecha de auditoría.')
        return false
      }

      if (this.editedItem.fecha > this.fechaMaxima) {
        this.validarErrorDirecto('La fecha de auditoría no puede ser mayor a hoy.')
        return false
      }

      if (
        !this.editedItem.estatusModalidad ||
        !['Inicial', 'Seguimiento'].includes(this.editedItem.estatusModalidad)
      ) {
        this.validarErrorDirecto('Selecciona el estatus (Inicial o Seguimiento).')
        return false
      }

      if (!this.editedItem.tipoAuditoria || !this.tiposAuditoriaNombres.includes(this.editedItem.tipoAuditoria)) {
        this.validarErrorDirecto('No hay tipo de auditoría disponible.')
        return false
      }

      if (this.editedItem.idplantel == null || this.editedItem.idplantel === '') {
        this.validarErrorDirecto('No hay plantel disponible; contacta al administrador.')
        return false
      }

      if (this.editedItem.responsable == null || this.editedItem.responsable === '') {
        this.validarErrorDirecto('Selecciona el responsable del plan de acción.')
        return false
      }

      if (!this.criterios.length) {
        this.validarErrorDirecto('No hay criterios disponibles para guardar la auditoría.')
        return false
      }

      const criterioSinCalificacion = this.criterios.find(
        (item) => !item.calificacion || !this.calificacionesValidas.includes(item.calificacion)
      )

      if (criterioSinCalificacion) {
        this.validarErrorDirecto('Los criterios no pudieron inicializarse correctamente.')
        return false
      }

      return true
    },

    construirPayloadAuditoria() {
      const idSesion = this.obtenerIdSesion()
      const partesCabecera = []
      if (this.editedItem.estatusModalidad) {
        partesCabecera.push(`Modalidad: ${this.editedItem.estatusModalidad}`)
      }
      const procesoAuditado = String(this.editedItem.procesoAuditado || this.editedItem.tipoAuditoria || '').trim()
      if (procesoAuditado) {
        partesCabecera.push(`Proceso auditado: ${procesoAuditado}`)
      }
      const prefHallazgos = partesCabecera.length ? `${partesCabecera.join('\n')}\n\n` : ''
      const resumenHallazgos = this.construirResumenHallazgos()

      // Mapear cada criterio con su sección para agregar evidencia general
      const seccionPorCriterio = {}
      this.criterios.forEach((c) => {
        const seccion = c.seccion || ''
        if (!seccionPorCriterio[seccion]) {
          seccionPorCriterio[seccion] = []
        }
        seccionPorCriterio[seccion].push(c)
      })

      const payload = {
        id_departamento: this.editedItem.departamento,
        tipo_auditoria: this.tipoAuditoriaParaBackend(this.editedItem.tipoAuditoria),
        id_auditor: this.resolverIdUsuarioFkParaPayload(this.editedItem.auditor, false),
        // Igual que responsable: la FK en auditorías valida contra catálogo ERP (iderp / idusuario),
        // así que forzamos a usar `iderp` cuando esté disponible.
        // En UI guardamos `idusuario` (PK nuevo ERP); el backend ya normaliza si llega `iderp`.
        id_jefe_departamento: this.resolverIdUsuarioFkParaPayload(this.editedItem.jefeDepartamento, false),
        fecha_auditoria: this.editedItem.fecha,
        estatus: this.editedItem.estatusModalidad || this.editedItem.estatus || 'Inicial',
        hallazgos: prefHallazgos + resumenHallazgos,
        accion_correctiva: this.editedItem.accionCorrectiva || '',
        id_responsable: this.resolverIdUsuarioFkParaPayload(this.editedItem.responsable, true),
        fecha_compromiso: this.editedItem.fechaCompromiso || null,
        evidencia_cierre:
          this.editedItem.evidenciaCierre != null &&
          String(this.editedItem.evidenciaCierre).trim() !== ''
            ? this.editedItem.evidenciaCierre
            : null,
        id_plantel: this.editedItem.idplantel,
        criterios: this.criterios.map((item) => {
          // Obtener evidencia general para la sección de este criterio
          const seccionDelCriterio = item.seccion || ''
          const evidenciaGeneral = this.evidenciasGeneralesPhva[seccionDelCriterio] || ''
          const fotoGeneral = this.obtenerFotoEvidenciaGeneral(seccionDelCriterio)
          
          // Combinar evidencia individual con general
          const evidenciaIndividual = item.evidencia || item.evidencia_hallazgo || ''
          const evidenciaFinal = [
            evidenciaIndividual,
            evidenciaGeneral
          ].filter((e) => e && String(e).trim())
            .join('\n---\n')

          // Construir evidencia con foto (individual o general)
          let evidenciaConFoto = evidenciaFinal
          if (this.esCriterioFotoComentario(item)) {
            evidenciaConFoto = this.construirEvidenciaConFoto(
              evidenciaFinal || '',
              this.obtenerFotoEvidencia(item)
            )
          } else if (fotoGeneral) {
            evidenciaConFoto = this.construirEvidenciaConFoto(
              evidenciaFinal || '',
              fotoGeneral
            )
          }

          return {
            evidencia_hallazgo: evidenciaConFoto || '',
            id_criterio: item.id_criterio_catalogo || item.id,
            nombre_criterio: item.nombre,
            descripcion: item.descripcion,
            calificacion: item.calificacion
          }
        })
      }

      if (idSesion != null) {
        if (this.editedItem.id) {
          payload.id_usuario_actualizacion = idSesion
        } else {
          payload.id_usuario_creacion = idSesion
          payload.id_usuario_actualizacion = idSesion
        }
      }

      return payload
    },

    openDialogActivo() {
      if (this.esTabEvaluacionPersonal) {
        return this.openDialog()
      }
      this.openDialogControlInterno()
      return null
    },

    openDialogControlInterno() {
      this.editedControlInternoIndex = -1
      this.editedControlInternoItem = crearDefaultControlInternoItem()
      this.editedControlInternoItem.id_ciclo = this.filtros.id_ciclo || null
      this.aplicarCamposFijosControlInterno(this.editedControlInternoItem)
      this.cerrarDialogFirmaControlInterno()
      this.dialogControlInterno = true
    },

    fechaHoyLocal() {
      const hoy = new Date()
      const mes = String(hoy.getMonth() + 1).padStart(2, '0')
      const dia = String(hoy.getDate()).padStart(2, '0')
      return `${hoy.getFullYear()}-${mes}-${dia}`
    },

    /**
     * Objetivo y departamento siempre fijos. El auditor asignado al programar/editar se respeta;
     * si no hay, es el usuario logueado. La fecha es la de hoy mientras no esté cerrada.
     */
    aplicarCamposFijosControlInterno(item) {
      if (!item) return
      item.objetivo = OBJETIVO_CONTROL_INTERNO
      item.departamento = this.departamentoOperaciones ? this.departamentoOperaciones.id : null
      const cerrada = item.id && item.estatus === 'Cerrada'
      if (item.idAuditor == null || item.idAuditor === '') {
        item.idAuditor = this.obtenerIdSesion()
      }
      if (!cerrada || !item.fechaAuditoria) {
        item.fechaAuditoria = this.fechaHoyLocal()
      }
      this.sincronizarHallazgosDepartamentoControlInterno(item)
    },

    urlEvidenciaControlInterno(evidencia) {
      if (!evidencia || !evidencia.archivo) return ''
      const base = this.$http.defaults.baseURL || '/'
      return `${base}${base.slice(-1) === '/' ? '' : '/'}evidencia-auditorias-control-interno/${evidencia.archivo}`
    },

    abrirSelectorEvidenciaControlInterno(criterio, modo) {
      const refs = {
        foto: 'inputEvidenciaCIFoto',
        video: 'inputEvidenciaCIVideo',
        archivo: 'inputEvidenciaCIArchivo'
      }
      const input = this.$refs[refs[modo] || refs.archivo]
      if (!input || !criterio) return
      this.criterioEvidenciaControlInterno = criterio
      input.value = ''
      input.click()
    },

    async onArchivosEvidenciaControlInterno(event) {
      const criterio = this.criterioEvidenciaControlInterno
      const archivos = event && event.target && event.target.files ? Array.from(event.target.files) : []
      if (event && event.target) event.target.value = ''
      if (!criterio || !archivos.length) return

      const maxBytes = MAX_MB_EVIDENCIA_CONTROL_INTERNO * 1024 * 1024
      const validos = archivos.filter((archivo) => {
        const tipo = String(archivo.type || '')
        if (tipo && tipo.indexOf('image/') !== 0 && tipo.indexOf('video/') !== 0) {
          this.validarErrorDirecto(`"${archivo.name}" no es una foto ni un video.`)
          return false
        }
        if (archivo.size > maxBytes) {
          this.validarErrorDirecto(`"${archivo.name}" supera los ${MAX_MB_EVIDENCIA_CONTROL_INTERNO} MB.`)
          return false
        }
        return true
      })
      if (!validos.length) return

      if (!Array.isArray(criterio.evidencias)) this.$set(criterio, 'evidencias', [])
      this.$set(this.subiendoEvidenciaControlInterno, criterio.id, true)
      try {
        for (const archivo of validos) {
          const formData = new FormData()
          formData.append('archivo', archivo)
          const response = await this.$http.post('auditorias/control-interno/evidencia', formData)
          const subida = this.extraerObjeto(response)
          if (subida && subida.archivo) {
            criterio.evidencias.push({
              archivo: subida.archivo,
              tipo: subida.tipo,
              nombre_original: subida.nombre_original || archivo.name
            })
          }
        }
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudo subir la evidencia.'
        this.validarErrorDirecto(mensaje)
      } finally {
        this.$delete(this.subiendoEvidenciaControlInterno, criterio.id)
      }
    },

    quitarEvidenciaControlInterno(criterio, index) {
      if (!criterio || !Array.isArray(criterio.evidencias)) return
      criterio.evidencias.splice(index, 1)
    },

    mapControlInternoAFormulario(item) {
      const row = item || {}
      const retroRaw = row.retroalimentacion || {}
      const metodologiaRaw = row.metodologia5s || row.metodologia_5s || {}
      return {
        id: row.id != null ? row.id : null,
        objetivo: row.objetivo || '',
        departamento:
          row.id_departamento != null
            ? row.id_departamento
            : row.departamento != null
              ? row.departamento
              : null,
        dirigidoA:
          row.id_dirigido_a != null
            ? row.id_dirigido_a
            : row.dirigidoA != null
              ? row.dirigidoA
              : null,
        idplantel:
          row.id_plantel != null
            ? row.id_plantel
            : row.idplantel != null
              ? row.idplantel
              : null,
        id_ciclo:
          row.id_ciclo != null
            ? row.id_ciclo
            : row.idCiclo != null
              ? row.idCiclo
              : this.filtros.id_ciclo || null,
        responsablePlantel:
          row.id_responsable_plantel != null
            ? this.idResponsableSelectDesdeIdUsuarioOAuditor(row.id_responsable_plantel) || row.id_responsable_plantel
            : row.responsablePlantel != null
              ? row.responsablePlantel
              : null,
        idAuditor: this.normalizarIdNumericoControlInterno(
          row.id_auditor != null ? row.id_auditor : row.idAuditor
        ),
        nombreAuditor: row.nombre_auditor || '',
        fechaAuditoria: this.formatearFechaInput(row.fecha_auditoria || row.fechaAuditoria),
        fechaProgramada: this.formatearFechaInput(row.fecha_programada || row.fechaProgramada),
        horaInicio: this.formatearHoraInput(row.hora_inicio || row.horaInicio),
        horaTermino: this.formatearHoraInput(row.hora_termino || row.horaTermino),
        estatus: row.estatus || 'Cerrada',
        criterios: this.normalizarCriteriosControlInterno(row.criterios),
        salones: this.normalizarSalonesControlInterno(row.salones),
        oficinas: (Array.isArray(row.oficinas) ? row.oficinas : []).map((oficina) => crearOficinaControlInterno(oficina)),
        observacionesSalones: row.observacionesSalones || row.observaciones_salones || '',
        corte: this.normalizarCorteControlInterno(row.corte),
        vestimenta: this.normalizarVestimentaControlInterno(row.vestimenta),
        riAtencionAlumno: this.normalizarRiAtencionAlumnoControlInterno(row.riAtencionAlumno || row.ri_atencion_alumno),
        metodologia5s: this.normalizarMetodologia5sControlInterno(metodologiaRaw),
        retroalimentacion: this.normalizarRetroalimentacionControlInterno(retroRaw, {
          ...metodologiaRaw,
          climaGeneral:
            (retroRaw && retroRaw.climaGeneral) ||
            metodologiaRaw.climaGeneral ||
            row.metodologia_clima_general ||
            null,
          comunicacion:
            (retroRaw && retroRaw.comunicacion) ||
            metodologiaRaw.comunicacion ||
            row.metodologia_comunicacion ||
            null,
          organizacionTurnos:
            (retroRaw && retroRaw.organizacionTurnos) ||
            metodologiaRaw.organizacionTurnos ||
            row.metodologia_organizacion_turnos ||
            null,
          liderazgo:
            (retroRaw && retroRaw.liderazgo) ||
            metodologiaRaw.liderazgo ||
            row.metodologia_liderazgo ||
            null,
          operacion:
            (retroRaw && retroRaw.operacion) ||
            metodologiaRaw.operacion ||
            row.metodologia_operacion ||
            null
        }),
        cierreAuditoria: this.normalizarCierreAuditoriaControlInterno({
          ...(row.cierreAuditoria || row.cierre_auditoria || {}),
          nivelGeneral:
            (row.cierreAuditoria && row.cierreAuditoria.nivelGeneral) ||
            (row.cierre_auditoria && row.cierre_auditoria.nivel_general) ||
            row.metodologia_nivel_general ||
            metodologiaRaw.nivelGeneral ||
            null
        })
      }
    },

    normalizarCriteriosControlInterno(criterios) {
      const criteriosEntrada = Array.isArray(criterios) ? criterios : []
      const mapa = new Map()
      criteriosEntrada.forEach((item) => {
        if (!item || item.id == null) return
        mapa.set(String(item.id), item)
      })

      return clonarCriteriosControlInterno().map((base) => {
        const match = mapa.get(String(base.id))
        return {
          ...base,
          resultado: match && match.resultado ? match.resultado : null,
          evidencias: match && Array.isArray(match.evidencias) ? match.evidencias.map((ev) => ({ ...ev })) : []
        }
      })
    },

    normalizarSalonesControlInterno(salones) {
      const entrada = Array.isArray(salones) ? salones : []
      return entrada.filter((item) => item).map((item, index) => crearSalonControlInterno(item, index))
    },

    /**
     * Arma la sección de salones con los salones activos de la sucursal.
     * Con conservarGuardados se respetan las marcas ya capturadas (por id_salon); las auditorías
     * anteriores al catálogo (sin id_salon) se dejan tal como se guardaron.
     */
    async cargarSalonesControlInterno(conservarGuardados) {
      const item = this.editedControlInternoItem
      const idPlantel = item ? item.idplantel : null
      const actuales = conservarGuardados && Array.isArray(item.salones) ? item.salones : []

      if (esPlantelCorporativoControlInterno(idPlantel)) {
        item.salones = []
        return
      }
      if (conservarGuardados && actuales.length && actuales.every((s) => s.id_salon == null)) return
      if (idPlantel == null || idPlantel === '') {
        item.salones = []
        return
      }

      const solicitud = (this.solicitudSalonesControlInterno || 0) + 1
      this.solicitudSalonesControlInterno = solicitud
      this.cargandoSalonesControlInterno = true
      try {
        const response = await this.$http.get(`auditorias/control-interno/salones/${idPlantel}`)
        if (solicitud !== this.solicitudSalonesControlInterno || item !== this.editedControlInternoItem) return

        const catalogo = this.extraerArray(response)
        const guardadosPorId = new Map()
        actuales.forEach((s) => {
          if (s.id_salon != null) guardadosPorId.set(String(s.id_salon), s)
        })

        const filas = catalogo.map((salon, index) =>
          crearSalonControlInterno(
            {
              ...(guardadosPorId.get(String(salon.id_salon)) || {}),
              salon: index + 1,
              id_salon: salon.id_salon,
              nombre: salon.salon
            },
            index
          )
        )
        const idsCatalogo = new Set(catalogo.map((salon) => String(salon.id_salon)))
        actuales
          .filter((s) => s.id_salon != null && !idsCatalogo.has(String(s.id_salon)))
          .forEach((s) => filas.push(crearSalonControlInterno({ ...s, salon: filas.length + 1 }, filas.length)))

        item.salones = filas
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudieron cargar los salones de la sucursal.'
        this.validarErrorDirecto(mensaje)
      } finally {
        if (solicitud === this.solicitudSalonesControlInterno) {
          this.cargandoSalonesControlInterno = false
        }
      }
    },

    /** Tickets abiertos (asignado, pendiente, rechazado) de Mantenimiento de la sucursal auditada. */
    async cargarTicketsControlInterno() {
      const item = this.editedControlInternoItem
      const idPlantel = item ? item.idplantel : null
      const solicitud = (this.solicitudTicketsControlInterno || 0) + 1
      this.solicitudTicketsControlInterno = solicitud
      this.ticketsControlInterno = []
      if (idPlantel == null || idPlantel === '') return

      this.cargandoTicketsControlInterno = true
      try {
        const response = await this.$http.get(`auditorias/control-interno/tickets/${idPlantel}`)
        if (solicitud !== this.solicitudTicketsControlInterno) return
        this.ticketsControlInterno = this.extraerArray(response)
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudieron cargar los tickets de la sucursal.'
        this.validarErrorDirecto(mensaje)
      } finally {
        if (solicitud === this.solicitudTicketsControlInterno) {
          this.cargandoTicketsControlInterno = false
        }
      }
    },

    estatusTicketControlInterno(estatus) {
      const mapa = {
        2: { texto: 'Asignado', color: 'blue' },
        3: { texto: 'Pendiente', color: 'orange' },
        7: { texto: 'Rechazado', color: 'black' }
      }
      return mapa[Number(estatus)] || { texto: String(estatus || ''), color: 'grey' }
    },

    normalizarListaResultadoControlInterno(listaBase, listaEntrada) {
      const entrada = Array.isArray(listaEntrada) ? listaEntrada : []
      const mapa = new Map()
      entrada.forEach((item) => {
        if (!item || item.id == null) return
        mapa.set(String(item.id), item)
      })

      return clonarCriteriosResultado(listaBase).map((base) => ({
        ...base,
        ...(mapa.get(String(base.id)) || {})
      }))
    },

    normalizarCorteControlInterno(corte) {
      const item = corte || {}
      return {
        encargada: this.normalizarValorSelectNumerico(item.encargada),
        recepcionTurno: this.normalizarValorSelectNumerico(item.recepcionTurno || item.recepcion_turno),
        criterios: this.normalizarListaResultadoControlInterno(CORTE_CONTROL_INTERNO_BASE, item.criterios),
        observaciones: item.observaciones || ''
      }
    },

    normalizarVestimentaControlInterno(vestimenta) {
      const item = vestimenta || {}
      const entrada = Array.isArray(item.filas) ? item.filas : []
      const mapa = new Map()
      const corporativo = []
      entrada.forEach((fila) => {
        if (!fila || !fila.personal) return
        if (String(fila.personal).indexOf(PREFIJO_PERSONAL_CORPORATIVO_CONTROL_INTERNO) === 0) {
          corporativo.push(personaCorporativoDesdeFilaVestimenta(fila))
          return
        }
        mapa.set(String(fila.personal), fila)
      })

      return {
        filas: VESTIMENTA_CONTROL_INTERNO_BASE.map((base) => {
          const guardada = mapa.get(String(base.personal))
          // En BD solo existe la fila del personal opcional cuando sí aplica
          let aplica = base.aplica
          if (guardada) aplica = guardada.aplica != null ? guardada.aplica !== false : true
          return { ...base, ...(guardada || {}), aplica }
        }),
        teachers: (Array.isArray(item.teachers) ? item.teachers : []).map((teacher) =>
          crearTeacherVestimentaControlInterno(teacher)
        ),
        corporativo,
        observaciones: item.observaciones || '',
        observacionesPuntualidad:
          item.observacionesPuntualidad || item.observaciones_puntualidad || ''
      }
    },

    normalizarRiAtencionAlumnoControlInterno(ri) {
      const item = ri || {}
      return {
        encargada: this.normalizarValorSelectNumerico(item.encargada),
        recepcion: this.normalizarValorSelectNumerico(item.recepcion),
        encargadaCriterios: this.normalizarListaResultadoControlInterno(
          RI_ENCARGADA_CONTROL_INTERNO_BASE,
          item.encargadaCriterios || item.encargada_criterios
        ),
        encargadaObservaciones: item.encargadaObservaciones || item.encargada_observaciones || '',
        recepcionCriterios: this.normalizarListaResultadoControlInterno(
          RI_RECEPCION_CONTROL_INTERNO_BASE,
          item.recepcionCriterios || item.recepcion_criterios
        ),
        recepcionObservaciones: item.recepcionObservaciones || item.recepcion_observaciones || ''
      }
    },

    normalizarMetodologia5sControlInterno(metodologia) {
      const item = metodologia || {}
      return {
        criterios: this.normalizarListaResultadoControlInterno(METODOLOGIA_5S_CONTROL_INTERNO_BASE, item.criterios)
      }
    },

    normalizarRetroalimentacionControlInterno(retro, metodologiaFallback) {
      const item = retro || {}
      const fallback = metodologiaFallback || {}
      const personasRaw = Array.isArray(item.personas) ? item.personas : []
      const personas = personasRaw.length
        ? personasRaw.map((persona) => ({
            ...crearDefaultPersonaRetroControlInterno(),
            ...(persona || {})
          }))
        : [crearDefaultPersonaRetroControlInterno(), crearDefaultPersonaRetroControlInterno()]

      return {
        personas,
        climaGeneral: item.climaGeneral || item.clima_general || fallback.climaGeneral || fallback.clima_general || null,
        comunicacion: item.comunicacion || fallback.comunicacion || null,
        organizacionTurnos:
          item.organizacionTurnos ||
          item.organizacion_turnos ||
          fallback.organizacionTurnos ||
          fallback.organizacion_turnos ||
          null,
        liderazgo: item.liderazgo || fallback.liderazgo || null,
        operacion: item.operacion || fallback.operacion || null
      }
    },

    normalizarIdNumericoControlInterno(valor) {
      if (valor == null || valor === '') return null
      const n = Number(valor)
      return Number.isNaN(n) ? valor : n
    },

    formatearHoraInput(valor) {
      if (valor == null || valor === '') return null
      if (valor instanceof Date && !Number.isNaN(valor.getTime())) {
        const h = String(valor.getHours()).padStart(2, '0')
        const m = String(valor.getMinutes()).padStart(2, '0')
        return h + ':' + m
      }
      const texto = String(valor).trim()
      const iso = texto.match(/T(\d{2}):(\d{2})/)
      if (iso) return iso[1] + ':' + iso[2]
      const soloHora = texto.match(/^(\d{1,2}):(\d{2})(?::\d{2})?/)
      if (soloHora) {
        return String(soloHora[1]).padStart(2, '0') + ':' + soloHora[2]
      }
      return null
    },

    colorEstatusControlInterno(estatus) {
      if (estatus === 'Programada') return 'deep-purple'
      if (estatus === 'En curso') return 'orange darken-1'
      return 'green darken-1'
    },

    seleccionarPersonaRetroControlInterno(persona, idUsuario) {
      if (!persona) return
      if (idUsuario == null || idUsuario === '') {
        this.$set(persona, 'idUsuario', null)
        persona.nombre = ''
        persona.puesto = ''
        return
      }
      const usuario = (this.usuariosSelects || []).find((u) => u && String(u.idusuario) === String(idUsuario))
      const catalogo = (this.usuariosCatalogo || []).find((u) => u && String(u.idusuario) === String(idUsuario))
      this.$set(persona, 'idUsuario', idUsuario)
      persona.nombre = this.etiquetaUsuarioSelect(usuario || catalogo) || ''
      persona.puesto = (catalogo && catalogo.puesto) || (usuario && usuario.puesto) || ''
    },

    agregarPersonaRetroControlInterno() {
      if (!this.editedControlInternoItem.retroalimentacion) {
        this.$set(this.editedControlInternoItem, 'retroalimentacion', crearDefaultRetroalimentacionControlInterno())
      }
      this.editedControlInternoItem.retroalimentacion.personas.push(crearDefaultPersonaRetroControlInterno())
    },

    openDialogEditarProgramacionControlInterno(sucursal) {
      const auditoria = (sucursal && sucursal.auditoria) || null
      this.programarControlInternoItem = {
        id: auditoria ? auditoria.id : null,
        esEdicion: true,
        id_plantel: sucursal ? sucursal.id_plantel : null,
        id_auditor: auditoria
          ? this.normalizarIdNumericoControlInterno(
              auditoria.id_auditor != null ? auditoria.id_auditor : auditoria.idAuditor
            )
          : null,
        fecha_programada: auditoria ? auditoria.fechaProgramada || auditoria.fechaAuditoria || null : null,
        hora_inicio: auditoria ? this.formatearHoraInput(auditoria.hora_inicio || auditoria.horaInicio) : null,
        hora_termino: auditoria ? this.formatearHoraInput(auditoria.hora_termino || auditoria.horaTermino) : null,
        id_responsable_plantel: null
      }
      this.dialogProgramarControlInterno = true
    },

    openDialogProgramarControlInterno() {
      this.programarControlInternoItem = {
        id: null,
        esEdicion: false,
        id_plantel: null,
        id_auditor: null,
        fecha_programada: null,
        hora_inicio: null,
        hora_termino: null,
        id_responsable_plantel: null
      }
      this.dialogProgramarControlInterno = true
    },

    closeDialogProgramarControlInterno() {
      this.dialogProgramarControlInterno = false
    },

    async saveProgramarControlInterno() {
      if (this.guardandoProgramarControlInterno || this.cargar) return

      const item = this.programarControlInternoItem || {}
      if (item.id_plantel == null || item.id_plantel === '') {
        this.validarErrorDirecto('Selecciona el plantel.')
        return
      }
      if (item.id_auditor == null || item.id_auditor === '') {
        this.validarErrorDirecto('Selecciona quién va a auditar.')
        return
      }
      if (!item.fecha_programada) {
        this.validarErrorDirecto('Selecciona la fecha de auditoría.')
        return
      }

      this.guardandoProgramarControlInterno = true
      this.cargar = true
      try {
        const idSesion = this.obtenerIdSesion()
        if (item.id) {
          await this.$http.put(`auditorias/control-interno/${item.id}/programacion`, {
            id_auditor: this.resolverIdUsuarioFkParaPayload(item.id_auditor, false),
            fecha_programada: item.fecha_programada,
            hora_inicio: this.formatearHoraInput(item.hora_inicio) || null,
            hora_termino: this.formatearHoraInput(item.hora_termino) || null,
            id_usuario_actualizacion: idSesion
          })
          this.validarSuccess('Auditoría actualizada correctamente.')
          this.dialogProgramarControlInterno = false
          await this.obtenerControlInternoAuditorias()
          return
        }
        const payload = {
          estatus: 'Programada',
          objetivo: 'Auditoría programada',
          id_plantel: item.id_plantel,
          id_ciclo: this.filtros.id_ciclo || null,
          id_auditor: this.resolverIdUsuarioFkParaPayload(item.id_auditor, false),
          fecha_programada: item.fecha_programada,
          fecha_auditoria: item.fecha_programada,
          hora_inicio: this.formatearHoraInput(item.hora_inicio) || null,
          hora_termino: this.formatearHoraInput(item.hora_termino) || null,
          id_responsable_plantel: item.id_responsable_plantel
            ? this.resolverIdUsuarioFkParaPayload(item.id_responsable_plantel, true)
            : this.resolverIdUsuarioFkParaPayload(item.id_auditor, false),
          id_dirigido_a: this.resolverIdUsuarioFkParaPayload(item.id_auditor, false),
          id_departamento: this.departamentoOperaciones
            ? this.departamentoOperaciones.id
            : (this.departamentos[0] && this.departamentos[0].id) || 1
        }
        if (idSesion != null) {
          payload.id_usuario_creacion = idSesion
        }

        await this.$http.post('auditorias/control-interno', payload)
        this.validarSuccess('Auditoría programada correctamente.')
        this.dialogProgramarControlInterno = false
        await this.obtenerControlInternoAuditorias()
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudo programar la auditoría.'
        this.validarErrorDirecto(mensaje)
      } finally {
        this.guardandoProgramarControlInterno = false
        this.cargar = false
      }
    },

    normalizarFilasObservacionesControlInterno(filas, cantidad) {
      const entrada = Array.isArray(filas) ? filas : []
      const base = crearFilasObservacionesControlInterno(cantidad)
      entrada.slice(0, cantidad).forEach((fila, index) => {
        base[index] = {
          observacion: fila && fila.observacion ? fila.observacion : '',
          departamento: fila && fila.departamento ? fila.departamento : ''
        }
      })
      return base
    },

    normalizarCierreAuditoriaControlInterno(cierre) {
      const item = cierre || {}
      return {
        principalesHallazgos: this.normalizarFilasObservacionesControlInterno(
          item.principalesHallazgos || item.principales_hallazgos,
          2
        ),
        hallazgosDepartamento: this.agruparHallazgosDepartamentoControlInterno(
          item.hallazgosDepartamento || item.hallazgos_departamento
        ),
        areasOportunidad: this.normalizarFilasObservacionesControlInterno(
          item.areasOportunidad || item.areas_oportunidad,
          2
        ),
        fortalezasDetectadas: this.normalizarFilasObservacionesControlInterno(
          item.fortalezasDetectadas || item.fortalezas_detectadas,
          2
        ),
        nivelGeneral: item.nivelGeneral || item.nivel_general || null,
        auditorFirma: this.normalizarFirmaImagenControlInterno(item.auditorFirma || item.auditor_firma),
        responsablePlantelFirma: this.normalizarFirmaImagenControlInterno(
          item.responsablePlantelFirma || item.responsable_plantel_firma
        ),
        fechaFirma: this.formatearFechaInput(item.fechaFirma || item.fecha_firma)
      }
    },

    /** Agrupa los comentarios guardados (lista plana) por departamento. */
    agruparHallazgosDepartamentoControlInterno(lista) {
      const grupos = []
      const porNombre = {}
      ;(Array.isArray(lista) ? lista : []).forEach((item) => {
        const nombre = item && item.departamento ? String(item.departamento) : ''
        if (!nombre) return
        if (!porNombre[nombre]) {
          porNombre[nombre] = { departamento: nombre, comentarios: [] }
          grupos.push(porNombre[nombre])
        }
        porNombre[nombre].comentarios.push(crearComentarioHallazgoDepartamentoControlInterno(item))
      })
      return grupos
    },

    /** Asegura que estén todos los departamentos del catálogo (en su orden) sin perder lo capturado. */
    sincronizarHallazgosDepartamentoControlInterno(item) {
      if (!item || !item.cierreAuditoria) return
      const actuales = Array.isArray(item.cierreAuditoria.hallazgosDepartamento)
        ? item.cierreAuditoria.hallazgosDepartamento
        : []
      const porNombre = {}
      actuales.forEach((grupo) => {
        if (grupo && grupo.departamento) porNombre[grupo.departamento] = grupo
      })
      const nombres = (this.departamentos || [])
        .map((depto) => (depto && depto.nombre ? depto.nombre : ''))
        .filter((nombre) => nombre && this.normalizarTexto(nombre) !== 'control interno')
      const lista = nombres.map((nombre) => porNombre[nombre] || { departamento: nombre, comentarios: [] })
      actuales.forEach((grupo) => {
        const tieneComentarios = grupo && Array.isArray(grupo.comentarios) && grupo.comentarios.length
        if (tieneComentarios && grupo.departamento && nombres.indexOf(grupo.departamento) === -1) lista.push(grupo)
      })
      this.$set(item.cierreAuditoria, 'hallazgosDepartamento', lista)
    },

    agregarComentarioHallazgoDepartamentoControlInterno(grupo) {
      if (!grupo) return
      if (!Array.isArray(grupo.comentarios)) this.$set(grupo, 'comentarios', [])
      grupo.comentarios.push(crearComentarioHallazgoDepartamentoControlInterno())
    },

    quitarComentarioHallazgoDepartamentoControlInterno(grupo, index) {
      if (!grupo || !Array.isArray(grupo.comentarios)) return
      grupo.comentarios.splice(index, 1)
    },

    /** Solo comentarios con texto o evidencia; se envía como lista plana. */
    hallazgosDepartamentoPayloadControlInterno(grupos) {
      const filas = []
      ;(Array.isArray(grupos) ? grupos : []).forEach((grupo) => {
        if (!grupo) return
        ;(grupo.comentarios || []).forEach((comentario) => {
          const observacion = String((comentario && comentario.observacion) || '').trim()
          const evidencias = (comentario && Array.isArray(comentario.evidencias) ? comentario.evidencias : []).map(
            (evidencia) => ({ ...evidencia })
          )
          if (!observacion && !evidencias.length) return
          filas.push({ departamento: grupo.departamento, observacion, evidencias })
        })
      })
      return filas
    },

    esFirmaImagenControlInterno(valor) {
      if (!valor || typeof valor !== 'string') return false
      return valor.indexOf('data:image/') === 0
    },

    normalizarFirmaImagenControlInterno(valor) {
      if (this.esFirmaImagenControlInterno(valor)) return valor
      return ''
    },

    clearFirmaControlInterno(campo) {
      if (!this.editedControlInternoItem || !this.editedControlInternoItem.cierreAuditoria) return
      this.$set(this.editedControlInternoItem.cierreAuditoria, campo, '')
    },

    abrirFirmaControlInterno(campo) {
      this.campoFirmaControlInterno = campo
      this.dialogFirmaControlInterno = true
      setTimeout(() => {
        const canvas = document.getElementById('signature-pad-control-interno')
        if (!canvas) return
        if (this.signaturePadControlInterno) {
          this.signaturePadControlInterno.clear()
        }
        this.signaturePadControlInterno = new SignaturePad(canvas)
      }, 500)
    },

    limpiarFirmaControlInterno() {
      if (this.signaturePadControlInterno) {
        this.signaturePadControlInterno.clear()
      }
    },

    cerrarDialogFirmaControlInterno() {
      this.dialogFirmaControlInterno = false
      this.campoFirmaControlInterno = null
      if (this.signaturePadControlInterno) {
        this.signaturePadControlInterno.clear()
      }
    },

    guardarFirmaControlInterno() {
      if (!this.signaturePadControlInterno) {
        this.validarErrorDirecto('No se pudo iniciar el pad de firma.')
        return
      }
      if (this.signaturePadControlInterno.isEmpty()) {
        this.validarErrorDirecto('Necesitas ingresar una firma')
        return
      }
      if (!this.campoFirmaControlInterno || !this.editedControlInternoItem || !this.editedControlInternoItem.cierreAuditoria) {
        this.validarErrorDirecto('No se pudo guardar la firma.')
        return
      }
      const dataUrl = this.signaturePadControlInterno.toDataURL()
      this.$set(this.editedControlInternoItem.cierreAuditoria, this.campoFirmaControlInterno, dataUrl)
      this.cerrarDialogFirmaControlInterno()
    },

    marcarCriterioControlInterno(criterio, resultado) {
      if (!criterio) return
      criterio.resultado = criterio.resultado === resultado ? null : resultado
    },

    toggleBooleanControlInterno(item, campo) {
      if (!item || !campo) return
      item[campo] = !item[campo]
    },

    marcarBooleanoCumpleControlInterno(item, campo, valorCumple) {
      if (!item || !campo) return
      this.$set(item, campo, item[campo] === valorCumple ? null : valorCumple)
    },

    agregarTeacherVestimentaControlInterno() {
      const vestimenta = this.editedControlInternoItem.vestimenta
      if (!Array.isArray(vestimenta.teachers)) this.$set(vestimenta, 'teachers', [])
      vestimenta.teachers.push(crearTeacherVestimentaControlInterno())
    },

    esPersonalOpcionalControlInterno(fila) {
      return !!fila && PERSONAL_OPCIONAL_CONTROL_INTERNO.indexOf(fila.personal) !== -1
    },

    quitarTeacherVestimentaControlInterno(index) {
      const vestimenta = this.editedControlInternoItem.vestimenta
      if (!vestimenta || !Array.isArray(vestimenta.teachers)) return
      vestimenta.teachers.splice(index, 1)
    },

    etiquetaCriterio5sControlInterno(criterio) {
      if (!criterio) return ''
      const id = criterio.id != null ? Number(criterio.id) : null
      if (id != null && ETIQUETAS_5S_CONTROL_INTERNO[id]) {
        return ETIQUETAS_5S_CONTROL_INTERNO[id]
      }
      return criterio.pilar || criterio.criterioRevision || ''
    },

    seleccionarValorControlInterno(item, campo, valor) {
      if (!item || !campo) return
      const nuevo = item[campo] === valor ? null : valor
      this.$set(item, campo, nuevo)
    },

    aplicarOpcionControlInterno(item, campo, valor, checked) {
      if (!item || !campo) return
      if (checked) {
        this.$set(item, campo, valor)
        return
      }
      if (item[campo] === valor) {
        this.$set(item, campo, null)
      }
    },

    validarFormularioControlInterno() {
      const estatus = this.editedControlInternoItem.estatus || 'En curso'
      if (estatus === 'Programada') {
        if (this.editedControlInternoItem.idplantel == null || this.editedControlInternoItem.idplantel === '') {
          this.validarErrorDirecto('Selecciona el plantel.')
          return false
        }
        if (this.editedControlInternoItem.idAuditor == null || this.editedControlInternoItem.idAuditor === '') {
          this.validarErrorDirecto('Selecciona el auditor.')
          return false
        }
        if (!this.editedControlInternoItem.fechaProgramada && !this.editedControlInternoItem.fechaAuditoria) {
          this.validarErrorDirecto('Selecciona la fecha programada.')
          return false
        }
        return true
      }

      if (this.editedControlInternoItem.departamento == null || this.editedControlInternoItem.departamento === '') {
        this.validarErrorDirecto(`No se encontró el departamento ${DEPARTAMENTO_CONTROL_INTERNO} en el catálogo.`)
        return false
      }

      if (this.editedControlInternoItem.idAuditor == null || this.editedControlInternoItem.idAuditor === '') {
        this.validarErrorDirecto('No se pudo identificar al usuario logueado como auditor.')
        return false
      }

      if (this.cargandoSalonesControlInterno) {
        this.validarErrorDirecto('Espera a que carguen los salones de la sucursal.')
        return false
      }

      if (Object.keys(this.subiendoEvidenciaControlInterno).length) {
        this.validarErrorDirecto('Espera a que terminen de subir las evidencias.')
        return false
      }

      this.erroresControlInterno = {}
      const faltantes = this.camposFaltantesControlInterno()
      if (faltantes.length) {
        faltantes.forEach((faltante) => this.$set(this.erroresControlInterno, faltante.clave, 'Campo requerido'))
        this.validarErrorDirecto('Falta llenar: ' + faltantes.map((faltante) => faltante.etiqueta).join(', '))
        this.irACampoControlInterno(faltantes[0].clave)
        return false
      }

      return true
    },

    /** Campos obligatorios vacíos; `clave` corresponde al id `ci-campo-<clave>` del template. */
    camposFaltantesControlInterno() {
      const item = this.editedControlInternoItem || {}
      const vacio = (valor) => valor == null || valor === ''
      const faltantes = []

      if (vacio(item.idplantel)) {
        faltantes.push({ clave: 'plantel', etiqueta: 'Plantel (sección I)' })
      }
      if (vacio(item.responsablePlantel)) {
        faltantes.push({ clave: 'responsable', etiqueta: 'Responsable del plantel (sección I)' })
      }

      if (esPlantelCorporativoControlInterno(item.idplantel)) {
        ;(item.oficinas || []).forEach((oficina, index) => {
          if (vacio(oficina.departamento)) {
            faltantes.push({ clave: 'oficina-' + index, etiqueta: `Departamento de la oficina ${index + 1} (sección 2)` })
          }
        })
      }

      if (item.estatus === 'Cerrada' && !esPlantelCorporativoControlInterno(item.idplantel)) {
        ;(item.salones || []).forEach((salon, index) => {
          if (!salon || (Array.isArray(salon.evidencias) && salon.evidencias.length)) return
          faltantes.push({
            clave: 'salon-' + index,
            etiqueta: `Evidencia del salón ${salon.nombre || salon.salon} (sección 2)`
          })
        })
      }

      const teachers = esPlantelCorporativoControlInterno(item.idplantel) ? [] : this.teachersVestimentaControlInterno
      teachers.forEach((teacher, index) => {
        if (vacio(teacher.idUsuarioEvaluado)) {
          faltantes.push({
            clave: 'teacher-' + index,
            etiqueta: `Teacher ${index + 1} (sección 4. Código de vestimenta)`
          })
        }
      })

      const retro = item.retroalimentacion || {}
      ;(retro.personas || []).forEach((persona, index) => {
        if (!persona || persona.idUsuario != null || String(persona.nombre || '').trim()) return
        const tieneRespuestas = PREGUNTAS_RETRO_CONTROL_INTERNO.some((_, indexPregunta) =>
          String(persona['p' + (indexPregunta + 1)] || '').trim()
        )
        if (tieneRespuestas) {
          faltantes.push({
            clave: 'retro-' + index,
            etiqueta: `Persona ${index + 1} (sección 8. Retroalimentación)`
          })
        }
      })

      return faltantes
    },

    irACampoControlInterno(clave) {
      this.$nextTick(() => {
        const elemento = document.getElementById('ci-campo-' + clave)
        if (elemento) elemento.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    },

    onCambioEscuelaControlInterno() {
      if (this.filtros.plantel == null || this.filtros.plantel === '') return
      const sigueDisponible = (this.plantelesFiltroControlInterno || []).some(
        (plantel) => String(plantel.idplantel) === String(this.filtros.plantel)
      )
      if (!sigueDisponible) this.filtros.plantel = null
    },

    descripcionSeccionControlInterno(numero) {
      if (this.esCorporativoControlInterno && DESCRIPCIONES_SECCIONES_CORPORATIVO_CONTROL_INTERNO[numero]) {
        return DESCRIPCIONES_SECCIONES_CORPORATIVO_CONTROL_INTERNO[numero]
      }
      return DESCRIPCIONES_SECCIONES_CONTROL_INTERNO[numero] || { que: '', como: '' }
    },

    numeroSeccionControlInterno(numero) {
      if (!this.esCorporativoControlInterno) return numero
      return NUMERO_SECCION_CORPORATIVO_CONTROL_INTERNO[numero] || numero
    },

    abrirSelectorEvidenciaSalonControlInterno(salon, index, modo) {
      this.limpiarErrorControlInterno('salon-' + index)
      this.abrirSelectorEvidenciaControlInterno(salon, modo)
    },

    agregarOficinaControlInterno() {
      const item = this.editedControlInternoItem
      if (!Array.isArray(item.oficinas)) this.$set(item, 'oficinas', [])
      item.oficinas.push(crearOficinaControlInterno())
    },

    quitarOficinaControlInterno(index) {
      const oficinas = this.editedControlInternoItem.oficinas || []
      const oficina = oficinas[index]
      if (!oficina) return
      const tieneDatos =
        oficina.departamento ||
        (oficina.evidencias && oficina.evidencias.length) ||
        oficina.criterios.concat(oficina.criterios5s).some((criterio) => criterio.resultado)
      if (tieneDatos && !window.confirm('¿Quitar la oficina ' + (oficina.departamento || index + 1) + ' y lo que se capturó?')) {
        return
      }
      oficinas.splice(index, 1)
      this.erroresControlInterno = {}
    },

    nombreOficinaControlInterno(oficina, index) {
      return oficina && oficina.departamento ? oficina.departamento : 'Oficina ' + (index + 1)
    },

    resumenVestimentaPersonaControlInterno(persona) {
      const valores = CRITERIOS_VESTIMENTA_CONTROL_INTERNO.map((criterio) => persona[criterio.campo])
      if (valores.some((valor) => valor === 'Ausente')) return { texto: 'Ausente', color: 'grey' }
      if (valores.some((valor) => valor === false)) return { texto: 'No cumple', color: 'red' }
      if (valores.every((valor) => valor === true)) return { texto: 'Cumple', color: 'green' }
      return { texto: 'Sin evaluar', color: 'blue-grey lighten-3' }
    },

    respuestasRetroPersonaControlInterno(persona) {
      return PREGUNTAS_RETRO_CONTROL_INTERNO.filter(
        (_, indexPregunta) => String((persona && persona['p' + (indexPregunta + 1)]) || '').trim()
      ).length
    },

    /**
     * Cuántos antecedentes tiene cada persona (actas administrativas + incidencias de colaboradores).
     * Sin `sobrescribir` solo llena a quien aún no tiene cantidad capturada.
     */
    cambiarPersonaVestimentaControlInterno(persona) {
      if (!persona) return
      this.$set(persona, 'antecedentesCantidad', null)
      this.cargarAntecedentesControlInterno([persona], 'idUsuarioEvaluado', true)
    },

    async cargarAntecedentesControlInterno(personas, campoId, sobrescribir) {
      const lista = (personas || []).filter((persona) => {
        if (!persona || persona[campoId] == null || persona[campoId] === '') return false
        if (sobrescribir) return true
        return persona.antecedentesCantidad == null || persona.antecedentesCantidad === ''
      })
      const ids = Array.from(new Set(lista.map((persona) => Number(persona[campoId])).filter((id) => id > 0)))
      if (!ids.length) return

      try {
        const response = await this.$http.get('auditorias/control-interno/antecedentes', {
          params: { ids: ids.join(',') }
        })
        const totalPorId = {}
        this.extraerArray(response).forEach((fila) => {
          totalPorId[String(fila.idusuario)] = Number(fila.total) || 0
        })
        lista.forEach((persona) => {
          const total = totalPorId[String(persona[campoId])]
          if (total != null) this.$set(persona, 'antecedentesCantidad', total)
        })
      } catch (error) {
        // El conteo es solo un valor sugerido; si falla se captura a mano
      }
    },

    /** Trabajadores activos del corporativo en el ERP, conservando lo ya evaluado (por iderp). */
    async cargarPersonalCorporativoControlInterno() {
      const item = this.editedControlInternoItem
      if (!item || !item.vestimenta) return
      if (!esPlantelCorporativoControlInterno(item.idplantel)) {
        this.$set(item.vestimenta, 'corporativo', [])
        this.cargarAntecedentesControlInterno(
          [].concat(item.vestimenta.filas || [], item.vestimenta.teachers || []),
          'idUsuarioEvaluado',
          false
        )
        return
      }

      const solicitud = (this.solicitudPersonalCorporativoControlInterno || 0) + 1
      this.solicitudPersonalCorporativoControlInterno = solicitud
      this.cargandoPersonalCorporativoControlInterno = true
      try {
        const response = await this.$http.get(`auditorias/control-interno/personal/${item.idplantel}`)
        if (solicitud !== this.solicitudPersonalCorporativoControlInterno || item !== this.editedControlInternoItem) return

        const actuales = Array.isArray(item.vestimenta.corporativo) ? item.vestimenta.corporativo : []
        const guardadosPorIderp = {}
        actuales.forEach((persona) => {
          if (persona.iderp != null) guardadosPorIderp[String(persona.iderp)] = persona
        })
        const catalogo = this.extraerArray(response)
        const lista = catalogo.map((trabajador) => {
          const guardado = guardadosPorIderp[String(trabajador.iderp)] || {}
          return crearPersonaCorporativoControlInterno({
            ...trabajador,
            uniformeCorrecto: guardado.uniformeCorrecto,
            presentacionProfesional: guardado.presentacionProfesional,
            antecedentesDisciplinarios: guardado.antecedentesDisciplinarios,
            antecedentesCantidad: guardado.antecedentesCantidad
          })
        })
        const iderpsCatalogo = catalogo.map((trabajador) => String(trabajador.iderp))
        actuales
          .filter((persona) => iderpsCatalogo.indexOf(String(persona.iderp)) === -1)
          .forEach((persona) => lista.push(persona))

        this.$set(item.vestimenta, 'corporativo', lista)
        this.sincronizarRetroCorporativoControlInterno(item)
        this.cargarAntecedentesControlInterno(lista, 'idUsuario', false)
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudo cargar el personal del corporativo.'
        this.validarErrorDirecto(mensaje)
      } finally {
        if (solicitud === this.solicitudPersonalCorporativoControlInterno) {
          this.cargandoPersonalCorporativoControlInterno = false
        }
      }
    },

    /** En corporativos la retroalimentación es de las mismas personas de vestimenta. */
    sincronizarRetroCorporativoControlInterno(item) {
      if (!item || !item.retroalimentacion) return
      const actuales = Array.isArray(item.retroalimentacion.personas) ? item.retroalimentacion.personas : []
      const usadas = []
      const buscar = (persona) =>
        actuales.find((retro) => {
          if (usadas.indexOf(retro) !== -1) return false
          if (persona.idUsuario != null && retro.idUsuario != null) {
            return String(persona.idUsuario) === String(retro.idUsuario)
          }
          return this.normalizarTexto(retro.nombre) === this.normalizarTexto(persona.nombre)
        })
      const personas = (item.vestimenta.corporativo || []).map((persona) => {
        const retro = buscar(persona)
        if (retro) usadas.push(retro)
        return {
          ...crearDefaultPersonaRetroControlInterno(),
          ...(retro || {}),
          idUsuario: persona.idUsuario,
          nombre: persona.nombre,
          puesto: persona.puesto || (retro && retro.puesto) || ''
        }
      })
      actuales
        .filter((retro) => usadas.indexOf(retro) === -1 && this.respuestasRetroPersonaControlInterno(retro))
        .forEach((retro) => personas.push(retro))
      this.$set(item.retroalimentacion, 'personas', personas)
    },

    salonSinEvidenciaConErrorControlInterno(salon, index) {
      if (!this.erroresControlInterno['salon-' + index]) return false
      return !(salon && Array.isArray(salon.evidencias) && salon.evidencias.length)
    },

    limpiarErrorControlInterno(clave) {
      if (this.erroresControlInterno[clave]) this.$delete(this.erroresControlInterno, clave)
    },

    construirPayloadControlInterno() {
      const idSesion = this.obtenerIdSesion()
      const estatus = this.editedControlInternoItem.estatus || 'En curso'
      const retro = this.editedControlInternoItem.retroalimentacion || {}
      const cierre = this.editedControlInternoItem.cierreAuditoria || {}
      const escalasRetro = {
        climaGeneral: retro.climaGeneral || null,
        comunicacion: retro.comunicacion || null,
        organizacionTurnos: retro.organizacionTurnos || null,
        liderazgo: retro.liderazgo || null,
        operacion: retro.operacion || null
      }
      const payload = {
        id: this.editedControlInternoItem.id,
        objetivo: String(this.editedControlInternoItem.objetivo || '').trim(),
        id_departamento: this.editedControlInternoItem.departamento,
        id_dirigido_a:
          this.resolverIdUsuarioFkParaPayload(this.editedControlInternoItem.dirigidoA, false) ||
          this.resolverIdUsuarioFkParaPayload(this.editedControlInternoItem.idAuditor, false),
        id_plantel: this.editedControlInternoItem.idplantel,
        id_ciclo:
          this.editedControlInternoItem.id_ciclo != null
            ? this.editedControlInternoItem.id_ciclo
            : this.filtros.id_ciclo || null,
        id_responsable_plantel: this.resolverIdUsuarioFkParaPayload(
          this.editedControlInternoItem.responsablePlantel,
          true
        ),
        id_auditor: this.resolverIdUsuarioFkParaPayload(this.editedControlInternoItem.idAuditor, false),
        fecha_auditoria: this.editedControlInternoItem.fechaAuditoria,
        fecha_programada: this.editedControlInternoItem.fechaProgramada || null,
        hora_inicio: this.formatearHoraInput(this.editedControlInternoItem.horaInicio) || null,
        hora_termino: this.formatearHoraInput(this.editedControlInternoItem.horaTermino) || null,
        estatus: estatus,
        criterios: (this.editedControlInternoItem.criterios || []).map((item) => ({
          id: item.id,
          seccion: item.seccion,
          criterio: item.criterio,
          resultado: item.resultado || null,
          evidencias: (item.evidencias || []).map((evidencia) => ({ ...evidencia }))
        })),
        salones: (this.editedControlInternoItem.salones || []).map((item) => ({ ...item })),
        observacionesSalones: this.editedControlInternoItem.observacionesSalones || '',
        corte: {
          ...this.editedControlInternoItem.corte,
          criterios: (this.editedControlInternoItem.corte.criterios || []).map((item) => ({ ...item }))
        },
        vestimenta: {
          ...this.editedControlInternoItem.vestimenta,
          filas: (this.editedControlInternoItem.vestimenta.filas || [])
            .filter((item) => item && item.aplica !== false)
            .map((item) => ({ ...item })),
          teachers: (this.editedControlInternoItem.vestimenta.teachers || []).map((item) => ({ ...item }))
        },
        riAtencionAlumno: {
          ...this.editedControlInternoItem.riAtencionAlumno,
          encargadaCriterios: (this.editedControlInternoItem.riAtencionAlumno.encargadaCriterios || []).map((item) => ({
            ...item
          })),
          recepcionCriterios: (this.editedControlInternoItem.riAtencionAlumno.recepcionCriterios || []).map((item) => ({
            ...item
          }))
        },
        metodologia5s: {
          ...this.editedControlInternoItem.metodologia5s,
          ...escalasRetro,
          criterios: (this.editedControlInternoItem.metodologia5s.criterios || []).map((item) => ({ ...item }))
        },
        retroalimentacion: {
          ...retro,
          ...escalasRetro,
          personas: (retro.personas || []).map((item) => ({ ...item }))
        },
        cierreAuditoria: {
          ...cierre,
          nivelGeneral: cierre.nivelGeneral || null,
          principalesHallazgos: (cierre.principalesHallazgos || []).map((item) => ({ ...item })),
          hallazgosDepartamento: this.hallazgosDepartamentoPayloadControlInterno(cierre.hallazgosDepartamento),
          areasOportunidad: (cierre.areasOportunidad || []).map((item) => ({ ...item })),
          fortalezasDetectadas: (cierre.fortalezasDetectadas || []).map((item) => ({ ...item }))
        },
        oficinas: []
      }

      // Corporativo: sin salones, Corte, RI ni 5S general (si se mandan cuentan como No cumple en el puntaje)
      if (esPlantelCorporativoControlInterno(payload.id_plantel)) {
        payload.salones = []
        payload.corte.criterios = []
        payload.riAtencionAlumno.encargadaCriterios = []
        payload.riAtencionAlumno.recepcionCriterios = []
        payload.metodologia5s.criterios = []
        payload.vestimenta.teachers = []
        payload.vestimenta.filas = (this.editedControlInternoItem.vestimenta.corporativo || []).map((persona) => ({
          personal: (
            PREFIJO_PERSONAL_CORPORATIVO_CONTROL_INTERNO +
            (persona.iderp != null ? persona.iderp : '') +
            ':' +
            persona.nombre
          ).slice(0, 80),
          idUsuarioEvaluado: persona.idUsuario,
          uniformeCorrecto: persona.uniformeCorrecto,
          presentacionProfesional: persona.presentacionProfesional,
          antecedentesDisciplinarios: persona.antecedentesDisciplinarios,
          antecedentesCantidad: persona.antecedentesCantidad
        }))
        delete payload.vestimenta.corporativo
        payload.retroalimentacion.personas = payload.retroalimentacion.personas.filter((persona) =>
          this.respuestasRetroPersonaControlInterno(persona)
        )
        payload.oficinas = (this.editedControlInternoItem.oficinas || []).map((oficina) => ({
          departamento: oficina.departamento,
          criterios: oficina.criterios.map((criterio) => ({ ...criterio })),
          criterios5s: oficina.criterios5s.map((criterio) => ({
            id: criterio.id,
            criterio: criterio.pilar,
            resultado: criterio.resultado || null,
            evidenciaAccion: criterio.evidenciaAccion || ''
          })),
          evidencias: (oficina.evidencias || []).map((evidencia) => ({ ...evidencia }))
        }))
      } else {
        delete payload.vestimenta.corporativo
      }

      if (idSesion != null) {
        if (payload.id) {
          payload.id_usuario_actualizacion = idSesion
        } else {
          payload.id_usuario_creacion = idSesion
          payload.id_usuario_actualizacion = idSesion
        }
      }

      return payload
    },

    siguienteIdControlInterno() {
      const maximo = (this.controlInternoAuditorias || []).reduce((max, item) => {
        const id = Number(item && item.id)
        return !Number.isNaN(id) && id > max ? id : max
      }, 0)
      return maximo + 1
    },

    async editControlInternoItem(item) {
      this.cargar = true
      try {
        this.editedControlInternoIndex = this.controlInternoAuditorias.findIndex(
          (row) => String(row.id) === String(item.id)
        )
        const responseDetalle = await this.$http.get(`auditorias/control-interno/${item.id}`)
        const detalle = this.extraerObjeto(responseDetalle)
        this.editedControlInternoItem = this.mapControlInternoAFormulario(detalle)
        if (this.editedControlInternoItem.estatus === 'Programada') {
          this.editedControlInternoItem.estatus = 'En curso'
        }
        this.aplicarCamposFijosControlInterno(this.editedControlInternoItem)
        this.cargarSalonesControlInterno(true)
        this.cargarTicketsControlInterno()
        this.cargarPersonalCorporativoControlInterno()
        this.asegurarUsuarioEnCatalogoLocal(
          detalle && detalle.id_responsable_plantel,
          detalle && detalle.nombre_responsable_plantel
        )
        this.asegurarUsuarioEnCatalogoLocal(
          detalle && (detalle.id_auditor != null ? detalle.id_auditor : detalle.idAuditor),
          detalle && detalle.nombre_auditor
        )
        this.cerrarDialogFirmaControlInterno()
        this.dialogControlInterno = true
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudo cargar el detalle de control interno.'
        this.validarErrorDirecto(mensaje)
      } finally {
        this.cargar = false
      }
    },

    async deleteControlInternoItem(item, nombreSucursal) {
      if (!item || !item.id) return
      const detalle = [item.estatus, this.formatearFechaInput(item.fechaAuditoria || item.fechaProgramada)]
        .filter(Boolean)
        .join(', ')
      const sucursal = nombreSucursal ? ` de ${nombreSucursal}` : ''
      const mensaje = `¿Eliminar la auditoría${sucursal}${detalle ? ` (${detalle})` : ''}? Se quitará de la lista.`
      if (!confirm(mensaje)) return

      this.cargar = true
      try {
        await this.$http.delete(`auditorias/control-interno/${item.id}`)
        this.validarSuccess('Auditoría de control interno eliminada correctamente.')
        await this.obtenerControlInternoAuditorias()
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudo eliminar la auditoría de control interno.'
        this.validarErrorDirecto(mensaje)
      } finally {
        this.cargar = false
      }
    },

    closeControlInterno() {
      this.dialogControlInterno = false
      this.erroresControlInterno = {}
      this.solicitudTicketsControlInterno += 1
      this.ticketsControlInterno = []
      this.cerrarDialogFirmaControlInterno()
      this.$nextTick(() => {
        this.editedControlInternoItem = crearDefaultControlInternoItem()
        this.editedControlInternoIndex = -1
      })
    },

    async saveControlInterno() {
      if (this.guardandoControlInterno || this.cargar) return
      this.aplicarCamposFijosControlInterno(this.editedControlInternoItem)
      if (!this.validarFormularioControlInterno()) return

      this.guardandoControlInterno = true
      this.cargar = true
      try {
        const payload = this.construirPayloadControlInterno()
        if (payload.id) {
          await this.$http.put(`auditorias/control-interno/${payload.id}`, payload)
          this.validarSuccess('Auditoría de control interno actualizada correctamente.')
        } else {
          const response = await this.$http.post('auditorias/control-interno', payload)
          const creado = this.extraerObjeto(response)
          if (creado && creado.id != null) {
            this.$set(this.editedControlInternoItem, 'id', creado.id)
          }
          this.validarSuccess('Auditoría de control interno guardada correctamente.')
        }

        this.closeControlInterno()
        await this.obtenerControlInternoAuditorias()
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudo guardar la auditoría de control interno.'
        this.validarErrorDirecto(mensaje)
      } finally {
        this.guardandoControlInterno = false
        this.cargar = false
      }
    },

    async openDialog() {
      this.cargar = true
      try {
        this.editedIndex = -1
        this.editedItem = crearDefaultItem()
        this.fotosEvidenciaPhva = {}
        this.evidenciasGeneralesPhva = {}
        this.fotosEvidenciaGeneralesPhva = {}
        await this.ensureCriteriosPlantilla()
        this.aplicarCriteriosDesdeApi([])

        if (!this.criterios.length) {
          this.validarErrorDirecto('No se encontraron criterios para inicializar la auditoría.')
          return
        }

        this.dialog = true
      } finally {
        this.cargar = false
      }
    },

    async editItem(item) {
      this.cargar = true

      try {
        this.editedIndex = this.auditorias.findIndex((row) => String(row.id) === String(item.id))

        const [_, responseDetalle] = await Promise.all([
          this.ensureCriteriosPlantilla(),
          this.$http.get(`auditorias/${item.id}`)
        ])

        const detalle = this.extraerObjeto(responseDetalle)
        this.editedItem = this.mapDetalleAFormulario(detalle)

        // Permite editar registros aunque el usuario no venga en `catalogs/usuarios`,
        // siempre que el id exista en BD (la FK ya lo garantiza en datos consistentes).
        this.asegurarUsuarioEnCatalogoLocal(detalle && detalle.id_auditor, detalle && detalle.nombre_auditor)
        this.asegurarUsuarioEnCatalogoLocal(
          detalle && detalle.id_jefe_departamento,
          detalle && (detalle.nombre_jefe || detalle.nombre_jefe_departamento)
        )
        this.asegurarUsuarioEnCatalogoLocal(detalle && detalle.id_responsable, detalle && detalle.nombre_responsable)
        this.asegurarUsuarioEnCatalogoLocal(detalle && detalle.id_usuario_creacion, detalle && detalle.nombre_usuario_creacion)
        this.asegurarUsuarioEnCatalogoLocal(
          detalle && detalle.id_usuario_actualizacion,
          detalle && detalle.nombre_usuario_actualizacion
        )

        this.aplicarCriteriosDesdeApi(detalle && detalle.criterios)

        if (!this.criterios.length) {
          this.validarErrorDirecto('La auditoría no cuenta con criterios configurados.')
          return
        }

        this.dialog = true
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudo cargar el detalle de la auditoría.'
        this.validarErrorDirecto(mensaje)
      } finally {
        this.cargar = false
      }
    },

    async deleteItem(item) {
      if (!confirm('¿Estás seguro de que deseas eliminar esta auditoría?')) return

      this.cargar = true

      try {
        await this.$http.delete(`auditorias/${item.id}`)
        this.validarSuccess('Auditoría eliminada correctamente.')
        await Promise.all([this.obtenerAuditorias(), this.obtenerReporteDepartamentos()])
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudo eliminar la auditoría.'
        this.validarErrorDirecto(mensaje)
      } finally {
        this.cargar = false
      }
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = crearDefaultItem()
        this.editedIndex = -1
        this.fotosEvidenciaPhva = {}
        this.evidenciasGeneralesPhva = {}
        this.fotosEvidenciaGeneralesPhva = {}
        this.criterios = this.criteriosVacios()
      })
    },

    async save() {
      if (!this.validarFormularioAuditoria()) return

      this.cargar = true

      try {
        const payload = this.construirPayloadAuditoria()

        if (this.editedItem.id) {
          await this.$http.put(`auditorias/${this.editedItem.id}`, payload)
          this.validarSuccess('Auditoría actualizada correctamente.')
        } else {
          await this.$http.post('auditorias', payload)
          this.validarSuccess('Auditoría guardada correctamente.')
        }

        this.close()
        await Promise.all([this.obtenerAuditorias(), this.obtenerReporteDepartamentos()])
      } catch (error) {
        const raw =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudo guardar la auditoría.'
        const mensaje = this.interpretarErrorSqlAuditorias(raw)
        this.validarErrorDirecto(mensaje)
      } finally {
        this.cargar = false
      }
    },

    interpretarErrorSqlAuditorias(mensaje) {
      const texto = String(mensaje || '')
      if (!texto) return 'No se pudo guardar la auditoría.'

      if (texto.includes('auditorias_ibfk_2') && texto.includes('id_auditor')) {
        return 'No puedes elegir a ese usuario como auditor: no está disponible en el catálogo de ERP (usuarios).'
      }

      if (texto.includes('FOREIGN KEY') && texto.includes('id_jefe_departamento')) {
        return 'No puedes elegir a ese usuario como jefe de departamento: no está disponible en el catálogo de ERP (usuarios).'
      }

      if (texto.includes('FOREIGN KEY') && texto.includes('id_responsable')) {
        return 'No puedes elegir a ese usuario como responsable: no está disponible en el catálogo de ERP (usuarios).'
      }

      return texto
    },

    canDelete() {
      return !!this.getdatosUsuarioERPERP
    }
  },

  watch: {
    auditoriaTab() {
      this.filtros.estatus = null
      if (!this.esTabEvaluacionPersonal && this.filtros.id_ciclo) {
        this.onCambioCicloControlInterno()
      }
    },

    departamentos() {
      if (this.dialogControlInterno) {
        this.sincronizarHallazgosDepartamentoControlInterno(this.editedControlInternoItem)
      }
    }
  },

  mounted() {
    this.initialize()
  }
}
</script>

<style scoped>
.text-sm {
  font-size: 0.875rem;
}

.shadowCard {
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.auditoria-dashboard {
  display: block;
  width: 100%;
  background: #ffffff;
  border: 1px solid #e9eef5;
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.04);
}

.auditoria-dashboard-header,
.auditoria-table-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.auditoria-table-header {
  justify-content: space-between;
  margin: 10px 0 6px;
  padding: 0 2px;
}

.auditoria-section-title {
  color: #263238;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.auditoria-chip {
  border: 1px solid rgba(25, 118, 210, 0.16);
  font-weight: 700;
}

.auditoria-tabs-wrap {
  display: flex;
  justify-content: flex-start;
  margin-top: 10px;
}

.auditoria-tabs {
  flex: 0 0 auto;
  width: auto;
  border: 1px solid #edf2f7;
  border-radius: 14px;
  padding: 4px;
  background: #ffffff !important;
  box-shadow: 0 3px 12px rgba(15, 23, 42, 0.05);
}

.auditoria-tabs ::v-deep .v-slide-group__content {
  gap: 6px;
}

.auditoria-tabs ::v-deep .v-tabs-slider-wrapper {
  display: none;
}

.auditoria-tab {
  flex: 0 0 auto !important;
  min-width: 40px !important;
  width: auto !important;
  max-width: 180px;
  min-height: 32px !important;
  padding: 0 14px !important;
  border: 1px solid;
  border-radius: 11px;
  font-size: 0.7rem;
  letter-spacing: 0.04em;
  opacity: 0.82;
  transition: all 0.18s ease;
}

.auditoria-tab:hover {
  opacity: 1;
  transform: translateY(-1px);
}

.auditoria-tab--evaluacion {
  background: #eef7ff !important;
  border-color: #d8ecff;
  color: #1565c0 !important;
}

.auditoria-tab--control {
  background: #fff8e8 !important;
  border-color: #ffe7b8;
  color: #ad6800 !important;
}

.auditoria-tab--evaluacion.auditoria-tab--active {
  background: #f8fcff !important;
  border-color: #90caf9;
  box-shadow: inset 0 0 0 1px rgba(33, 150, 243, 0.18);
}

.auditoria-tab--control.auditoria-tab--active {
  background: #fffdf7 !important;
  border-color: #ffd166;
  box-shadow: inset 0 0 0 1px rgba(255, 160, 0, 0.18);
}

.auditoria-tab--active {
  font-weight: 800;
  opacity: 1;
}

.auditoria-metrics {
  display: flex;
  align-items: flex-end;
  gap: 18px;
  min-height: 34px;
}

.reporte-dashboard-row {
  display: flex;
  margin-top: 4px !important;
}

.reporte-dept-card {
  min-height: 92px;
  border: 1px solid #e7edf5;
  border-radius: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.reporte-dept-card:hover {
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
  transform: translateY(-1px);
}

.reporte-metric {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}

.reporte-metric-val {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.2;
}

.auditoria-table {
  overflow: hidden;
  border: 1px solid #e8eef7;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 3px 14px rgba(15, 23, 42, 0.04);
}

.auditoria-table ::v-deep thead tr {
  background: #f6f9fd;
}

.auditoria-table ::v-deep th {
  color: #546e7a !important;
  font-size: 0.72rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.auditoria-table ::v-deep tbody tr {
  transition: background-color 0.15s ease;
}

.auditoria-table ::v-deep tbody tr:hover {
  background: #f8fbff !important;
}

.auditoria-table ::v-deep td {
  border-bottom: 1px solid #eef3f8 !important;
}

.control-interno-modal-card {
  overflow: hidden;
  border-radius: 18px;
  background: #f8fafc;
}

.control-interno-modal-header {
  border-bottom: 1px solid #e7edf5;
  background:
    radial-gradient(circle at top left, rgba(33, 150, 243, 0.14), transparent 35%),
    linear-gradient(135deg, #ffffff 0%, #f7fbff 100%);
  padding: 18px 24px;
}

.control-interno-modal-title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
}

.control-interno-modal-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border: 1px solid #dbeafe;
  border-radius: 14px;
  background: #eff6ff;
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.12);
}

.control-interno-modal-title {
  color: #0f172a;
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: -0.01em;
}

.control-interno-modal-subtitle {
  color: #64748b;
  font-size: 0.78rem;
  line-height: 1.35;
}

.control-interno-modal-id {
  padding: 6px 10px;
  border: 1px solid #dbeafe;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 0.8rem;
}

.control-interno-modal-body {
  background: #f8fafc;
  padding: 18px 24px 22px !important;
}

.control-interno-modal-dashboard {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.control-interno-modal-stat {
  min-height: 76px;
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.05);
}

.control-interno-modal-stat .stat-label {
  display: block;
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.control-interno-modal-stat .stat-value {
  display: block;
  margin-top: 8px;
  color: #0f172a;
  font-size: 1rem;
  font-weight: 800;
  line-height: 1.2;
}

.control-interno-modal-stat.stat-accent {
  border-color: #fed7aa;
  background: linear-gradient(135deg, #fff7ed 0%, #ffffff 100%);
}

.control-interno-modal-body ::v-deep .v-input__slot {
  border-radius: 12px !important;
  box-shadow: none !important;
}

.control-interno-modal-body ::v-deep .v-text-field--filled > .v-input__control > .v-input__slot,
.control-interno-modal-body ::v-deep .v-textarea > .v-input__control > .v-input__slot {
  border: 1px solid #e2e8f0;
  background: #ffffff !important;
}

.control-interno-modal-body ::v-deep .v-input--is-focused .v-input__slot {
  border-color: #93c5fd !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
}

.control-interno-modal-body label {
  color: #475569;
  font-weight: 700;
}

.control-interno-modal-actions {
  border-top: 1px solid #e7edf5;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 -10px 24px rgba(15, 23, 42, 0.08);
  padding: 12px 24px !important;
}

.control-interno-action-btn {
  min-width: 118px !important;
  border-radius: 10px !important;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
}

.control-interno-seccion-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 18px 0 10px;
  color: #0f172a;
  font-size: 0.95rem;
  font-weight: 800;
  letter-spacing: 0.01em;
}

.control-interno-seccion-title::before {
  content: '';
  width: 8px;
  height: 24px;
  border-radius: 999px;
  background: linear-gradient(180deg, #38bdf8 0%, #2563eb 100%);
}

.control-interno-check-table {
  overflow-x: auto;
  overflow-y: hidden;
  border: 1px solid #dbe4ef;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
}

.control-interno-check-table ::v-deep table {
  min-width: 760px;
  border-collapse: separate;
  border-spacing: 0;
}

.control-interno-check-table ::v-deep th,
.control-interno-check-table ::v-deep td {
  border-right: 1px solid #dbe4ef !important;
  border-bottom: 1px solid #dbe4ef !important;
  color: #1e293b;
  font-size: 0.82rem !important;
  vertical-align: middle;
}

.control-interno-check-table ::v-deep th:last-child,
.control-interno-check-table ::v-deep td:last-child {
  border-right: 0 !important;
}

.control-interno-check-table ::v-deep tbody tr:last-child td {
  border-bottom: 0 !important;
}

.control-interno-check-table ::v-deep th {
  background: linear-gradient(180deg, #f8fafc 0%, #eef4fb 100%);
  color: #475569;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.control-interno-check-table ::v-deep th:nth-child(2),
.control-interno-check-table ::v-deep th:nth-child(3) {
  width: 118px;
  font-size: 0.82rem !important;
}

.control-interno-check-table ::v-deep tbody tr {
  transition: background-color 0.15s ease;
}

.control-interno-check-table ::v-deep tbody tr:hover {
  background: #f8fbff;
}

.control-interno-check {
  display: inline-flex;
  margin-top: 0;
  padding-top: 0;
}

.control-interno-cantidad {
  max-width: 80px;
  margin: 0 auto;
}

/* iOS Safari no abre la cámara con .click() sobre inputs con display:none */
.control-interno-file-oculto {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
}

.control-interno-hallazgo-depto {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 8px;
}

.control-interno-oficina {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.control-interno-oficina-depto {
  max-width: 340px;
}

.control-interno-panels {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.control-interno-seccion-desc {
  background: #f5f7ff;
  border-left: 3px solid #c5cae9;
  border-radius: 4px;
  color: #455a64;
  font-size: 12px;
  line-height: 1.45;
  padding: 6px 10px;
  margin: 4px 0 10px;
}

.control-interno-fila-error td {
  background: #fdecea !important;
}

.control-interno-ticket-motivo {
  max-height: 96px;
  overflow-y: auto;
  white-space: pre-line;
  font-size: 12px;
  padding: 4px 0;
}

.control-interno-hallazgo-comentario {
  border-top: 1px dashed #e0e0e0;
  padding-top: 8px;
  margin-top: 8px;
}

.control-interno-evidencias {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 6px 0;
}

.control-interno-evidencia {
  position: relative;
  width: 84px;
  height: 84px;
  border: 1px solid #dbe4ef;
  border-radius: 10px;
  overflow: hidden;
  background: #f1f5f9;
}

.control-interno-evidencia a {
  display: block;
  width: 100%;
  height: 100%;
}

.control-interno-evidencia img,
.control-interno-evidencia video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.control-interno-evidencia-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.control-interno-evidencia-quitar {
  position: absolute !important;
  top: 2px;
  right: 2px;
  background: rgba(255, 255, 255, 0.9);
}

.control-interno-check ::v-deep .v-input--selection-controls__input {
  margin: 0;
}

.control-interno-check ::v-deep .v-icon {
  color: #64748b;
}

.control-interno-check ::v-deep .v-input--selection-controls__ripple {
  color: #2563eb;
}

.control-interno-nivel {
  display: grid;
  gap: 8px;
  padding: 14px;
  border: 1px solid #dbe4ef;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
}

.control-interno-nivel-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.control-interno-nivel-row strong {
  min-width: 210px;
  color: #334155;
}

.control-interno-nivel-check {
  margin: 0 !important;
  padding: 0 !important;
}

.control-interno-observaciones-table ::v-deep th:nth-child(2),
.control-interno-observaciones-table ::v-deep td:nth-child(2) {
  width: 240px;
}

.control-interno-check-table ::v-deep .v-text-field.v-text-field--solo .v-input__control {
  min-height: 34px;
}

.control-interno-check-table ::v-deep .v-text-field.v-text-field--solo .v-input__slot,
.control-interno-check-table ::v-deep .v-textarea.v-text-field--solo .v-input__slot {
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.control-interno-firmas {
  padding: 16px;
  border: 1px solid #dbe4ef;
  border-radius: 16px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
}

.control-interno-firma-preview {
  border: 1px dashed #c5d0de;
  border-radius: 8px;
  background: #fff;
  text-align: center;
}

.control-interno-firma-img {
  max-width: 100%;
  max-height: 90px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}

.control-interno-signature-pad {
  display: block;
  width: 100%;
  max-width: 780px;
  border: 1px solid #c5d0de;
  border-radius: 4px;
  background: #fff;
  touch-action: none;
}

@media (max-width: 960px) {
  .control-interno-modal-dashboard {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .control-interno-modal-header,
  .control-interno-modal-body,
  .control-interno-modal-actions {
    padding-left: 14px !important;
    padding-right: 14px !important;
  }

  .control-interno-modal-dashboard {
    grid-template-columns: 1fr;
  }
}

.resultado-card {
  background: #fafafa;
}

.resultado-porcentaje {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.25;
}

.criterio-row {
  border-bottom: 1px solid #eeeeee;
}

.criterio-row:last-child {
  border-bottom: 0;
}

.bg-light-grey {
  background-color: #f5f5f5 !important;
}

.phva-table tbody tr td.bg-light-grey {
  border-top: 2px solid #ddd;
  border-bottom: 2px solid #ddd;
}
</style>
